import { Component, OnInit, ViewChild, HostListener, ElementRef, NgZone } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { SignaturePad } from 'angular2-signaturepad';
import { CurrencyMaskModule } from "ng2-currency-mask";
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { Http } from '@angular/http';
import { DatePipe } from '@angular/common';
import { AngularFileUploaderComponent } from 'angular-file-uploader';

//Service 
import { ContactService } from '../../../services/contact.service';
import { CountryService } from '../../../services/country.service';
import { DocumentService } from '../../../services/document.service';
import { InventionService } from '../../../services/invention.service';
import { ProductService } from '../../../services/product.service';
import { StateService } from '../../../services/state.service';
import { UtilityService } from '../../../services/shared/utility.service';
import { WizardService } from '../../../services/wizard.service';
import { OfficeService } from '../../../services/office.service';
import { BillingService } from '../../../services/billing.service';
import { ContractSessionService } from '../../../services/contractsession.service';
import { InfoCollectService } from '../../../services/InfoCollect.service';
import { AddendumService } from '../../../services/addendum.service';
import { UserService } from '../../../services/user.service';
import { NavigationService } from '../../../services/navigation.service';
import { AppconfigService } from '../../../services/shared/appconfig.service';
import { ConfigMasterService } from '../../../services/configMaster.service';
import { MediaImagesService } from '../../../services/mediaimages.service';
import { SMSService } from '../../../services/sms.service';
import { EmailService } from '../../../services/email.service';
import { ChatService } from '../../../services/shared/chat.service';
import { TransferDataService } from '../../../services/shared/transferData.service';


//Models
import { User, UserResponse } from '../../../models/user.model';
import { ContactResponse, ContactDetails } from '../../../models/contact.model';
import { InventionResponse, InventionDetails } from '../../../models/invention.model';
import { WizardResponse, WizardReadyResponse, WizardDetails } from '../../../models/wizard.model';
import { Country } from '../../../models/country.model';
import { State } from '../../../models/state.model';
import { DocumentContainer, DocumentList, DocumentResponse, ConfigDocuments, ConfigDocumentsResponse, DocumentBinaryPDF, DocumentResponseList, DocType } from '../../../models/document.model';
import { SMSDetails, SMSResponse } from '../../../models/sms.model';
import { EmailDetails, EmailResponse } from '../../../models/email.model';
import { SimpleResponse } from '../../../models/genericResponse.model';
import { ProductListResponse, ProductDetails, ProductResponse } from '../../../models/product.model';
import { OfficeList, OfficeListResponse } from '../../../models/officelist.model';
import { RepaymentTerms, RepaymentTermsResponse } from '../../../models/billing.model';
import { PromotionOffers, PromotionOffersResponse } from '../../../models/promotionOffers.model';
import { ContractSession, ContractSessionResponse, ContractSessionListResponse } from '../../../models/contractsession.model';
import { Addendum, AddendumServicesResponse } from '../../../models/addendum.model';
import { ContractMultiPayment, ContractMultiPaymentResponse, ContractPayment, ContractPaymentResponse } from '../../../models/contractPayment.model';
import { BGInformInvention, BGInformInventionResponse } from '../../../models/bgInformInvention.model';
import { InventorInformation, InventorInformationResponse } from '../../../models/inventorInformation.model';
import { UniversalPayment, UniversalPaymentResponse } from '../../../models/universalPayment.model';
import { DocumentSignature, DocumentSignatureResponse } from '../../../models/documentSignature.model';
import { Navigation, NavigationResponse, NavigationSteps, NavigationStepsResponse } from '../../../models/navigation.model';
import { ConfigDetails } from '../../../models/appConfig.model';
import { BillingDetails, BillingResponse } from '../../../models/billing.model';
import { ConfigMaster, ConfigMasterResponse } from '../../../models/configMaster.model';
import { mediaImages, MediaDocImagesResponse, MediaImagesResponse, ROIRefreshFlagResponse } from '../../../models/mediaImages.model';
import { checkList, configCheckList, CheckListImagesResponse, ConfigCheckListImagesResponse } from '../../../models/checkList.model';
import { mediaDoc } from '../../../models/mediaImages.model';
import { Message, ActiveConnection } from '../../../models/message';
import { ContratActionLogService } from '../../../services/contratActionLog.service';
import { ContractActionLog } from '../../../models/contractActionLog.model';
import { InventionCheckList, InventionCheckListResponse } from '../../../models/inventionCheckList.model';
import { InventionCheckListService } from '../../../services/inventionCheckList.service';
import { isNullOrUndefined } from '@swimlane/ngx-datatable/release/utils';
import { paymentDocList, PaymentDocMediaImagesResponse } from '../../../models/PaymentDocImage.model';
import { isNumber } from 'util';
import { IpService } from '../../../services/ip.service';



//For jquery
declare var $: any;


@Component({
    selector: 'app-client-remote',
    templateUrl: './client-remote.component.html',
    styleUrls: ['./client-remote.component.css']
})
/** client-remote component*/
export class ClientRemoteComponent implements OnInit {
    signDocsGroup: FormGroup;
    docSign: string = "Waiting for InventHelp...";
    documents: DocType[];
    chkSOC: boolean = false;
    documentTypeId: number = -999;
    documentTypeIds: string = '';
    currencySterling: string = "";
    clpUserId: number;
    inventionId: number;
    contractSessionId: number;
    contactId: number;
    docHeaderName: string = "";
    docHeader: string = "";
    isClientConnect: boolean = false;
    isShowWelcome: boolean = false;
    isCustAction: boolean = false;
    isFormAction: boolean = false;
    actionDesc: string = "";
    isSignedSOC: boolean = false;
    base64Str: string = "";
    base64StrADS: string = "";
    base64StrCoInv: string = "";
    base64StrCoInvADS: string = "";
    base64StrFinal: string = "";
    base64StrFinalCoInv: string = "";
    person: string = "";
    i2person: string = "";
    isCoInventor: boolean = false;
    signature1: string = '';
    i1SignatureADS: string = '';
    i1SignatureFinal: string = '';
    verifySignStatus: boolean = true;
    reverifySignStatus: boolean = true;
    mandateDocBtn: string = "Accept & Sign";
    documentID: any;
    chkSign: boolean = false;
    navigationDivId: string = '';
    productId: number = 1;
    issetCardRender: boolean = false;
    isSecondContract: boolean = false;
    isSecondSign: boolean = false;
    waitDays: number = 0;
    isWaitPrdForPayment: boolean = false;
    userStateName: string = "";
    dtSOC: string = "";
    businessDays: string = "";
    IsSubmitCharge: boolean = false;
    isSubmitCharge: boolean = false;
    cardErrorMsg: string = "";
    oneTimeFee: number = 0;
    isPaymentProcessing: boolean = false;
    isCardPaymentStarted: boolean = false;
    cardToken: string = "";
    stripePrivateKey: string = "";
    inventionName: string = "";
    fileNumber: string = "";
    formSubId: string = "";
    collectPaymentGroup: FormGroup;
    isWaitingPeriod: boolean = false;
    cardTxnReference: string = "";
    cardTxnNotes: string = "";
    isPaymentError: boolean = false;
    isPaymentDone: boolean = false;
    isCardAuthorized: boolean = false;
    chkConnectionStatus: boolean = false;
    chkDisconnectedStatus: boolean = false;
    chkMessage: boolean = false;
    paymentDocConfig: any;
    currentMultiPayId: number = 0;
    countryID: number = 1;
    paymentAuthTitle: string = "";
    isFinalSignWait: boolean = false;
    private mediaImagesResponse: MediaImagesResponse;
    private ROIFlagResponse: ROIRefreshFlagResponse;
    private mediaDocImagesResponse: MediaDocImagesResponse;
    private paymentDocMediaImagesResponse: PaymentDocMediaImagesResponse;
    paymentDoc: paymentDocList[];
    paymentDocCheque: paymentDocList[];
    paymentOther: paymentDocList[];
    private checkListImagesResponse: CheckListImagesResponse;
    private configCheckListImagesResponse: ConfigCheckListImagesResponse;
    private encryptedUser: string = '';
    private billingDetails: BillingDetails;
    private contractPaymentResponse: ContractPaymentResponse;
    private contractSession: ContractSession;
    private addendum: Addendum;
    private addendumServicesResponse: AddendumServicesResponse;
    private contractSessionListResponse: ContractSessionListResponse;
    private contractSessionResponse: ContractSessionResponse;
    private configDocumentsResponse: ConfigDocumentsResponse;
    private configDocuments: ConfigDocuments;
    private documentResponse: DocumentResponse;
    private documentListResponse: DocumentResponseList;
    private documentList: DocumentList;
    private documentBinaryPDF: DocumentBinaryPDF;
    private documentContainer: DocumentContainer;
    private documentContainerADS: DocumentContainer;
    private documentSignature: DocumentSignature;
    private documentSignatureResponse: DocumentSignatureResponse;
    private emailDetails: EmailDetails;
    private emailResponse: EmailResponse;
    private inventionResponse: InventionResponse;
    private inventionDetails: InventionDetails;
    private inventorInformation: InventorInformation;
    private inventorInformationResponse: InventorInformationResponse;
    private billingResponse: BillingResponse;
    private configMaster: ConfigMaster[];
    private configMasterResponse: ConfigMasterResponse;
    private contactResponse: ContactResponse;
    private contactCoInventResponse: ContactResponse;
    private contactDetails: ContactDetails;
    private contactCoInventDetails: ContactDetails;
    private contractPayment: ContractPayment;
    contractActionlog: ContractActionLog;
    private mediaImages: mediaImages;
    mediaImagesList: mediaImages[];
    private mediaDoc: mediaDoc;
    private activeConnection: ActiveConnection;
    activeConnectionList: ActiveConnection[] = [];
    mediaDocList: mediaDoc[];
    currentUser: User;
    checkList: checkList[];
    configCheckListArr: any[] = [];
    private navigation: Navigation;
    private navigationResponse: NavigationResponse;
    private navigationSteps: NavigationSteps[];
    private navigationStepsResponse: NavigationStepsResponse;
    officeList: OfficeList[];
    private officeListResponse: OfficeListResponse;
    private productListResponse: ProductListResponse;
    productDetails: ProductDetails[];
    private productDetail: ProductDetails;
    private productResponse: ProductResponse;
    private promotionOffersResponse: PromotionOffersResponse;
    promotionOffers: PromotionOffers[];
    private repaymentTermsResponse: RepaymentTermsResponse;
    repaymentTerms: RepaymentTerms[];
    private simpleResponse: SimpleResponse;
    private smsDetails: SMSDetails;
    private smsResponse: SMSResponse;
    private universalPayment: UniversalPayment;
    private universalPaymentResponse: UniversalPaymentResponse;
    private wizardResponse: WizardResponse;
    private wizardReadyResponse: WizardReadyResponse;
    private wizardDetails: WizardDetails;
    private globalResponse: any;
    private globalpaymentResponse: any;
    private globalCheckListResponse: any;
    private globalConfigCheckListResponse: any;
    private bgInformInvention: BGInformInvention;
    private bgInformInventionResponse: BGInformInventionResponse;
    private user: User;
    private configDetails: ConfigDetails;
    private inventionCheckList: InventionCheckList;
    private inventionCheckListResponse: InventionCheckListResponse;
    private userResponse: UserResponse;
    private contractMultiPaymentResponse: ContractMultiPaymentResponse;
    private contractMultiPayment: ContractMultiPayment;
    private contractMultiPayments: ContractMultiPayment[];

    @ViewChild('sigpad1', { static: true }) signaturePad: SignaturePad;
    @ViewChild('sigpad2', { static: true }) signaturePadCoInv: SignaturePad;
    @ViewChild('sigpadFinal', { static: true }) signaturePadFinal: SignaturePad;
    @ViewChild('sigpadFinalCoInv', { static: true }) signaturePadFinalCoInv: SignaturePad;
    @ViewChild('groupAdjust') groupAdjust;
    @ViewChild('paymentUploader') paymentUploader: AngularFileUploaderComponent;
    title = 'ClientApp';
    txtMessage: string = '';
    uniqueID: string = new Date().getTime().toString();
    messages = new Array<Message>();
    message: Message;
    connectionId: string = "";
    finalConnectionId: string = "";
    clientDivId: string = "";
    clientDocTypeId: number;
    salesRepAction: string = "";
    formDivActive: number = 0;
    checkListStatus: boolean = true;
    signatureStatus: boolean = true;
    _i1SSN: string = "";
    _unmaskI1SSN: string = "";
    _i2SSN: string = "";
    showSSnDiv: boolean = true;
    isSSNMask: boolean = true;
    divPaySaveAc: boolean = true;
    divPayCard: boolean = false;
    upcExpiryStatus: boolean = false;
    divNoAutoPay: boolean = false;
    hideOptionalDoc: boolean = false;
    maxDate = new Date();
    expDate: string = "";
    cCardExpDTfield: string = "";
    expiry: boolean = false;
    flgInstallment: boolean = true;
    isCalcPayment: boolean = false;
    signedDocId: string = '';
    isFinalSign: boolean = false;
    verifyFinalDoc: string = "";
    _docTypeId: number = -999;
    disabledAgreement: boolean = true;
    paymentDocshowUploadFlg: boolean = false;

    productName: string;
    officeId: number;
    email: string = "";
    submitted: boolean = false;
    site: string = "";
    useType: number = 0;
    stripePublicKey: string = "";
    stripePublicKeyValue: string = "";
    configKeyValue: string = "";
    imgSource: string = "";
    cardType: string = "";
    cardNumber: string = "";
    imgVisible: boolean = false;
    txnType: number = 0;
    chkAmount: boolean = false;
    chkFileNumber: boolean = false;
    show: boolean = false;
    checkListTabItem: string = "";
    subscription: Subscription;
    isProductV: boolean = false;
    documentVCutOffDate: any;

    initialDisabled: boolean = false;
    initialCoInvDisabled: boolean = false;
    initialFinalDisabled: boolean = false;
    initialFinalCoInvDisabled: boolean = false;
    initialConnStatus: number = -1;
    _activeConnection: ActiveConnection = {
        connectionId: "",
        chkSelected: false
    }
    docSignAddmB: string = "The document is loading. Please wait...";
    docSignAddmG: string = "The document is loading. Please wait...";
    docSignAddmP: string = "The document is loading. Please wait...";
    docSignAddmT: string = "The document is loading. Please wait...";
    docSignAddmV: string = "The document is loading. Please wait...";
    docSignIntroMark: string = "The document is loading. Please wait...";
    docSignPatent: string = "The document is loading. Please wait...";
    isAddmBAccept: boolean = false;
    isAddmGAccept: boolean = false;
    isAddmPAccept: boolean = false;
    isAddmTAccept: boolean = false;
    isAddmVAccept: boolean = false;
    isPatentAccept: boolean = false;
    isIntroMarkAccept: boolean;
    isSUBAccept: boolean;
    isShowPatent: boolean;
    isNewCanadianContract: boolean = false;


    openSnackBar(message: string, action: string) {
        this._snackBar.open(message, action, {
            verticalPosition: 'top',
            horizontalPosition: 'right',
            duration: 5000,
        });
    }

    horizontalPosition: MatSnackBarHorizontalPosition = 'right';
    verticalPosition: MatSnackBarVerticalPosition = 'top';

    sel_brand: string = "unknown";
    sel_brandUPC: string = "unknown";
    finaldocument: string = "";
    isNoAutoPay: boolean = true;
    isExistSoc: boolean = false;
    isExistADS: boolean = false;
    isExistFinal: boolean = false;
    isExistSocinv: boolean = false;
    isExistADSinv: boolean = false;
    isExistFinalinv: boolean = false;
    titleMsg: string = '';
    titleMsgInv: string = '';
    isBankAccountNameBlank: boolean = false;
    isRoutingNumberBlank: boolean = false;
    isAccountNumberBlank: boolean = false;
    ipAddress: string = '';

    /** client-remote ctor */
    constructor(private fb: FormBuilder,
        private fbProduct: FormBuilder,
        private _utilityService: UtilityService,
        private _router: Router,
        private _route: ActivatedRoute,
        private _contactService: ContactService,
        private _configMasterService: ConfigMasterService,
        private chatService: ChatService,
        private _inventionService: InventionService,
        private _wizardService: WizardService,
        private _stateService: StateService,
        private _appconfigService: AppconfigService,
        private _countryService: CountryService,
        private _documentService: DocumentService,
        private _productService: ProductService,
        private _officeService: OfficeService,
        private _billingService: BillingService,
        private _contractSessionService: ContractSessionService,
        private _snackBar: MatSnackBar,
        private _infoCollectService: InfoCollectService,
        private _addendumService: AddendumService,
        private _userService: UserService,
        private _navigationService: NavigationService,
        private _mediaImagesService: MediaImagesService,
        private _smsService: SMSService,
        private _emailService: EmailService,
        private _contractActionLogService: ContratActionLogService,
        private _transferDataService: TransferDataService,
        private _inventionCheckListService: InventionCheckListService,
        private _ngZone: NgZone,
        private ipService: IpService) {
        this._route.queryParamMap.subscribe(params => {

            if (params.has('r')) {
                this.encryptedUser = params.get('r');
                this._userService.getAuthenticateR(this.encryptedUser)
                    .then(res => {
                        if (res) {
                            if (res.isvalid) {
                                this.userResponse = UtilityService.clone(res);
                                this.clpUserId = this.userResponse.user.clpUserId;
                                console.log("Valid User");
                            } else {
                                this._router.navigate(['/unauthorized']);
                            }
                        } else {
                            this._router.navigate(['/unauthorized']);
                        }
                    })
                    .catch((err: HttpErrorResponse) => {
                        console.log("Client side Error : " + err);
                        this._utilityService.handleErrorResponse(err);
                    });
            }
            else {
                console.log('no r');
                this._router.navigate(['/unauthorized']);
            }
        });

        this.loadMessage();
        this.subscribeToEvents();
    }

    get prodForm() {
        return this.signDocsGroup.controls;
    }

    get collectPaymentForm() {
        return this.collectPaymentGroup.controls;
    }

    ngOnInit() {
        this.activeConnection = this._activeConnection;
        this.activeConnectionList = [];
        this.getInventHelpSite();
        this.signDocsGroup = this.fb.group({
            i1DOB: [{ value: '' }],
            i1SSN: [{ value: '' }, Validators.minLength(9)],
            i1SSNMask: [{ value: '' }, Validators.minLength(9)],

            chkNoAutoPay: [{ value: true }],
            chkSaveAc: [{ value: true }],
            bankName: ['', [Validators.pattern(/^[_A-z0-9 ]*((-|\s)*[_A-z0-9])*$/)]],
            ABANo: [{ value: '' }, Validators.minLength(9)],
            chkAcNo: [{ value: '' }],
            accountType: ['-1'],
            chkCCard: [{ value: false }],
            cCardNo: [{ value: '' }, Validators.minLength(14)],
            cCardExpDT: ['', [Validators.pattern(/^0[1-9]|^(10)|^(11)|^(12)[0-9][0-9]*$/)]],
            cCardCVV: [{ value: '' }],
            altDayMonth: [{ value: 0 }, Validators.max(31)],
            altAmount: [{ value: '' }, [Validators.max(99999)]],

            downPayment: [{ value: 0, disabled: true }, [Validators.required, Validators.max(99999)]],

            cardName: [{ value: '' }],

            isSubmitYes: [{ value: false }],
            isSubmitNo: [{ value: false }],

            isAcceptYes: [{ value: false }],
            isAcceptNo: [{ value: false }],

            isDataBankYes: [{ value: false }],
            isDataBankNo: [{ value: false }],

            isSolicitsYes: [{ value: false }],
            isSolicitsNo: [{ value: false }],

            isIdeasYes: [{ value: false }],
            isIdeasNo: [{ value: false }],

            isPrepareYes: [{ value: false }],
            isPrepareNo: [{ value: false }],

            isStaffYes: [{ value: false }],
            isStaffNo: [{ value: false }],

            isBIPSYes: [{ value: false }],
            isBIPSNo: [{ value: false }],

            isPRSYes: [{ value: false }],
            isPRSNo: [{ value: false }],

            isSoldYes: [{ value: false }],
            isSoldNo: [{ value: false }],

            isSendYes: [{ value: false }],
            isSendNo: [{ value: false }],

            isShowsYes: [{ value: false }],
            isShowsNo: [{ value: false }],

            isWorkBrochureYes: [{ value: false }],
            isWorkBrochureNo: [{ value: false }],

            isBIPYes: [{ value: false }],
            isBIPNo: [{ value: false }],

            isBIPReportYes: [{ value: false }],
            isBIPReportNo: [{ value: false }],

            isNABIPReport: [{ value: false }],

            isServiceFeesYes: [{ value: false }],
            isServiceFeesNo: [{ value: false }],

            isADSYes: [{ value: false }],
            isADSNo: [{ value: false }],

            isNDAYes: [{ value: false }],
            isNDANo: [{ value: false }],

            isPRSBrochureYes: [{ value: false }],
            isPRSBrochureNo: [{ value: false }],

            isPPSOYes: [{ value: false }],
            isPPSONo: [{ value: false }],

            isNAPPSO: [{ value: false }],
            comments: [{ value: '' }],
            bestTimeToReach: [{ value: '' }],

            isSolicitYes: [{ value: false }],
            isSolicitNo: [{ value: false }],

            isRefineYes: [{ value: false }],
            isRefineNo: [{ value: false }],

            isIndependentYes: [{ value: false }],
            isIndependentNo: [{ value: false }],

            isAttorneyYes: [{ value: false }],
            isAttorneyNo: [{ value: false }],

            isPurchasedYes: [{ value: false }],
            isPurchasedNo: [{ value: false }],

            initialSignature: [{ value: '' }],
            initialCoInvSignature: [{ value: '' }],
            initialFinalSignature: [{ value: '' }],
            initialFinalCoInvSignature: [{ value: '' }],

        });

        this.collectPaymentGroup = this.fb.group({
            firstName: [{ value: '' }, [Validators.required, Validators.pattern(/^([a-zA-Z0-9.,-/&\s]{0,100})$/)]],
            lastName: [{ value: '' }, [Validators.required, Validators.pattern(/^([a-zA-Z0-9.,-/&\s]{0,100})$/)]],
            creditCard: [{ value: '' }, [Validators.required, Validators.minLength(14)]],
            expirationDate: ['', [Validators.required, Validators.pattern(/^0[1-9]|^(10)|^(11)|^(12)[0-9][0-9]*$/)]],
            cvc: [{ value: '' }, [Validators.required, Validators.minLength(3), Validators.pattern(/^[0-9\s]{3,4}$/)]],
            zip: [{ value: '' }, [Validators.minLength(5), Validators.pattern(/^[a-zA-Z0-9\s]{5,10}$/)]],
            paymentType: [{ value: false }],
            fileNo: [{ value: false }],
            chkBankName: [{ value: '' }, [Validators.pattern(/^([a-zA-Z0-9.,-/&\s]{0,25})$/)]],
            chkCity: [{ value: '' }, [Validators.pattern(/^([a-zA-Z0-9.,-/&\s]{0,25})$/)]],
            chkState: [{ value: '' }, [Validators.pattern(/^([a-zA-Z0-9.,-/&\s]{0,25})$/)]],
            chkRoutingNo: [{ value: '' }],
            chkAccNo: [{ value: '' }],
            chkNumber: [{ value: '' }],
            bankAccountName: [{ value: '' }]
        });

        this._route.paramMap.subscribe(async params => {
            if (params.has('invention')) {
                this.inventionId = +params.get('invention');
            }
            if (params.has('contractSessionId')) {
                this.contractSessionId = +params.get('contractSessionId');
            }
        });

        this.signDocsGroup.patchValue({

            i1DOB: '',
            i1SSN: '',
            i1SSNMask: '',

            chkSaveAc: true,
            bankName: '',
            ABANo: '',
            chkAcNo: '',
            accountType: '-1',
            chkCCard: false,
            cCardNo: '',
            cCardExpDT: '',
            cCardCVV: '',
            altDayMonth: '',
            altAmount: '',
            cardName: '',
            chkNoAutoPay: false,
            initialSignature: '',
            initialCoInvSignature: '',
            initialFinalSignature: '',
            initialFinalCoInvSignature: ''
        });

        this.collectPaymentGroup.patchValue({
            firstName: '',
            lastName: '',
            creditCard: '',
            expirationDate: '',
            cvc: '',
            zip: '',
            paymentType: false,
            fileNo: false,
            chkBankName: '',
            chkCity: '',
            chkState: '',
            chkRoutingNo: '',
            chkAccNo: '',
            chkNumber: '',
            bankAccountName: ''
        })

        this.paymentDocConfig = {
            theme: 'dragNDrop',
            hideResetBtn: false,
            hideSelectBtn: false,
            maxSize: 10,
            uploadAPI: {
                url: this.site + 'api/MediaImages/PaymentDocPost/' + this.inventionId + '/' + this.contractSessionId + '/' + this.currentMultiPayId + '/' + 0,

                headers: {
                },
            },
            formatsAllowed: '.jpg,.png,.pdf,.docx, .txt,.gif,.jpeg,.xlsx,.pptx,.bmp,.tiff',
            multiple: true,
            replaceTexts: {
                selectFileBtn: 'Select Image',
                resetBtn: 'Reset',
                uploadBtn: 'Upload Image',
                dragNDropBox: 'Drag and Drop your image here',
                attachPinBtn: 'Attach Files...',
                afterUploadMsg_success: 'Successfully Uploaded!',
                afterUploadMsg_error: 'Upload Failed!',
            }
        };

        this.loadClientRemote();
        resizeCanvas();
        this.loadInventorInformation();
        this.loadUniversalPayment();
        this.setCCKeys("InventHelp_CS_Site");
        this.loadInventionCheckList();
        this.isFinalSign = false;
        this.refreshConnectionId();
        this.loadContractSession();
        this.loadContractMultiPayment();
        this.loadNavigationWizard();
        this.loadDocumentSignature();
        this.getIP();
    }

    getIP() {
        this.ipService.getIPAddress().subscribe((res: any) => {
            this.ipAddress = res.ip;
            console.log('this.ipAddress', this.ipAddress);
        });
    }

    async getInventHelpSite() {
        await this._appconfigService.getAppConfigValues(this.encryptedUser, ["DocumentVCutOffDate"])
            .then(async (result: any) => {
                if (result) {
                    var resultvalue = UtilityService.clone(result);
                    if (resultvalue) {
                        this.documentVCutOffDate = resultvalue.filter(i => i.configKey == "DocumentVCutOffDate")[0];

                    } else {
                        console.log("Config Details Client-remote error - documentVCutOffDate");
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    @HostListener('window:beforeunload', ['$event'])
    public browserClosed(event: any): void {
        this.message.connectionStatus = 0;
        this.message.isCustAction = true;
        this.message.type = "sent";
        this.message.clientuniqueid = this.uniqueID;
        this.message.isClient = true;
        this.message.isSalesRep = false;
        this.message.actionDesc = "";
        this.chatService.sendMessage(this.message);
    }

    identifyClientConnection() {
        this.sendMessage();
    }

    ngAfterViewInit() {
    }

    chkSubscribeMessageRcvd() {
        setTimeout(() => {
            if (!this.chkConnectionStatus) {
                if (this.message.connectionStatus != 0) {
                    this.sendMessage();
                    this.subscribeToEvents();
                }
                this.chkSubscribeMessageRcvd();
            }
        }, 3000);
    }

    startConnection() {
        this.sendMessage();
    }

    private async loadMessage() {
        await this._navigationService.getSignalRMessageAsync(this.encryptedUser)
            .then(res => {
                if (res) {
                    this.message = UtilityService.clone(res);
                    this.message.connectionStatus = 1;
                    this.sendMessage();
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    paymentdocUpload(payType: number) {
        this.fetchPaymentDocList(this.contractSessionId, this.currentMultiPayId, payType);
        this.sendMessage();
    }

    get disableContinue(): boolean {
        if (this.isCoInventor) {
            if (this.isFinalSign) {
                if (this.isCoInventor && (!this.initialFinalDisabled && !this.initialFinalCoInvDisabled)
                    && (this.signDocsGroup.controls.initialFinalSignature.value.length == 0 || this.signDocsGroup.controls.initialFinalCoInvSignature.value.length == 0))
                    return true;
                else if (this.isCoInventor && this.initialFinalDisabled && this.signaturePadFinalCoInv.isEmpty() && this.signDocsGroup.controls.initialFinalCoInvSignature.value.length == 0)
                    return true;
                else if (this.isCoInventor && this.initialFinalCoInvDisabled && this.signaturePadFinal.isEmpty() && this.signDocsGroup.controls.initialFinalSignature.value.length == 0)
                    return true;
                else if (this.isCoInventor && (this.initialFinalDisabled && this.initialFinalCoInvDisabled)
                    && (this.signaturePadFinal.isEmpty() || this.signaturePadFinalCoInv.isEmpty()))
                    return true;
                else if (this.navigationDivId == 'tdIsCheckListDoc') {
                    this.checkListStatus = this.checkListValid();
                    if (!isNullOrUndefined(this.navigationResponse) && !this.navigationResponse.navigation.isCheckListForm)
                        return true;
                    else if (!this.checkListStatus)
                        return true;
                }
                else
                    return false;
            }
            else {
                if (this.isCoInventor && (!this.initialDisabled && !this.initialCoInvDisabled) && (this.navigationDivId == "tdIsSOCDoc" || this.navigationDivId == "tdIsADSDoc")
                    && (this.signDocsGroup.controls.initialSignature.value.length == 0 || this.signDocsGroup.controls.initialCoInvSignature.value.length == 0))
                    return true;
                else if (this.isCoInventor && this.initialDisabled && this.signaturePadCoInv.isEmpty() && this.signDocsGroup.controls.initialCoInvSignature.value.length == 0
                    && (this.navigationDivId == "tdIsSOCDoc" || this.navigationDivId == "tdIsADSDoc"))
                    return true;
                else if (this.isCoInventor && this.initialCoInvDisabled && (this.signaturePad.isEmpty() && this.documentSignature.signature1 === '') && this.signDocsGroup.controls.initialSignature.value.length == 0
                    && (this.navigationDivId == "tdIsSOCDoc" || this.navigationDivId == "tdIsADSDoc"))
                    return true;
                else if (this.isCoInventor && (this.initialDisabled && this.initialCoInvDisabled) && (this.navigationDivId == "tdIsSOCDoc" || this.navigationDivId == "tdIsADSDoc")
                    && ((this.signaturePad.isEmpty() && this.documentSignature.signature1 === '') || this.signaturePadCoInv.isEmpty()))
                    return true;
                else
                    return false;
            }
        }
        else if (this.navigationDivId == 'tdIsCheckListDoc') {
            this.checkListStatus = this.checkListValid();
            if (!isNullOrUndefined(this.navigationResponse) && !this.navigationResponse.navigation.isCheckListForm)
                return true;
            else if (!this.checkListStatus)
                return true;
        }
        else
            return false;
    }

    get hideAccept(): boolean {
        if (this.documentID == 2)
            return true;
        else if ((this.documentID == -1 || this.documentID == 142 || this.navigationDivId == 'tdIsSUBDoc') && this.isSUBAccept)
            return true;
        else if (this.isSecondContract) {
            if ((this.navigationDivId == 'tdIsSOCDoc') || (this.navigationDivId == 'tdIsADSDoc'))
                return true;
            else if (this.finaldocument != 'ND' && this.navigationDivId == 'tdIsNDADoc')
                return true;
        }
        else
            return false;
    }

    private async setCCKeys(configKey: string) {
        await this._appconfigService.getAppConfigValue(this.encryptedUser, configKey)
            .then(async (result: ConfigDetails) => {
                if (result) {
                    this.configDetails = UtilityService.clone(result);
                    if (this.configDetails) {
                        this.configKeyValue = this.configDetails.configValue;
                        if (this.configKeyValue != "") {
                            if (this.site.startsWith("https://evolve_cs")) {
                                if (this.useType == 99) {
                                    this.stripePublicKey = "Evolve_CC_PK_TestKey";
                                    this.stripePrivateKey = "Evolve_CC_SK_TestKey";
                                }
                                else {
                                    this.stripePublicKey = "Evolve_CC_PK_LiveKey";
                                    this.stripePrivateKey = "Evolve_CC_SK_LiveKey";
                                }
                            } else {
                                this.stripePublicKey = "SalesOptima_CC_PK_TestKey";
                                this.stripePrivateKey = "SalesOptima_CC_SK_TestKey";
                            }
                        }
                        await this._appconfigService.getAppConfigValue(this.encryptedUser, this.stripePublicKey)
                            .then(async (result: ConfigDetails) => {
                                if (result) {
                                    this.configDetails = UtilityService.clone(result);
                                    if (this.configDetails) {
                                        this.stripePublicKeyValue = this.configDetails.configValue;
                                    } else {
                                        console.log("Config Details error " + this.stripePublicKey);
                                    }
                                }
                            })
                            .catch((err: HttpErrorResponse) => {
                                this._utilityService.handleErrorResponse(err);
                            });
                    } else {
                        console.log("Config Details error " + configKey);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async loadClientRemote() {
        this._route.paramMap.subscribe(async params => {
            if (params.has('contact')) {
                this.contactId = +params.get('contact');
                if (params.has('invention')) {
                    if (!this.inventionId)
                        this.inventionId = +params.get('invention');
                    if (params.has('contractSessionId')) {
                        this.contractSessionId = +params.get('contractSessionId');
                        this.loadContractActionlog(this.contractSessionId);
                        this.fetchPaymentDocList(this.contractSessionId, -1, 0);
                        await this._contactService.getContactAsync(this.encryptedUser, this.contactId)
                            .then(async (result: ContactResponse) => {
                                if (result) {
                                    if (result.statusCode == 0) {
                                        this.contactResponse = UtilityService.clone(result);
                                        if (this.contactResponse) {
                                            this.contactDetails = UtilityService.clone(this.contactResponse.contactDetails);
                                            this.currentUser = UtilityService.clone(this.contactResponse.currentUser);
                                            this.person = this.contactDetails.firstname + ' ' + this.contactDetails.lastname;
                                            if (this.clpUserId == 0)
                                                this.clpUserId = this.contactDetails.clpuserid;
                                            this.email = this.contactDetails.email;
                                            this.collectPaymentGroup.patchValue({
                                                firstName: this.contactDetails.firstname,
                                                lastName: this.contactDetails.lastname,
                                            })
                                        }
                                    }
                                }
                                else {
                                    console.log("contact result status code: " + result.statusCode);
                                }
                            })
                            .catch((err: HttpErrorResponse) => {
                                this._utilityService.handleErrorResponse(err);
                            });
                    }
                    else
                        console.log("no contractSession");
                }
                else
                    console.log("no invention");
            }
            else
                console.log("no contact");
        });
    }

    changeMandateDocBtn(docId) {
        switch (docId) {
            case 1: case 3: this.mandateDocBtn = "Accept & Sign"; if ((this.isSecondContract) && (this.navigationDivId == "tdIsSOCDoc" || this.navigationDivId == "tdIsADSDoc")) this.isSecondSign = true; break;
            default: this.mandateDocBtn = "Accept"; this.isSecondSign = false; break;
        }
    }


    refreshConnection() {
        setTimeout(() => {
            if (this._transferDataService.isNavAction) {
                this.message.connectionStatus = this._transferDataService.connectionStatus;
                this.message.billingDetails.fileNumber = this._transferDataService.fileNumber;
            }
            this.refreshConnection();
        }, 500);
    }

    sendMessage(): void {
        var infoDOB = $("#i1DOB").val();
        this.txtMessage = 'sent';
        var altAmount = this.signDocsGroup.controls.altAmount.value;
        if (typeof altAmount != 'string') {
            this.convertNumberToCurrency(altAmount, 'altAmount');
        }
        if (this.txtMessage && this.message) {
            this.message.clientuniqueid = this.uniqueID;
            this.message.type = "sent";
            this.message.isClient = true;
            this.message.isSalesRep = false;
            this.message.message = this.txtMessage;
            this.message.date = new Date();
            this.message.clpUserId = this.clpUserId;
            this.message.inventId = this.inventionId;
            this.message.docTypeId = this.documentTypeId;
            this.message.contractSessionId = this.contractSessionId;
            this.message.contactId = this.contactId;

            if (this.message.connectionStatus == 0) {
                this.message.divId = "Blank";
                this.message.isCustAction = false;
                this.message.navigationDivId = "";
            }

            if (this.message.connectionStatus == -1) {
                this._transferDataService.connectionStatus = 1;
                this.message.connectionStatus = 1;
                this._transferDataService.message.connectionStatus = 1;
            }
            this.message.isCustAction = this.isCustAction;
            this.message.isFormAction = this.isFormAction;
            this.message.isSalesRepAction = false;
            this.message.actionDesc = this.actionDesc;
            this.message.navigationDivId = this.navigationDivId;
            this.message.isPaymentDone = this.isPaymentDone;
            this.message.isPaymentError = this.isPaymentError;
            this.message.isPaymentProcessing = this.isPaymentProcessing;
            this.message.cardTxnReference = this.cardTxnReference;
            this.message.cardTxnNotes = this.cardTxnNotes;
            this.message.cardType = this.sel_brand ? this.sel_brand : "unknown";
            this.message.upcCardType = this.sel_brandUPC ? this.sel_brandUPC : "unknown";
            this.message.isCardExpire = this.expiry ? this.expiry : false;

            //For Info
            if (this.message.inventorInformation) {
                if (this.showSSnDiv && this.signDocsGroup.controls.i1SSN)
                    this.message.inventorInformation.i1SSN = this.signDocsGroup.controls.i1SSN.value;
                else if (!this.showSSnDiv && this.signDocsGroup.controls.i1SSNMask)
                    this.message.inventorInformation.i1SSN = this.signDocsGroup.controls.i1SSNMask.value;
                this.message.i1SSN = this.signDocsGroup.controls.i1SSN.value;
                this.message.i1SSNMask = this.signDocsGroup.controls.i1SSNMask.value;
                if (infoDOB) {
                    this.message.inventorInformation.i1DOB = infoDOB;
                }
            }

            if (this.message.universalPayment) {
                //For UPC
                this.message.universalPayment.bankName = this.signDocsGroup.controls.bankName.value || '';
                this.message.universalPayment.ABANo = this.signDocsGroup.controls.ABANo.value || '';
                this.message.universalPayment.chkAcNo = this.signDocsGroup.controls.chkAcNo.value || '';
                this.message.universalPayment.accountType = +this.signDocsGroup.controls.accountType.value || -1;
                this.message.universalPayment.cCardNo = this.signDocsGroup.controls.cCardNo.value || '';
                this.message.universalPayment.cCardExpDT = this.signDocsGroup.controls.cCardExpDT.value || '';
                this.message.universalPayment.cCardCVV = this.signDocsGroup.controls.cCardCVV.value || '';
                this.message.universalPayment.altDayMonth = this.signDocsGroup.controls.altDayMonth.value || '';
                this.message.universalPayment.altAmount = this.signDocsGroup.controls.altAmount.value ? Number(this.signDocsGroup.controls.altAmount.value.toString().replace(this.currencySterling, "").replace(',', "")) : 0;
                this.message.universalPayment.chkSaveAc = this.signDocsGroup.controls.chkSaveAc.value || false;
                this.message.universalPayment.chkCCard = this.signDocsGroup.controls.chkCCard.value || false;
                this.message.universalPayment.chkNoAutoPay = this.signDocsGroup.controls.chkNoAutoPay.value || false;
            }
            //For Credit Card
            if (this.message.billingDetails) {
                this.message.billingDetails.firstName = this.collectPaymentGroup.controls.firstName.value;
                this.message.billingDetails.lastName = this.collectPaymentGroup.controls.lastName.value;
                this.message.billingDetails.ccNumber = this.collectPaymentGroup.controls.creditCard.value || '';
                this.message.billingDetails.ccExp = this.collectPaymentGroup.controls.expirationDate.value || '';
                this.message.billingDetails.cvv = this.collectPaymentGroup.controls.cvc.value || '';
                this.message.billingDetails.zip = this.collectPaymentGroup.controls.zip.value || '';
            }

            if (this.message.contractMultiPayment) {
                this.message.contractMultiPayment.isChkAmount = this.collectPaymentForm.paymentType.value;
                this.message.contractMultiPayment.chkBankName = this.collectPaymentGroup.controls.chkBankName.value;
                this.message.contractMultiPayment.chkCity = this.collectPaymentGroup.controls.chkCity.value || '';
                this.message.contractMultiPayment.chkState = this.collectPaymentGroup.controls.chkState.value || '';
                this.message.contractMultiPayment.chkRoutingNo = this.collectPaymentGroup.controls.chkRoutingNo.value || '';
                this.message.contractMultiPayment.chkAccNo = this.collectPaymentGroup.controls.chkAccNo.value || '';
                this.message.contractMultiPayment.chkNumber = this.collectPaymentGroup.controls.chkNumber.value || '';
                this.message.contractMultiPayment.bankAccountName = this.collectPaymentGroup.controls.bankAccountName.value || '';
                this.message.contractMultiPayment.chkDate = $("#chkDate").val() || '';
            }

            if (this.contractActionlog) {
                this.message.contractActionLog = UtilityService.clone(this.contractActionlog);
                if (!isNullOrUndefined(this.documentVCutOffDate)) {
                    this.isProductV = new Date(this.documentVCutOffDate.configValue) >= new Date(this.message.contractActionLog.dtCreated) ? true : false;
                }
            }
            //Check List
            if (this.inventionCheckList)
                this.message.inventionCheckList = UtilityService.clone(this.inventionCheckList);

            this.message.isClient = true;
            this.message.isSalesRep = false;
            this._transferDataService.message = this.message;
            this.chatService.sendMessage(this.message);

            this.txtMessage = '';
            this.isCustAction = false;
            this.isSSNMask = false;

            this.isFinalSign = this.finaldocument == "tdIsFinalDocuments" ? true : false;
        }
    }

    refreshConnectionId() {
    }

    validateMsgResponse(message: Message) {
        let isValid: boolean = false;
    }


    private subscribeToEvents(): void {
        this.chatService.messageReceived.subscribe((message: Message) => {
            this._ngZone.run(() => {
                if (message.clientuniqueid != this.uniqueID
                    && message.contractSessionId == this.contractSessionId && message.isSalesRep == true
                ) {
                    let isValidResponse: boolean = true;
                    if ((this._docTypeId == message.docTypeId) && (this._docTypeId == 24) && (message.isSalesRepAction == false))
                        isValidResponse = false;
                    if (isValidResponse) {
                        this.message = UtilityService.clone(message);
                        this._transferDataService.message = this.message;
                        if (this.message.connectionStatus == -1) {
                            this._transferDataService.connectionStatus = 1;
                            this.message.connectionStatus = 1;
                            this._transferDataService.message.connectionStatus = 1;
                        }

                        if (message.isPaymentError) {
                            this.isPaymentError = message.isPaymentError;
                            this.isPaymentProcessing = message.isPaymentProcessing;
                            this.isSubmitCharge = false;
                            this.cardTxnReference = message.cardTxnReference;
                        }

                        else if (message.isPaymentDone) {
                            this.isPaymentProcessing = message.isPaymentProcessing;
                            this.isPaymentDone = message.isPaymentDone;
                            this.isSubmitCharge = true;
                            this.oneTimeFee = message.oneTimeFee;
                            this.isPaymentError = false;
                            this.cardTxnReference = message.cardTxnReference;
                        }
                        else if (message.isPaymentProcessing)
                            this.isPaymentProcessing = message.isPaymentProcessing;
                        else {
                            this.isPaymentDone = message.isPaymentDone;
                            this.isSubmitCharge = false;
                            this.oneTimeFee = message.oneTimeFee;
                            this.isPaymentProcessing = false;
                            this.isPaymentError = false;
                        }
                        if (this.message.partialFee > 0)
                            this.cardErrorMsg = "";
                        this.cardTxnNotes = message.cardTxnNotes;
                        this._docTypeId = message.docTypeId;
                        this.formDivActive = 0;
                        this.message.type = "received";
                        this.oneTimeFee = message.oneTimeFee;
                        this.productName = message.productDescription;
                        this.officeId = message.officeCode;
                        this.inventionName = message.inventionName;
                        this.productId = message.productId;
                        this.isSecondContract = message.isSecondContract;
                        this.waitDays = message.waitDays;
                        this.userStateName = message.userStateName;
                        this.dtSOC = message.dtSOC;
                        this.businessDays = message.businessDays;
                        this.isWaitPrdForPayment = message.isWaitPrdForPayment;
                        this.isCoInventor = message.isCoInventor;
                        this.i2person = message.coInventorName;
                        this.person = message.inventorName;
                        this.sel_brand = message.cardType ? message.cardType : "unknown";
                        this.sel_brandUPC = message.upcCardType ? message.upcCardType : "unknown";
                        this.finaldocument = message.finaldocument;
                        this.expiry = message.isFileNoBlank ? message.isFileNoBlank : false;
                        this.fileNumber = message.billingDetails.fileNumber;
                        this.countryID = message.countryID;
                        this.isNewCanadianContract = message.isNewCanadianContract;
                        this.applyZipValidators(this.countryID);
                        this.checkListTabItem = this.countryID > 2 ? "d" : this.isNewCanadianContract === true ? "e" : "f";
                        this.currencySterling = this.contractSession.CurrencySymbol;
                        this.paymentAuthTitle = this.countryID > 2 ? "Partial Auto Payment" : "Universal Payment Corporation";

                        $([document.documentElement, document.body]).animate({
                            scrollTop: $('#dvSOCSignDoc').offset().top - 104
                        }, 100);
                        if ((this.message.divId == 'Blank' || this.message.divId == "") && (this.message.docTypeId != -999)
                            && (this.message.connectionStatus != 0) && (this.message.connectionStatus != 2)) {
                            this.receiveRespone(this.message.docTypeId, this.message.finalDocTypeIds);
                            if (this.productId >= 3 && this.productId <= 14 && this.productId != 6 && this.productId != 11)
                                this.loadOptionalServiceDocument(this.message.serviceDocTypeIds);
                        }

                        if ((this.message.connectionStatus == 0) || (this.message.connectionStatus == 2)) {
                            $('#modalSignSaved').modal('hide');
                            $('#modalLoadDocument').modal('hide');
                        }

                        if (this.message.isCustAction == true)
                            this.receiveSalesRespone(this.message);

                        this.navigationDivId = this.message.navigationDivId;
                        if (this.message.divId != "Blank")
                            this.showFormDiv(this.message.divId);

                        if (this.message.inventorInformation) {
                            this.signDocsGroup.patchValue({ i1SSNMask: this.getSSNMaskString(message.i1SSN) });
                            this.signDocsGroup.patchValue({ i1SSN: message.i1SSN });
                            if (this.message.inventorInformation.i1DOB) {
                                setTimeout(() => {
                                    $("#i1DOB").val(this.message.inventorInformation.i1DOB);
                                }, 0)
                            }
                        }
                        //For UPC
                        this.bindUniversalInput(this.message);
                        this.bindbillingInput(message);
                        this.bindcontractMultiPayment(message);
                        if (this.message.contractActionLog) {
                            this.loadContractActionlog(this.message.contractSessionId);
                            this.contractActionlog = UtilityService.clone(this.message.contractActionLog);
                            this.isFinalSignWait = this.contractActionlog.isFinalSign;
                        }
                    }
                } else {
                    this.message = UtilityService.clone(message);
                }
            });
            this.inventionId = this.message.inventId;
            this.contractSessionId = this.message.contractSessionId;
            this.loadNavigationWizard();
        });
    }

    private bindUniversalInput(message): void {
        if (message.universalPayment) {
            this.checkClientExpiry(message.divId);
            this.signDocsGroup.patchValue({
                bankName: message.universalPayment.bankName ? message.universalPayment.bankName : '',
                ABANo: message.universalPayment.abaNo ? message.universalPayment.abaNo : '',
                chkAcNo: message.universalPayment.chkAcNo ? message.universalPayment.chkAcNo : '',
                accountType: message.universalPayment.accountType ? message.universalPayment.accountType : -1,
                cCardNo: message.universalPayment.cCardNo ? message.universalPayment.cCardNo : '',
                cCardExpDT: message.universalPayment.cCardExpDT ? message.universalPayment.cCardExpDT : '',
                cCardCVV: message.universalPayment.cCardCVV ? message.universalPayment.cCardCVV : '',
                altDayMonth: message.universalPayment.altDayMonth ? message.universalPayment.altDayMonth : '',
                altAmount: message.universalPayment.altAmount ? message.universalPayment.altAmount : '',
            })
            var altAmount = this.signDocsGroup.controls.altAmount.value;
            if (typeof altAmount != 'string') {
                this.convertNumberToCurrency(altAmount, 'altAmount');
            }
            this.divPaySaveAc = message.universalPayment.chkSaveAc ? message.universalPayment.chkSaveAc : false;
            this.divPayCard = message.universalPayment.chkCCard ? message.universalPayment.chkCCard : this.countryID < 3 ? false : true;
            this.signDocsGroup.patchValue({
                chkSaveAc: message.universalPayment.chkSaveAc ? message.universalPayment.chkSaveAc : false,
                chkCCard: message.universalPayment.chkCCard ? message.universalPayment.chkCCard : this.countryID < 3 ? false : true,
                chkNoAutoPay: message.universalPayment.chkNoAutoPay ? message.universalPayment.chkNoAutoPay : false,
            });
            if (message.universalPayment.chkNoAutoPay) {
                this.isNoAutoPay = false;
                this.hideOptionalDoc = true;
                this.divNoAutoPay = true;
            }
            else {
                if (message.countryID == 2)
                    this.isNoAutoPay = false;
                else
                    this.isNoAutoPay = true;
                this.hideOptionalDoc = false;
                this.divNoAutoPay = false;
            }
        }
    }

    private bindbillingInput(message): void {
        if (message.billingDetails) {
            this.collectPaymentGroup.patchValue({
                firstName: message.billingDetails.firstName ? message.billingDetails.firstName : '',
                lastName: message.billingDetails.lastName ? message.billingDetails.lastName : '',
                creditCard: message.billingDetails.ccNumber ? message.billingDetails.ccNumber : '',
                expirationDate: message.billingDetails.ccExp ? message.billingDetails.ccExp : '',
                cvc: message.billingDetails.cvv ? message.billingDetails.cvv : '',
                zip: message.billingDetails.zip ? message.billingDetails.zip : ''
            })
            this.collectPaymentGroup.markAsDirty();
            this.collectPaymentGroup.markAsPristine();
            this.collectPaymentGroup.markAsUntouched();
        }
    }

    private bindcontractMultiPayment(message): void {
        if (message.contractMultiPayment) {
            this.collectPaymentGroup.patchValue({
                paymentType: message.contractMultiPayment.isChkAmount ? message.contractMultiPayment.isChkAmount : false,
                chkBankName: message.contractMultiPayment.chkBankName ? message.contractMultiPayment.chkBankName : '',
                chkCity: message.contractMultiPayment.chkCity ? message.contractMultiPayment.chkCity : '',
                chkState: message.contractMultiPayment.chkState ? message.contractMultiPayment.chkState : '',
                chkRoutingNo: message.contractMultiPayment.chkRoutingNo ? message.contractMultiPayment.chkRoutingNo : '',
                chkAccNo: message.contractMultiPayment.chkAccNo ? message.contractMultiPayment.chkAccNo : '',
                chkNumber: message.contractMultiPayment.chkNumber ? message.contractMultiPayment.chkNumber : '',
                bankAccountName: message.contractMultiPayment.bankAccountName ? message.contractMultiPayment.bankAccountName : '',
            })
            $("#chkDate").val(message.contractMultiPayment.chkDate);
            if (this.collectPaymentGroup.controls.chkRoutingNo.value.length > 0)
                this.isRoutingNumberBlank = message.contractMultiPayment.chkRoutingNo.length > 0 ? false : true;
            if (this.collectPaymentGroup.controls.chkAccNo.value.length > 0)
                this.isAccountNumberBlank = message.contractMultiPayment.chkAccNo.length > 0 ? false : true;
            if (this.collectPaymentGroup.controls.bankAccountName.value.length > 0)
                this.isBankAccountNameBlank = message.contractMultiPayment.bankAccountName.length > 0 ? false : true;
            this.disabledAgreement = message.contractMultiPayment.isChkAmount ? false : true;
            this.currentMultiPayId = message.contractMultiPayment.id;
            if (message.paidMode === 'payMoneyOrder')
                this.fetchPaymentDocList(this.contractSessionId, this.currentMultiPayId, 1);
            else if (message.paidMode === 'payCheck')
                this.fetchPaymentDocList(this.contractSessionId, this.currentMultiPayId, 2);
            else if (message.paidMode === 'payOther')
                this.fetchPaymentDocList(this.contractSessionId, this.currentMultiPayId, 3);
        }
    }

    checkClientExpiry(divid) {
        var datePipe = new DatePipe("en-US");
        this.expDate = datePipe.transform(new Date(), 'MMyyyy');
        if (divid == 'divUPC') {
            if (this.message.universalPayment.cCardExpDT == '')
                this.cCardExpDTfield = this.expDate;
            else
                this.cCardExpDTfield = this.message.universalPayment.cCardExpDT.substring(0, 2) + this.expDate.substring(2, 4) + this.message.universalPayment.cCardExpDT.substring(2, 4);
            //divUPC
        }

        if (parseInt(this.cCardExpDTfield.substring(2, 6)) < parseInt(this.expDate.substring(2, 6))) {
            return this.expiry = true;
        }

        else if (parseInt(this.cCardExpDTfield.substring(2, 6)) == parseInt(this.expDate.substring(2, 6)) && parseInt(this.cCardExpDTfield.substring(0, 2)) < parseInt(this.expDate.substring(0, 2))) {
            return this.expiry = true;
        }
        else if (parseInt(this.cCardExpDTfield.substring(0, 2)) > 12) {
            return this.expiry = true;
        }
        else if (parseInt(this.cCardExpDTfield.substring(2, 6)) >= parseInt(this.expDate.substring(2, 6))) {
            return this.expiry = false;
        }

        else if (parseInt(this.cCardExpDTfield.substring(2, 6)) == parseInt(this.expDate.substring(2, 6)) && parseInt(this.cCardExpDTfield.substring(0, 2)) == parseInt(this.expDate.substring(0, 2))) {
            return this.expiry = false;
        }

        else if (parseInt(this.cCardExpDTfield.substring(2, 6)) == parseInt(this.expDate.substring(2, 6)) && parseInt(this.cCardExpDTfield.substring(0, 2)) < parseInt(this.expDate.substring(0, 2))) {
            return this.expiry = true;
        }
        else
            return this.expiry = false;
    }

    private showFormDiv(divId) {
        switch (divId) {
            case "divIFI": this.formDivActive = 1; this.signedDocId = 'inventFormSubmit'; this.documentTypeId = 24; this.isShowWelcome = true; $('#modalSignSaved').modal('hide'); break;
            case "divUPC": this.formDivActive = 2; this.signedDocId = 'uniPayFormSubmit'; this.documentTypeId = 26; this.isShowWelcome = true; $('#modalSignSaved').modal('hide'); break;
            case "divCPG": this.paymentUploader.resetFileUpload(); this.isShowWelcome = true; this.message.paidMode == 'payCreditCard' || this.message.paidMode == 'payCheck' || this.message.paidMode == 'payMoneyOrder'
                || this.message.paidMode == 'payOther' ? this.formDivActive = 3 : this.message.isWaitPrdForPayment ? this.formDivActive = 3 : this.isShowWelcome = false;
                this.signedDocId = 'payCollectionFormSubmit'; this.loadContractSession(); this.actionDesc = ""; $('#modalSignSaved').modal('hide'); break;
            case "divCheckList": this.formDivActive = 4; this.signedDocId = 'checkListFormSubmit'; this.documentTypeId = -3; this.isShowWelcome = true; $('#modalSignSaved').modal('hide'); break;
            case "divPS": this.actionDesc = "Services are being selected."; this.isShowWelcome = false; $('#modalSignSaved').modal('hide'); $('#modalLoadDocument').modal('hide'); break;
            case "divBIP": case "divSUB": case "divROI": case "divIMP": this.isShowWelcome = false; $('#modalSignSaved').modal('hide'); break;
        }
    }

    private receiveSalesRespone(msg) {
        if (msg.isCustAction == true) {
            $('#modalSignSaved').modal('show');
            msg.actionDesc = "";
            this.isCustAction = false;
        }
    }

    async receiveRespone(docTypeId, finalDocTypeIds): Promise<void> {
        await this.loadDocumentSignature();
        this.documentID = docTypeId;
        switch (docTypeId) {
            case 0: this.docHeaderName = "State Disclosure Agreement"; this.chkSOC = false; this.chkSign = false; this.signedDocId = 'stateDocSign'; this.documentTypeId = -0; break;


            case 1: this.docHeaderName = "Statement of Confidentiality"; this.chkSOC = true; this.chkSign = true; this.signedDocId = 'socDocSign';
                this.isFinalSign = false; this.socSignatureShow(); break;

            case 2: this.docHeaderName = "Record of Invention"; this.chkSOC = false; this.chkSign = false; this.signedDocId = 'roiDocSign'; break;

            case 3: case 38: this.docHeaderName = "Affirmative Disclosure Agreement"; this.chkSOC = false; this.chkSign = true; this.signedDocId = 'adsDocSign';
                this.isFinalSign = false; this.adsSignatureShow(); break;

            case 4: this.docHeaderName = "National Disclosure"; this.chkSOC = false; this.chkSign = false; this.signedDocId = 'ndaDocSign';
                this.hideModel(); break;

            case 22:
            case 32: case 129: this.docHeaderName = "Basic Information Package Agreement"; this.chkSOC = false; this.chkSign = false; this.signedDocId = 'bipDocSign';
                this.hideModel(); break;
            case 6: this.docHeaderName = "Patent Search Report"; this.chkSOC = false; this.chkSign = false; this.signedDocId = 'ppsoDocsign';
                this.hideModel(); break;
            case 23:
            case 33: this.docHeaderName = "Preliminary Patentability Search and Opinion"; this.chkSOC = false; this.chkSign = false; this.signedDocId = 'ppsoDocsign';
                this.hideModel(); break;
            case 24: this.docHeaderName = "Information For Inventhelp"; this.chkSOC = false; this.chkSign = false; this.signedDocId = 'inventDocSign'; break;
            case 25: this.docHeaderName = "Retail Installment Contract"; this.chkSOC = false; this.chkSign = false; this.signedDocId = 'retailInstallmentDocSign'; break;
            case 26: this.docHeaderName = this.countryID > 2 ? "Partial Auto Payment" : "Universal Payment Corporation"; this.chkSOC = false; this.chkSign = false; this.signedDocId = 'uniPayDocSign';
                this.hideModel(); break;
            case 27: case 28: case 29: case 30:
            case 31: this.docHeaderName = "Waiting State Agreement"; this.chkSOC = false; this.chkSign = false; this.signedDocId = 'waitStateDocSign';
                this.hideModel(); break;
            case 36: case 128: case 133: case 135: this.productId == 5 ? this.docHeaderName = "Web Services" : this.docHeaderName = "IMP Services"; this.chkSOC = false; this.chkSign = false; this.signedDocId = 'impDocSign';
                this.hideModel(); break;
            case -1:case 142: this.docHeaderName = "Submission Agreement"; this.chkSOC = false; this.chkSign = false; this.signedDocId = 'subDocSign'; break;
            case -2: this.docHeaderName = "Additional Documents"; this.chkSOC = false; this.chkSign = false; this.signedDocId = 'additionalDocSign';
                this.hideModel(); break;
            case -3: case 141: this.docHeaderName = "Invention Checklist"; this.chkSOC = false; this.chkSign = false; this.signedDocId = 'checkListDocSign';
                this.hideModel();
                if (finalDocTypeIds != '') {
                    this.mandateDocBtn = "Accept & Sign";
                    this.documentTypeIds = finalDocTypeIds;
                    $('#modalLoadDocument').modal('show');
                    this.loadDocument();
                } break;
            case 130: case 132: this.docHeaderName = "Partial Payment Agreement"; this.chkSOC = false; this.chkSign = false; this.signedDocId = 'ppaDocSign'; break;
            default: break;
        }

        if (finalDocTypeIds != '' && (this.finaldocument == "tdIsFinalDocuments")) {
            this.hideModel();
            this.finalSignatureShow();
            this.chkSign = false;
            this.isFinalSign = true;
            this.documentTypeIds = finalDocTypeIds;
            $('#modalLoadDocument').modal('show');
            this.loadDocument();
            this.mandateDocBtn = "Accept & Sign";
        }
        else {
            this.isFinalSign = false;
            this.changeMandateDocBtn(this.documentID);
            this.loadDocument_DocTypeId(docTypeId);
        }

        if (docTypeId != 0)
            this.documentTypeId = docTypeId;
        if (docTypeId == null && this.isWaitPrdForPayment == false)
            this.isShowWelcome = false;
        else
            this.isShowWelcome = true;
        this.actionDesc = ' loaded successfully.';

        if ((docTypeId == 24 && this.message.divId == 'infoSubmit') || (docTypeId == 26 && this.message.divId == 'upcSubmit') || ((docTypeId == -3 || docTypeId == 141) && this.message.divId == 'checkListSubmit'))
            this.actionDesc = ' saved and document loaded successfully.';
    }
    socSignatureShow() {
        if (this.message.isCoInventor) {
            if (this.documentSignature.signature2 === '' && this.documentSignature.initial2 === '') {
                if (this.documentSignature.signature1) {
                    this.signaturePad.clear();
                    this.signDocsGroup.patchValue({ initialSignature: '' });
                    this.signaturePad.fromDataURL(this.documentSignature.signature1, { width: canvaswidgth, height: canvasheight });
                    this.signatureOnEnd(); this.signaturePad.off(); this.isExistSoc = true;
                    this.titleMsg = 'To resign, please clear the signature first!';
                    this.signaturePadCoInv.clear();
                    this.initialCoInvDisabled = false;
                    this.signDocsGroup.patchValue({ initialCoInvSignature: '' });
                    this.signaturePadCoInv.on();
                }
                else if (this.documentSignature.initial1) {
                    this.signaturePad.clear();
                    this.signDocsGroup.patchValue({ initialSignature: this.documentSignature.initial1 });
                    this.signaturePad.off();
                    this.titleMsg = '';
                } else {
                    this.isExistSoc = false;
                    this.signaturePad.clear();
                    this.signDocsGroup.patchValue({ initialSignature: '' });
                    this.initialDisabled = false;
                    this.initialCoInvDisabled = false;
                    this.signaturePad.on(); this.titleMsg = '';
                    this.signaturePadCoInv.clear();
                    this.signDocsGroup.patchValue({ initialCoInvSignature: '' });
                    this.signaturePadCoInv.on();
                    if (this.contractSession.isCancelled == true) {
                        this.signaturePad.off();
                        this.signaturePadCoInv.off();
                        this.initialDisabled = true;
                        this.initialCoInvDisabled = true;
                        $(':button').prop('disabled', true);
                    }
                }
            }
            else {
                this.isExistSoc = false;
                this.signaturePad.clear();
                this.signDocsGroup.patchValue({ initialSignature: '' });
                this.initialDisabled = false;
                this.initialCoInvDisabled = false;
                this.signaturePad.on(); this.titleMsg = '';
                this.signaturePadCoInv.clear();
                this.signDocsGroup.patchValue({ initialCoInvSignature: '' });
                this.signaturePadCoInv.on();
                if (this.contractSession.isCancelled == true) {
                    this.signaturePad.off();
                    this.signaturePadCoInv.off();
                    this.initialDisabled = true;
                    this.initialCoInvDisabled = true;
                    $(':button').prop('disabled', true);
                }
            }
        } else {
            this.isExistSoc = false;
            this.signaturePad.clear();
            this.signDocsGroup.patchValue({ initialSignature: '' });
            this.initialDisabled = false;
            this.initialCoInvDisabled = false;
            this.signaturePad.on(); this.titleMsg = '';
            this.signaturePadCoInv.clear();
            this.signDocsGroup.patchValue({ initialCoInvSignature: '' });
            this.signaturePadCoInv.on();
            if (this.contractSession.isCancelled == true) {
                this.signaturePad.off();
                this.signaturePadCoInv.off();
                this.initialDisabled = true;
                this.initialCoInvDisabled = true;
                $(':button').prop('disabled', true);
            }
        }
    }
    adsSignatureShow() {
        if (this.message.isCoInventor) {
            if (this.documentSignature.i2SignatureADS === '' && this.documentSignature.i2InitialADS === '') {
                if (this.documentSignature.i1SignatureADS) {
                    this.signaturePad.clear();
                    this.signDocsGroup.patchValue({ initialSignature: '' });
                    this.signaturePad.fromDataURL(this.documentSignature.i1SignatureADS, { width: canvaswidgth, height: canvasheight });
                    this.signatureOnEnd(); this.signaturePad.off(); this.isExistADS = true;
                    this.titleMsg = 'To resign, please clear the signature first!';
                    this.signaturePadCoInv.clear();
                    this.initialCoInvDisabled = false;
                    this.signDocsGroup.patchValue({ initialCoInvSignature: '' });
                    this.signaturePadCoInv.on();
                }
                else if (this.documentSignature.i1InitialADS) {
                    this.signaturePad.clear();
                    this.signDocsGroup.patchValue({ initialSignature: this.documentSignature.i1InitialADS });
                    this.signaturePad.off();
                    this.titleMsg = '';
                }
                else {
                    this.isExistADS = false;
                    this.signaturePad.clear();
                    this.signDocsGroup.patchValue({ initialSignature: '' });
                    this.initialDisabled = false;
                    this.initialCoInvDisabled = false;
                    this.signaturePad.on(); this.titleMsg = '';
                    this.signaturePadCoInv.clear();
                    this.signDocsGroup.patchValue({ initialCoInvSignature: '' });
                    this.signaturePadCoInv.on();
                    if (this.contractSession.isCancelled == true) {
                        this.signaturePad.off();
                        this.signaturePadCoInv.off();
                        this.initialDisabled = true;
                        this.initialCoInvDisabled = true;
                        $(':button').prop('disabled', true);
                    }
                }
            } else {
                this.isExistADS = false;
                this.signaturePad.clear();
                this.signDocsGroup.patchValue({ initialSignature: '' });
                this.signaturePad.on();
                this.titleMsg = '';
                this.initialDisabled = false;
                this.initialCoInvDisabled = false;
                this.signaturePadCoInv.clear();
                this.signDocsGroup.patchValue({ initialCoInvSignature: '' });
                this.signaturePadCoInv.on();
                if (this.contractSession.isCancelled == true) {
                    this.signaturePad.off();
                    this.signaturePadCoInv.off();
                    this.initialDisabled = true;
                    this.initialCoInvDisabled = true;
                    $(':button').prop('disabled', true);
                }
            }
        } else {
            this.isExistADS = false;
            this.signaturePad.clear();
            this.signDocsGroup.patchValue({ initialSignature: '' });
            this.signaturePad.on();
            this.titleMsg = '';
            this.initialDisabled = false;
            this.initialCoInvDisabled = false;
            this.signaturePadCoInv.clear();
            this.signDocsGroup.patchValue({ initialCoInvSignature: '' });
            this.signaturePadCoInv.on();
            if (this.contractSession.isCancelled == true) {
                this.signaturePad.off();
                this.signaturePadCoInv.off();
                this.initialDisabled = true;
                this.initialCoInvDisabled = true;
                $(':button').prop('disabled', true);
            }
        }
    }
    finalSignatureShow() {
        if (this.message.isCoInventor) {
            if (this.documentSignature.i2SignatureFinal === '' && this.documentSignature.i2InitialFinal === '') {
                if (this.documentSignature.i1SignatureFinal) {
                    this.signaturePadFinal.clear();
                    this.signaturePadFinal.fromDataURL(this.documentSignature.i1SignatureFinal, { width: canvaswidgth, height: canvasheight });
                    this.signatureFinalOnEnd();
                    this.signaturePadFinal.off();
                    this.isExistFinal = true;
                    this.titleMsg = 'To resign, please clear the signature first!';
                    this.signaturePadFinalCoInv.clear();
                    this.signDocsGroup.patchValue({ initialFinalCoInvSignature: '' });
                    this.signaturePadFinalCoInv.on();
                    this.initialFinalCoInvDisabled = false;
                }
                else if (this.documentSignature.i1InitialFinal) {
                    this.signaturePadFinal.clear();
                    this.signDocsGroup.patchValue({ initialFinalSignature: this.documentSignature.i1InitialFinal });
                    this.signaturePadFinal.off();
                    this.isExistFinal = false;
                    this.initialFinalDisabled = false;
                }
                else {
                    this.signaturePadFinal.clear();
                    this.signDocsGroup.patchValue({ initialFinalSignature: '' });
                    this.signaturePadFinal.on();
                    this.isExistFinal = false;
                    this.initialFinalDisabled = false;
                    this.initialFinalCoInvDisabled = false;
                    this.signDocsGroup.patchValue({ initialFinalCoInvSignature: '' });
                    this.signaturePadFinalCoInv.clear();
                    this.signaturePadFinalCoInv.on();
                    if (this.contractSession.isCancelled == true) {
                        this.signaturePadFinal.off();
                        this.signaturePadFinalCoInv.off();
                        this.initialFinalDisabled = true;
                        this.initialFinalCoInvDisabled = true;
                        $(':button').prop('disabled', true);
                    }
                }
            } else {
                this.signaturePadFinal.clear();
                this.signDocsGroup.patchValue({ initialFinalSignature: '' });
                this.signaturePadFinal.on();
                this.isExistFinal = false;
                this.initialFinalDisabled = false;
                this.initialFinalCoInvDisabled = false;
                this.signDocsGroup.patchValue({ initialFinalCoInvSignature: '' });
                this.signaturePadFinalCoInv.clear();
                this.signaturePadFinalCoInv.on();
                if (this.contractSession.isCancelled == true) {
                    this.signaturePadFinal.off();
                    this.signaturePadFinalCoInv.off();
                    this.initialFinalDisabled = true;
                    this.initialFinalCoInvDisabled = true;
                    $(':button').prop('disabled', true);
                }
            }

        } else {
            this.signaturePadFinal.clear();
            this.signDocsGroup.patchValue({ initialFinalSignature: '' });
            this.signaturePadFinal.on();
            this.isExistFinal = false;
            this.initialFinalDisabled = false;
            this.initialFinalCoInvDisabled = false;
            this.signDocsGroup.patchValue({ initialFinalCoInvSignature: '' });
            this.signaturePadFinalCoInv.clear();
            this.signaturePadFinalCoInv.on();
            if (this.contractSession.isCancelled == true) {
                this.signaturePadFinal.off();
                this.signaturePadFinalCoInv.off();
                this.initialFinalDisabled = true;
                this.initialFinalCoInvDisabled = true;
                $(':button').prop('disabled', true);
            }
        }
    }
    private hideModel() {
        $("#modalSignSaved").removeClass("modal-backdrop fade");
        $("#modalLoadDocument").removeClass("modal-backdrop fade");
        $('#modalSignSaved').modal('hide');
        $('#modalLoadDocument').modal('hide');
    }
    private async loadDocumentSignature() {
        await this._documentService.getDocumentSignatureAsync(this.encryptedUser, this.contractSessionId)
            .then(res => {
                if (res) {
                    if (res.statusCode == 0) {
                        this.documentSignatureResponse = UtilityService.clone(res);
                        this.documentSignature = this.documentSignatureResponse.documentSignature;
                        if (this.documentSignature) {
                            this.signature1 = this.documentSignature.signature1;
                            this.i1SignatureADS = this.documentSignature.i1SignatureADS;
                            this.i1SignatureFinal = this.documentSignature.i1SignatureFinal;
                        }
                    } else {
                        console.log("Document Signature result status code: " + res.statusCode);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private loadContractSession() {
        if (this.contractSessionId > 0 && !isNullOrUndefined(this.contractSessionId)) {
            this._contractSessionService.getContactSessionByCSIdAsync(this.encryptedUser, this.contractSessionId)
                .then(async res => {
                    if (res) {
                        this.contractSession = UtilityService.clone(res);
                        if (this.contractSession.CountryID == 2)
                            this.isNoAutoPay = false;
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    private loadInventionCheckList() {
        this._inventionCheckListService.InventionCheckList_GetAsync(this.encryptedUser, this.inventionId, this.contractSessionId)
            .then(res => {
                if (res) {
                    if (res.statusCode == 0) {
                        this.inventionCheckListResponse = UtilityService.clone(res);
                        this.inventionCheckList = this.inventionCheckListResponse.inventionCheckList;

                        this.copyDataObjectToInfoCollectValues();
                    } else {
                        console.log("Invention Checklist result status code: " + res.statusCode);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async loadDocument_DocTypeId(docId) {
        if (this.documentID == -3 || this.documentID == 141 )
            this.navigationDivId = "tdIsCheckListDoc";
        this.signaturePad.clear();
        if (isNumber(docId)) {
            await this._documentService.getProductDocumentListAsync(this.encryptedUser, docId.toString(), this.inventionId, this.contactId, this.contractSessionId, this.productId >= 9 && this.productId < 12 ? "Plus" : "Normal")
                .then(async (result: DocumentResponseList) => {
                    $('#modalSignSaved').modal('hide');
                    $('#modalLoadDocument').modal('hide');
                    if (result) {
                        if (result.statusCode == 0) {
                            this.documentListResponse = UtilityService.clone(result);
                            if (this.documentListResponse && this.documentListResponse.docList.length > 0) {
                                if (docId == 88 || docId == 89)
                                    this.docSignAddmB = this.documentListResponse.docList[0].document;
                                else if (docId == 86 || docId == 87 || docId == 143 || docId == 146)
                                    this.docSignAddmG = this.documentListResponse.docList[0].document;
                                else if (docId == 84 || docId == 85)
                                    this.docSignAddmP = this.documentListResponse.docList[0].document;
                                else if (docId == 137 || docId == 138 || docId == 144 || docId == 147)
                                    this.docSignAddmT = this.documentListResponse.docList[0].document;
                                else if (docId == 139 || docId == 140)
                                    this.docSignAddmV = this.documentListResponse.docList[0].document;
                                else if (docId == 82 || docId == 83 || docId == 136 || docId == 134 || docId == 124 || docId == 125 || docId == 145 || docId == 148)
                                    this.docSignPatent = this.documentListResponse.docList[0].document;
                                else if (docId == 93 || docId == 94)
                                    this.docSignIntroMark = this.documentListResponse.docList[0].document;
                                else
                                    this.documents = this.documentListResponse.docList;
                                this.docSign = '';
                                this.message.isDocumentLoading = false;
                                this.isCustAction = false;
                                this.sendMessage();
                            }
                        } else {
                            console.log("loadDocument_DocTypeId.statusCode: " + result.statusCode);
                        }
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    private async loadDocument() {
        $('#modalSignSaved').modal('hide');
        if (this.documentTypeIds != '' && !isNullOrUndefined(this.documentTypeIds)) {
            await this._documentService.getProductDocumentListAsync(this.encryptedUser, this.documentTypeIds, this.inventionId, this.contactId, this.contractSessionId, this.productId >= 9 && this.productId < 12 ? "Plus" : "Normal")
                .then(async (result: DocumentResponseList) => {
                    if (result) {
                        if (result.statusCode == 0) {
                            this.documentListResponse = UtilityService.clone(result);
                            if (this.documentListResponse && this.documentListResponse.docList.length > 0) {
                                this.documents = this.documentListResponse.docList;
                            }
                            var docHeader = this.documentTypeIds.split(',');

                            for (var i = 0; i < docHeader.length; i++) {
                                if (this.documents[i]) {
                                    switch (this.documents[i].documentTypeID) {
                                        case 1: this.documents[i].documentTypeName = "Statement of Confidentiality"; break;
                                        case 2: this.documents[i].documentTypeName = "Record of Invention"; break;
                                        case 3: case 38:
                                            this.documents[i].documentTypeName = "Affirmative Disclosure Agreement"; break;
                                        case 4: this.documents[i].documentTypeName = "National Disclosure"; break;
                                        case 7: this.documents[i].documentTypeName = "Patent Search Opinion Request"; break;
                                        case 21: this.documents[i].documentTypeName = "Background Information About Invention"; break;
                                        case 6: this.documents[i].documentTypeName = "Patent Search Report"; break;
                                        case 23: this.documents[i].documentTypeName = "Preliminary Patentability Search and Opinion"; break;
                                        case 24: this.documents[i].documentTypeName = "Information For Inventhelp"; break;
                                        case 25: this.documents[i].documentTypeName = "Retail Installment Contract"; break;
                                        case 26: this.countryID > 2 ? this.documents[i].documentTypeName = "Partial Auto Payment" : this.documents[i].documentTypeName = "Universal Payment Corporation"; break;
                                        case 27: case 28: case 29: case 30: case 31:
                                            this.documents[i].documentTypeName = "Waiting State Agreement"; break;
                                        case 22: case 32: case 37: case 129:
                                            this.documents[i].documentTypeName = "Basic Information Package Agreement"; break;
                                        case 33: this.documents[i].documentTypeName = "Preliminary Patentability Search and Opinion"; break;
                                        case 36: case 128: this.documents[i].documentTypeName = "IMP Services"; break;
                                        case 133: case 135: this.documents[i].documentTypeName = "Web Services"; break;
                                        case 39: case 42: case 45: case 48: case 51: case 54: case 57: case 60: case 63: case 0:
                                            this.documents[i].documentTypeName = "State Disclosure Agreement"; break;
                                        case 66: case 67: case 68: case 69: case 70: case 71: case 72: case 73: case 74:
                                        case 75: case 76: case 77: case 78: case 79: case 80: case 81: case 131: case 142:
                                            this.documents[i].documentTypeName = "Submission Agreement"; break;
                                        case 88: case 89: this.productId >= 9 && this.productId < 12 ? this.documents[i].documentTypeName = "Preliminary Patentability Opinion" : this.documents[i].documentTypeName = "Addendum B"; break;
                                        case 86: case 87: case 143: case 146: this.documents[i].documentTypeName = "Addendum G"; break;
                                        case 84: case 85: this.documents[i].documentTypeName = "Addendum P"; break;
                                        case 137: case 138: case 144: case 147: this.documents[i].documentTypeName = "Addendum T"; break;
                                        case 139: case 140: this.isProductV ? this.documents[i].documentTypeName = "Addendum V" : ''; break;
                                        case 82: case 83: case 124: case 125: case 134: case 136: case 145: case 148:
                                            this.documents[i].documentTypeName = "Patent Application Services"; break;
                                        case 95: case 96: case 97: case 98: case 99: case 100: case 101: case 102: case 103:
                                        case 104: case 105: case 106: case 107: case 108: case 109: case 110:
                                        case 111: case 112: case 113: case 114: case 115: case 116: case 117:
                                        case 118: case 119: case 120: case 121: case 122: case 123: case 126: case -2:
                                            this.documents[i].documentTypeName = "Additional Documents"; break;
                                        case 127: case -3: case 141: this.documents[i].documentTypeName = "Invention Checklist"; break;
                                        case 93: case 94:
                                            this.documents[i].documentTypeName = "IntroMark Proposal"; break;
                                        case 130: case 132: this.documents[i].documentTypeName = "Partial Payment Agreement"; break;
                                        default: break;
                                    }
                                }
                            }
                        } else {
                            console.log("result.statusCode: " + result.statusCode);
                        }
                        setTimeout(() => {
                            $('#modalLoadDocument').modal('hide');
                        }, 200);
                    }
                    $('#modalLoadDocument').modal('hide');
                })
                .catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                    $('#modalLoadDocument').modal('hide');
                });
        }
        $('#modalLoadDocument').modal('hide');
        this.docSign = '';
        this.message.isDocumentLoading = false;
        this.isCustAction = false;
        this.sendMessage();
    }

    private async loadOptionalServiceDocument(servicedocTypeIds: string) {
        if ((this.productId == 4 || this.productId == 5) && !this.message.isPatentServices)
            this.docSignPatent = "No service selected.";
        if (servicedocTypeIds != '-1' && !isNullOrUndefined(servicedocTypeIds)) {
            await this._documentService.getProductDocumentListAsync(this.encryptedUser, servicedocTypeIds, this.inventionId, this.contactId, this.contractSessionId, this.productId >= 9 && this.productId < 12 ? "Plus" : "Normal")
                .then(async (result: DocumentResponseList) => {
                    if (result) {
                        if (result.statusCode == 0) {
                            this.documentListResponse = UtilityService.clone(result);

                            if (this.documentListResponse && this.documentListResponse.docList.length > 0) {
                                for (var i = 0; i < this.documentListResponse.docList.length; i++) {

                                    let doc: DocType = this.documentListResponse.docList[i];
                                    switch (doc.documentTypeID) {
                                        case 88: case 89: this.docSignAddmB = UtilityService.clone(doc.document); break;
                                        case 86: case 87: case 143: case 146: this.docSignAddmG = UtilityService.clone(doc.document); break;
                                        case 84: case 85: this.docSignAddmP = UtilityService.clone(doc.document); break;
                                        case 137: case 138: case 144: case 147: this.docSignAddmT = UtilityService.clone(doc.document); break;
                                        case 139: case 140: this.isProductV ? this.docSignAddmV = UtilityService.clone(doc.document) : this.docSignAddmV = ''; break;
                                        case 82: case 83: case 124: case 125: case 134: case 136: case 145: case 148: this.docSignPatent = UtilityService.clone(doc.document); break;
                                        case 93: case 94: this.docSignIntroMark = UtilityService.clone(doc.document); break;
                                        default: break;
                                    }

                                }
                            }

                        } else {
                            console.log("result.statusCode: " + result.statusCode);
                        }
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    private fetchPaymentDocList(contractSessionId, contractMultiPaymentId, payType): void {
        this._mediaImagesService.getPaymentDocList(this.encryptedUser, contractSessionId, contractMultiPaymentId, payType)
            .subscribe(
                (result: PaymentDocMediaImagesResponse) => {
                    this.globalResponse = result.listImages;
                    this.paymentDocMediaImagesResponse = result;
                    this.paymentDoc = Object.assign([], this.globalResponse).filter(payment => payment.payType == 1);
                    this.paymentDocCheque = Object.assign([], this.globalResponse).filter(payment => payment.payType == 2);
                    this.paymentOther = Object.assign([], this.globalResponse).filter(payment => payment.payType == 3);
                    this.globalResponse = null;
                },
                error => {
                    console.error(error);
                    this.paymentDoc = null;
                }
            );
    }

    private copyFormValuesToDataObject() {
        if (this.signaturePad.isEmpty() == false || this.documentSignature.signature1)
            this.base64Str = this.isExistSoc ? this.documentSignature.signature1 : this.signaturePad.toDataURL('image/png', 0.9);
        if (this.signaturePad.isEmpty() == false || this.documentSignature.i1SignatureADS)
            this.base64StrADS = this.isExistADS ? this.documentSignature.i1SignatureADS : this.signaturePad.toDataURL('image/png', 0.9);
        if (this.signaturePadCoInv.isEmpty() == false || this.documentSignature.signature2)
            this.base64StrCoInv = this.isExistSocinv ? this.documentSignature.signature2 : this.signaturePadCoInv.toDataURL('image/png', 0.9);
        if (this.signaturePadCoInv.isEmpty() == false || this.documentSignature.i2SignatureADS)
            this.base64StrCoInvADS = this.isExistADSinv ? this.documentSignature.i2SignatureADS : this.signaturePadCoInv.toDataURL('image/png', 0.9);
        if (this.signaturePadFinal.isEmpty() == false || this.documentSignature.i1SignatureFinal)
            this.base64StrFinal = this.isExistFinal ? this.documentSignature.i1SignatureFinal : this.signaturePadFinal.toDataURL('image/png', 0.9);
        if (this.signaturePadFinalCoInv.isEmpty() == false || this.documentSignature.i2SignatureFinal)
            this.base64StrFinalCoInv = this.isExistFinalinv ? this.documentSignature.i2SignatureFinal : this.signaturePadFinalCoInv.toDataURL('image/png', 0.9);
        let dc: DocumentContainer = {} as any;
        dc.contractSessionId = this.contractSessionId;
        dc.contactId = this.contactId;
        dc.currentUser = this.currentUser;
        dc.documentTypeId = 1;
        dc.inventionId = this.inventionId
        if (this.documentID == 1) {
            dc.signature = this.signDocsGroup.controls.initialSignature.value ? "" : this.base64Str;
            dc.initial = this.signDocsGroup.controls.initialSignature.value ? this.signDocsGroup.controls.initialSignature.value.trim() : "";

            if (this.message.isCoInventor) {
                dc.i2signature = this.signDocsGroup.controls.initialCoInvSignature.value ? '' : this.base64StrCoInv;
                dc.i2initial = this.signDocsGroup.controls.initialCoInvSignature.value ? this.signDocsGroup.controls.initialCoInvSignature.value.trim() : "";
            } else {
                dc.i2signature = '';
                dc.i2initial = '';
            }

            dc.i1SignatureADS = "";
            dc.i1InitialADS = "";
            dc.i2SignatureADS = "";
            dc.i2InitialADS = "";
            dc.i1SignatureFinal = "";
            dc.i1InitialFinal = "";
            dc.i2SignatureFinal = "";
            dc.i2InitialFinal = "";
        }
        if ((this.documentID == 3) || (this.documentID == 38)) {
            dc.i1SignatureADS = this.signDocsGroup.controls.initialSignature.value ? "" : this.base64StrADS;
            dc.i1InitialADS = this.signDocsGroup.controls.initialSignature.value ? this.signDocsGroup.controls.initialSignature.value.trim() : "";

            if (this.message.isCoInventor) {
                dc.i2SignatureADS = this.signDocsGroup.controls.initialCoInvSignature.value ? '' : this.base64StrCoInvADS;
                dc.i2InitialADS = this.signDocsGroup.controls.initialCoInvSignature.value ? this.signDocsGroup.controls.initialCoInvSignature.value.trim() : "";
            } else {
                dc.i2SignatureADS = '';
                dc.i2InitialADS = '';
            }

            dc.signature = "";
            dc.initial = "";
            dc.i2signature = "";
            dc.i2initial = "";
            dc.i1SignatureFinal = "";
            dc.i1InitialFinal = "";
            dc.i2SignatureFinal = "";
            dc.i2InitialFinal = "";
        }
        if (this.isFinalSign) {
            dc.i1SignatureFinal = this.signDocsGroup.controls.initialFinalSignature.value ? '' : this.base64StrFinal;
            dc.i1InitialFinal = !isNullOrUndefined(this.signDocsGroup.controls.initialFinalSignature.value) ? this.signDocsGroup.controls.initialFinalSignature.value.trim() : "";

            if (this.message.isCoInventor) {
                dc.i2SignatureFinal = this.signDocsGroup.controls.initialFinalCoInvSignature.value ? '' : this.base64StrFinalCoInv;
                dc.i2InitialFinal = !isNullOrUndefined(this.signDocsGroup.controls.initialFinalCoInvSignature.value) ? this.signDocsGroup.controls.initialFinalCoInvSignature.value.trim() : "";
            } else {
                dc.i2SignatureFinal = '';
                dc.i2InitialFinal = '';
            }

            dc.signature = "";
            dc.initial = "";
            dc.i2signature = "";
            dc.i2initial = "";
            dc.i1SignatureADS = "";
            dc.i1InitialADS = "";
            dc.i2SignatureADS = "";
            dc.i2InitialADS = "";
        }
        dc.wizardId = 1;
        dc.ipAddress = this.ipAddress;
        this.documentContainer = dc;
    }

    private copyPayFormValuesToDataObject() {
        let bill: BillingDetails = {
            cardToken: "",
            cardApiPrivateKey: "",
            cardApiPublicKey: "",
            cardTxnNotes: "",
            cardTxnReference: "",
            cardTxnStatus: -1,
            inventionName: "",
            ContractSessionId: -1,
            inventionId: -1,
            contractId: -1,
            productId: -1,
            product: "",
            OfficeNumber: -1,
            I1CLPContactId: -1,
            I2CLPContactId: -1,
            CLPUserId: -1,
            WizardId: 0,
            LawfirmId: -1,
            cardAmount: -1,
            fileNumber: '',
            cardHolderName: '',
            txnType: -1,
            chkAmount: false,
            chkFileNumber: false,
            authcode: '',
            avsresponse: '',
            cvvresponse: '',
            firstName: '',
            lastName: '',
            orderid: '',
            response: '',
            responsetext: '',
            response_code: '',
            transactionid: '',
            type: '',
            zip: '',
            ccNumber: '',
            ccExp: '',
            cvv: '',
            custVaultId: '',
            cardType: '',
            contractMultiPaymentId: -1,
            isPaid: false
        }
        this.billingDetails = bill;

        this.billingDetails.firstName = this.collectPaymentGroup.controls.firstName.value;
        this.billingDetails.lastName = this.collectPaymentGroup.controls.lastName.value;
        this.billingDetails.zip = this.collectPaymentGroup.controls.zip.value;
        this.billingDetails.ccNumber = this.collectPaymentGroup.controls.creditCard.value;
        this.billingDetails.ccExp = this.collectPaymentGroup.controls.expirationDate.value;
        this.billingDetails.cvv = this.collectPaymentGroup.controls.cvc.value;

        this.billingDetails.cardToken = this.cardToken;
        this.billingDetails.cardApiPrivateKey = this.stripePrivateKey;
        this.billingDetails.inventionName = this.inventionName;
        this.billingDetails.ContractSessionId = this.contractSessionId;
        this.billingDetails.inventionId = this.contractSession.inventionId;
        this.billingDetails.contractId = this.contractSession.contractId;
        this.billingDetails.productId = this.contractSession.productId;
        this.billingDetails.product = this.productName;
        this.billingDetails.OfficeNumber = this.officeId;
        this.billingDetails.I1CLPContactId = this.contractSession.I1CLPContactId;
        this.billingDetails.I2CLPContactId = this.contractSession.I2CLPContactId;
        this.billingDetails.CLPUserId = this.contractSession.CLPUserId;
        this.billingDetails.WizardId = this.contractSession.WizardId || 1;
        this.billingDetails.LawfirmId = this.contractSession.LawfirmId;
        this.billingDetails.cardAmount = this.message.partialFee;
        this.billingDetails.fileNumber = this.fileNumber;
        this.billingDetails.cardHolderName = this.collectPaymentForm.firstName.value + ' ' + this.collectPaymentForm.lastName.value;
        this.billingDetails.txnType = this.message.paidMode == 'payCreditCard' ? 1 : this.message.paidMode == 'payCheck' ? 3 : this.message.paidMode == 'payMoneyOrder' ? 2 : this.message.paidMode == 'payOther' ? 5 : this.message.paidMode == 'payMonterey' ? 7 : 4;
        this.billingDetails.chkAmount = false;
        this.billingDetails.chkFileNumber = false;
        this.billingDetails.cardType = this.sel_brand ? this.sel_brand : '';
        this.billingDetails.contractMultiPaymentId = this.currentMultiPayId;
    }

    private validateSignatures(): boolean {
        if (this.isCoInventor) {
            if (this.documentID == 1 && ((this.documentContainer.signature == '' && this.documentContainer.initial.trim() == '')
                || (isNullOrUndefined(this.documentContainer.signature) && isNullOrUndefined(this.documentContainer.initial))
                || (this.documentContainer.i2signature == '' && this.documentContainer.i2initial.trim() == '')
                || (isNullOrUndefined(this.documentContainer.i2signature) && isNullOrUndefined(this.documentContainer.i2initial))))
                return false;
            else if ((this.documentID == 3 || (this.documentID == 38)) && ((this.documentContainer.i1SignatureADS == '' && this.documentContainer.i1InitialADS.trim() == '')
                || (isNullOrUndefined(this.documentContainer.i1SignatureADS) && isNullOrUndefined(this.documentContainer.i1InitialADS))
                || (this.documentContainer.i2SignatureADS == '' && this.documentContainer.i2InitialADS.trim() == '')
                || (isNullOrUndefined(this.documentContainer.i2SignatureADS) && isNullOrUndefined(this.documentContainer.i2InitialADS))))
                return false;
            else if (this.isFinalSign && ((this.documentContainer.i1SignatureFinal == '' && this.documentContainer.i1InitialFinal.trim() == '')
                || (isNullOrUndefined(this.documentContainer.i1SignatureFinal) && isNullOrUndefined(this.documentContainer.i1InitialFinal))
                || (this.documentContainer.i2SignatureFinal == '' && this.documentContainer.i2InitialFinal.trim() == '')
                || (isNullOrUndefined(this.documentContainer.i2SignatureFinal) && isNullOrUndefined(this.documentContainer.i2InitialFinal))))
                return false;
        }
        else {
            if (this.documentID == 1 && ((this.documentContainer.signature == '' && this.documentContainer.initial.trim() == '')
                || (isNullOrUndefined(this.documentContainer.signature) && isNullOrUndefined(this.documentContainer.initial))))
                return false;
            else if ((this.documentID == 3 || (this.documentID == 38)) && ((this.documentContainer.i1SignatureADS == '' && this.documentContainer.i1InitialADS.trim() == '')
                || (isNullOrUndefined(this.documentContainer.i1SignatureADS) && isNullOrUndefined(this.documentContainer.i1InitialADS))))
                return false;
            else if (this.isFinalSign && ((this.documentContainer.i1SignatureFinal == '' && this.documentContainer.i1InitialFinal.trim() == '')
                || (isNullOrUndefined(this.documentContainer.i1SignatureFinal) && isNullOrUndefined(this.documentContainer.i1InitialFinal))))
                return false;
        }
        return true;
    }
    private async saveSignature() {
        this.copyFormValuesToDataObject();
        if (!isNullOrUndefined(this.documentContainer)) {
            if (this.isCoInventor) {
                if (this.documentID == 1) {
                    if (isNullOrUndefined(this.documentContainer.i2signature) && isNullOrUndefined(this.documentContainer.i2initial)) {
                        this.openSnackBar("Please sign the document.", "");
                        return;
                    }
                    if (this.documentContainer.i2signature == "" && this.documentContainer.i2initial == "" && !this.isExistSocinv) {
                        this.openSnackBar("Please sign the document.", "");
                        return;
                    }
                    if (this.signaturePadCoInv.isEmpty() && this.signDocsGroup.controls.initialCoInvSignature.value == "" && !this.isExistSocinv) {
                        this.openSnackBar("Please sign the document.", "");
                        return;
                    }
                }
                else if ((this.documentID == 3) || (this.documentID == 38)) {
                    if (isNullOrUndefined(this.documentContainer.i2SignatureADS) && isNullOrUndefined(this.documentContainer.i2InitialADS)) {
                        this.openSnackBar("Please sign the document.", "");
                        return;
                    }
                    if (this.documentContainer.i2SignatureADS == "" && this.documentContainer.i2InitialADS == "" && !this.isExistADSinv) {
                        this.openSnackBar("Please sign the document.", "");
                        return;
                    }
                    if (this.signaturePadCoInv.isEmpty() && this.signDocsGroup.controls.initialCoInvSignature.value == "" && !this.isExistADSinv) {
                        this.openSnackBar("Please sign the document.", "");
                        return;
                    }
                }
                else if (this.isFinalSign) {
                    if (isNullOrUndefined(this.documentContainer.i2SignatureFinal) && isNullOrUndefined(this.documentContainer.i2InitialFinal)) {
                        this.openSnackBar("Please sign the document.", "");
                        return;
                    }
                    if (this.documentContainer.i2SignatureFinal == "" && this.documentContainer.i2InitialFinal == "" && !this.isExistFinalinv) {
                        this.openSnackBar("Please sign the document.", "");
                        return;
                    }
                    if (this.signaturePadFinalCoInv.isEmpty() && this.signDocsGroup.controls.initialFinalCoInvSignature.value == "" && !this.isExistFinalinv) {
                        this.openSnackBar("Please sign the document.", "");
                        return;
                    }

                }
            }

            if (this.documentID == 1) {
                if (isNullOrUndefined(this.documentContainer.signature) && isNullOrUndefined(this.documentContainer.initial)) {
                    this.openSnackBar("Please sign the document.", "");
                    return;
                }
                if (this.documentContainer.signature == "" && this.documentContainer.initial == "" && !this.isExistSoc) {
                    this.openSnackBar("Please sign the document.", "");
                    return;
                }
                if ((this.signaturePad.isEmpty() && this.signDocsGroup.controls.initialSignature.value == "") && !this.isExistSoc) {
                    this.openSnackBar("Please sign the document.", "");
                    return;
                }
            }
            else if ((this.documentID == 3) || (this.documentID == 38)) {
                if (isNullOrUndefined(this.documentContainer.i1SignatureADS) && isNullOrUndefined(this.documentContainer.i1InitialADS)) {
                    this.openSnackBar("Please sign the document.", "");
                    return;
                }
                if (this.documentContainer.i1SignatureADS == "" && this.documentContainer.i1InitialADS == "" && !this.isExistADS) {
                    this.openSnackBar("Please sign the document.", "");
                    return;
                }
                if (this.signaturePad.isEmpty() && this.signDocsGroup.controls.initialSignature.value == "" && !this.isExistADS) {
                    this.openSnackBar("Please sign the document.", "");
                    return;
                }

            }
            else if (this.isFinalSign) {
                if (isNullOrUndefined(this.documentContainer.i1SignatureFinal) && isNullOrUndefined(this.documentContainer.i1InitialFinal)) {
                    this.openSnackBar("Please sign the document.", "");
                    return;
                }
                if (this.documentContainer.i1SignatureFinal == "" && this.documentContainer.i1InitialFinal == "" && !this.isExistFinal) {
                    this.openSnackBar("Please sign the document.", "");
                    return;
                }
                if (this.signaturePadFinal.isEmpty() && this.signDocsGroup.controls.initialFinalSignature.value == "" && !this.isExistFinal) {
                    this.openSnackBar("Please sign the document.", "");
                    return;
                }

            }
            this._documentService.checkSignAsync(this.documentContainer, this.encryptedUser)
                .then(res => {
                    if (res) {
                        this.documentResponse = UtilityService.clone(res);
                        if (this.documentResponse.statusCode == 1) {
                            this._utilityService.showAlertMsg("Sign Confirmation", "Signature could not be capture properly. Please sign it again!");

                            return;
                        }
                        else {
                            let strMsg = "";
                            if (this.validateSignBeforeSave()) {
                                this._documentService.saveDocumentAsync(this.documentContainer, this.encryptedUser)
                                    .then(resp => {
                                        if (resp) {
                                            if (resp.statusCode == 0) {
                                                this._documentService.getDocumentSignatureAsync(this.encryptedUser, this.contractSessionId)
                                                    .then(res => {
                                                        if (res) {
                                                            if (res.statusCode == 0) {
                                                                this.documentSignatureResponse = UtilityService.clone(res);
                                                                this.documentSignature = this.documentSignatureResponse.documentSignature;
                                                                if (this.documentSignature && this.isFinalSign) {
                                                                    strMsg = this.signatureNotSaved();
                                                                    if (strMsg != '') {
                                                                        this.message.signatureType = "signatureNotSaved";
                                                                        this._utilityService.showAlertMsg("Document Signature", strMsg);
                                                                        this.isCustAction = false;
                                                                    }
                                                                    else {
                                                                        this.updateUserStepsAfterAcceptOrSign();
                                                                    }
                                                                } else {
                                                                    this.updateUserStepsAfterAcceptOrSign();
                                                                }
                                                                this.drawClear();
                                                                this.drawClearCoInv();
                                                                this.drawClearFinal();
                                                                this.drawClearFinalCoInv();
                                                            } else {
                                                                console.log("Document Signature result status code: " + res.statusCode);
                                                            }
                                                        }
                                                    })
                                                    .catch((err: HttpErrorResponse) => {
                                                        this._utilityService.handleErrorResponse(err);
                                                    });
                                            } else {
                                                this._utilityService.showAlertMsg("Document Signature", resp.errorMsg);
                                                this.actionDesc = "The signature wasn't saved. Please try again.";
                                                this.isCustAction = false;
                                            }
                                        }
                                    }).catch((err: HttpErrorResponse) => {
                                        this._utilityService.handleErrorResponse(err);
                                    });
                            }
                            else
                                this.openSnackBar("Signature could not captured. Please refresh the contract and sign it again.", "");
                        }
                    }
                })
        }
        else
            this._utilityService.showAlertMsg("Document Signature", "Issue encountered! Please reload the contract and try again.");
    }

    updateUserStepsAfterAcceptOrSign(source?) {
        this.isCustAction = true;
        if (this.documentID == 1 || this.documentID == 3 || this.documentID == 38 || this.isFinalSign)
            this.actionDesc = "signature was saved.";
        else
            this.actionDesc = "document was accepted.";

        if (this.documentID == 24)
            this.navigationDivId = "tdIsInformInventDoc";
        else if (this.documentID == 26)
            this.navigationDivId = "tdIsUniPayDoc";

        this.isSignedSOC = true;

        if (+source == -1 || +source == -999) {
            this.isSUBAccept = true;
            this.openSnackBar("Submission was accepted.", "");
        }
        if (!isNullOrUndefined(source) && !isNumber(source) && (source.startsWith('tdIsAddm') || source == 'tdIsPatentDoc' || source == 'tdIsIntroMarkDoc')) {
            switch (source) {
                case "tdIsAddmBDoc": this.isAddmBAccept = true; break;
                case "tdIsAddmGDoc": this.isAddmGAccept = true; break;
                case "tdIsAddmPDoc": this.isAddmPAccept = true; break;
                case "tdIsAddmTDoc": this.isAddmTAccept = true; break;
                case "tdIsAddmVDoc": this.isAddmVAccept = true; break;
                case "tdIsPatentDoc": this.isPatentAccept = true; break;
                case "tdIsIntroMarkDoc": if (this.productId < 9 || this.productId == 12 || this.productId == 13 || this.productId == 14) { this.isIntroMarkAccept = true; } break;
                default:
            }
            if (!this.isProductV) {
                this.isAddmVAccept = true;
            }

            this.updateUserSteps(source);
            this.openSnackBar(source.substr(4).replace('Doc', '') + " was accepted.", "");
        }
        else {
            if (source != 'tdIsSUBDoc' && +source != -1 && +source != -999)
                $('#modalSignSaved').modal('show');

            this.updateUserSteps(this.navigationDivId);
        }
    }

    signatureNotSaved(): string {
        let strMsg = "";

        if (!isNullOrUndefined(this.documentSignature) && !isNullOrUndefined(this.contractSession)) {
            if (this.isCoInventor) {
                if (this.documentSignature.signature2 == '' && this.documentSignature.initial2 == '' && !this.contractSession.IsSecondContract) {
                    strMsg == '' ? strMsg = "CoInventor SOC" : strMsg += "/CoInventor SOC";
                    this.message.signatureMsg = strMsg;
                }
                if (this.documentSignature.i2SignatureADS == '' && this.documentSignature.i2InitialADS == '' && (this.contractSession.CountryID != 3 && this.contractSession.CountryID != 4 && this.contractSession.CountryID != 6) && !this.contractSession.IsSecondContract) {
                    strMsg == '' ? strMsg = "CoInventor ADS" : strMsg += "/CoInventor ADS";
                    this.message.signatureMsg = strMsg;
                }
                if (this.documentSignature.i2SignatureFinal == '' && this.documentSignature.i2InitialFinal == '') {
                    strMsg == '' ? strMsg = "CoInventor Final" : strMsg += "/CoInventor Final";
                    this.message.signatureMsg = strMsg;
                }
            }

            if (this.documentSignature.signature1 == '' && this.documentSignature.initial1 == '' && !this.contractSession.IsSecondContract) {
                strMsg == '' ? strMsg = "SOC" : strMsg += "/SOC";
                this.message.signatureMsg = strMsg;
            }
            if (this.documentSignature.i1SignatureADS == '' && this.documentSignature.i1InitialADS == '' && (this.contractSession.CountryID != 3 && this.contractSession.CountryID != 4 && this.contractSession.CountryID != 6) && !this.contractSession.IsSecondContract) {
                strMsg == '' ? strMsg = "ADS" : strMsg += "/ADS";
                this.message.signatureMsg = strMsg;
            }
            if (this.documentSignature.i1SignatureFinal == '' && this.documentSignature.i1InitialFinal == '') {
                strMsg == '' ? strMsg = "Final" : strMsg += "/Final";
                this.message.signatureMsg = strMsg;
            }

            if (strMsg != '')
                strMsg = strMsg + " signature is missing. Please inform sales rep to reopen the " + strMsg + " and sign it again.";

        } else {
            strMsg = "Issue encountered! Please reload the contract and try again.";
        }
        if (strMsg != '') {
            if (!isNullOrUndefined(this.navigationResponse)) {
                if (strMsg.includes("SOC"))
                    this.navigationResponse.navigation.isSOCDoc = false;
                if (strMsg.includes("ADS"))
                    this.navigationResponse.navigation.isADSDoc = false;
                if (strMsg.includes("Final"))
                    this.navigationResponse.navigation.isFinalSign = false;
                this.saveNavigationWizard();
            }
        }

        return strMsg;
    }

    validateSignBeforeSave(): boolean {
        let strMsg = "";
        if (!isNullOrUndefined(this.documentContainer)) {
            if (this.documentContainer.signature == '' && this.documentContainer.initial == '' && this.documentContainer.i1SignatureADS == '' && this.documentContainer.i1InitialADS == ''
                && this.documentContainer.i1SignatureFinal == '' && this.documentContainer.i1InitialFinal == '' && this.documentContainer.i2signature == '' && this.documentContainer.i2initial == ''
                && this.documentContainer.i2SignatureADS == '' && this.documentContainer.i2InitialADS == '' && this.documentContainer.i2SignatureFinal == '' && this.documentContainer.i2InitialFinal == '') {
                strMsg == 'Signature could not captured. Please refresh the contract and sign it again.';
            }

        } else {
            strMsg = "Issue encountered! Please reload the contract and try again.";
        }
        if (strMsg != '') {
            if (!isNullOrUndefined(this.navigationResponse)) {
                this.navigationResponse.navigation.isSOCDoc = false;
                this.navigationResponse.navigation.isADSDoc = false;
                this.navigationResponse.navigation.isFinalSign = false;
                this.saveNavigationWizard();
            }
            return false;
        }
        return true;
    }

    async updateUserSteps(divId) {
        await this.loadNavigationWizard();
        if (divId) {
            if (this.navigationResponse) {
                if (this.navigationResponse.navigation) {
                    this.navigationResponse.navigation.clpUserId = this.clpUserId;
                    this.navigationResponse.navigation.contractSessionId = this.contractSessionId;
                    this.navigationResponse.navigation.inventionId = this.inventionId;
                    this.navigationResponse.navigation.dtModified = new Date();

                    //if (!this.isProductV) {
                    //    this.navigationResponse.navigation.isSUBForm = true;
                    //    //this.navigationResponse.navigation.isSUBDoc = true;
                    //    this.navigationResponse.navigation.currentStep = 2;
                    //}

                    switch (divId) {
                        case "tdIsSOCForm":
                            this.navigationResponse.navigation.isSOCForm = true;
                            this.navigationResponse.navigation.currentStep = 1;
                            this.navigationResponse.navigation.isSOCDoc = false;
                            break;
                        case "tdIsSOCDoc":
                            this.navigationResponse.navigation.isSOCDoc = true;
                            this.navigationResponse.navigation.isSOCForm = true;
                            this.navigationResponse.navigation.currentStep = 1;
                            break;
                        case "tdIsADSDoc":
                            this.navigationResponse.navigation.isADSDoc = true;
                            this.navigationResponse.navigation.currentStep = 1;
                            break;
                        case "tdIsSDADoc":
                            this.navigationResponse.navigation.isStateDoc = true;
                            this.navigationResponse.navigation.currentStep = 1;
                            break;
                        case "tdIsProdServicesForm":
                            this.navigationResponse.navigation.isProdServicesForm = true;
                            this.navigationResponse.navigation.currentStep = 2;
                            this.navigationResponse.navigation.isRetailDoc = false;
                            break;
                        case "tdIsNDADoc":
                            this.navigationResponse.navigation.isNDADoc = true;
                            this.navigationResponse.navigation.currentStep = 2;
                            break;
                        case "tdIsWaitDoc":
                            this.navigationResponse.navigation.isWaitDoc = true;
                            this.navigationResponse.navigation.currentStep = 2;
                            break;
                        case "tdIsBIPForm":
                            this.navigationResponse.navigation.isBIPForm = true;
                            this.navigationResponse.navigation.currentStep = 2;
                            this.navigationResponse.navigation.isBIPDoc = false;
                            break;
                        case "tdIsBIPDoc":
                            this.navigationResponse.navigation.isBIPForm = true;
                            this.navigationResponse.navigation.isBIPDoc = true;
                            this.navigationResponse.navigation.currentStep = 3;
                            break;
                        case "tdIsPPSODoc":
                            this.navigationResponse.navigation.isPPSODoc = true;
                            this.navigationResponse.navigation.currentStep = 3;
                            break;
                        case "tdIsInformInventForm":
                            this.navigationResponse.navigation.isInformInventForm = true;
                            this.navigationResponse.navigation.currentStep = 2;
                            this.navigationResponse.navigation.isInformInventDoc = false;
                            break;
                        case "tdIsInformInventDoc":
                            this.navigationResponse.navigation.isInformInventForm = true;
                            this.navigationResponse.navigation.isInformInventDoc = true;
                            this.navigationResponse.navigation.currentStep = 3;
                            break;
                        case "tdIsRetailDoc":
                            this.navigationResponse.navigation.isRetailDoc = true;
                            this.navigationResponse.navigation.currentStep = 3;
                            break;
                        case "tdIsPPADoc":
                            this.navigationResponse.navigation.isPPADoc = true;
                            this.navigationResponse.navigation.currentStep = 3;
                            break;
                        case "tdIsUniPayForm":
                            this.navigationResponse.navigation.isUniPayForm = true;
                            this.navigationResponse.navigation.currentStep = 2;
                            this.navigationResponse.navigation.isUniPayDoc = false;
                            break;
                        case "tdIsUniPayDoc":
                            this.navigationResponse.navigation.isUniPayDoc = true;
                            this.navigationResponse.navigation.isUniPayForm = true;
                            this.navigationResponse.navigation.currentStep = 3;
                            break;
                        case "tdIsPayCollectForm":
                            this.navigationResponse.navigation.isPayCollectForm = true;
                            this.navigationResponse.navigation.currentStep = 4;
                            break;
                        case "tdIsROIForm":
                            this.navigationResponse.navigation.isROIForm = true;
                            this.navigationResponse.navigation.currentStep = 2;
                            this.navigationResponse.navigation.isROIDoc = true;
                            break;
                        case "tdIsROIDoc":
                            this.navigationResponse.navigation.isROIDoc = true;
                            this.navigationResponse.navigation.isROIForm = true;
                            this.navigationResponse.navigation.currentStep = 3;
                            break;
                        case "tdIsCheckListForm":
                            this.navigationResponse.navigation.isCheckListForm = true;
                            this.navigationResponse.navigation.currentStep = 2;
                            this.navigationResponse.navigation.isCheckListDoc = false;
                            break;
                        case "tdIsCheckListDoc":
                            this.navigationResponse.navigation.isCheckListDoc = true;
                            this.navigationResponse.navigation.isCheckListForm = true;
                            this.navigationResponse.navigation.currentStep = 3;
                            break;
                        case "IsPaymentReminder":
                            this.navigationResponse.navigation.IsPaymentReminder = true;
                            break;
                        case "tdIsIMPForm":
                            this.navigationResponse.navigation.isIMPForm = true;
                            this.navigationResponse.navigation.currentStep = 2;
                            this.navigationResponse.navigation.isIMPDoc = false;
                            break;
                        case "tdIsIMPDoc":
                            this.navigationResponse.navigation.isIMPForm = true;
                            this.navigationResponse.navigation.isIMPDoc = true;
                            this.navigationResponse.navigation.currentStep = 2;
                            break;
                        case "tdIsSUBForm":
                            this.navigationResponse.navigation.isSUBForm = true;
                            this.navigationResponse.navigation.currentStep = 2;
                            this.navigationResponse.navigation.isSUBDoc = false;
                            break;
                        case "tdIsSUBDoc":
                            if (this.validateSubmissionServices()) {
                                this.navigationResponse.navigation.isSUBForm = true;
                                this.navigationResponse.navigation.isSUBDoc = true;
                                this.navigationResponse.navigation.currentStep = 2;
                                $('#modalSignSaved').modal('show');
                            }
                            break;
                        case "tdIsAddmBDoc":
                            if (this.validateSubmissionServices()) {
                                this.navigationResponse.navigation.isSUBForm = true;
                                this.navigationResponse.navigation.isSUBDoc = true;
                                this.navigationResponse.navigation.currentStep = 2;
                                $('#modalSignSaved').modal('show');
                            }
                            break;
                        case "tdIsAddmGDoc":
                            if (this.validateSubmissionServices()) {
                                this.navigationResponse.navigation.isSUBForm = true;
                                this.navigationResponse.navigation.isSUBDoc = true;
                                this.navigationResponse.navigation.currentStep = 2;
                                $('#modalSignSaved').modal('show');
                            }
                            break;
                        case "tdIsAddmPDoc":
                            if (this.validateSubmissionServices()) {
                                this.navigationResponse.navigation.isSUBForm = true;
                                this.navigationResponse.navigation.isSUBDoc = true;
                                this.navigationResponse.navigation.currentStep = 2;
                                $('#modalSignSaved').modal('show');
                            }
                            break;
                        case "tdIsAddmTDoc":
                            if (this.validateSubmissionServices()) {
                                this.navigationResponse.navigation.isSUBForm = true;
                                this.navigationResponse.navigation.isSUBDoc = true;
                                this.navigationResponse.navigation.currentStep = 2;
                                $('#modalSignSaved').modal('show');
                            }
                            break;
                        case "tdIsAddmVDoc":
                            if (this.validateSubmissionServices()) {
                                this.navigationResponse.navigation.isSUBForm = true;
                                this.navigationResponse.navigation.isSUBDoc = true;
                                this.navigationResponse.navigation.currentStep = 2;
                                $('#modalSignSaved').modal('show');
                            }
                            break;
                        case "tdIsPatentDoc":
                            if (this.validateSubmissionServices()) {
                                this.navigationResponse.navigation.isSUBForm = true;
                                this.navigationResponse.navigation.isSUBDoc = true;
                                this.navigationResponse.navigation.currentStep = 2;
                                $('#modalSignSaved').modal('show');
                            }
                            break;
                        case "tdIsIntroMarkDoc":
                            if (this.validateSubmissionServices()) {
                                this.navigationResponse.navigation.isSUBForm = true;
                                this.navigationResponse.navigation.isSUBDoc = true;
                                this.navigationResponse.navigation.currentStep = 2;
                                $('#modalSignSaved').modal('show');
                            }
                            break;
                        case "tdIsAddlDoc":
                            this.navigationResponse.navigation.isAddlDoc = true;
                            this.navigationResponse.navigation.currentStep = 2;
                            break;
                        case "tdIsFinalDocuments":
                            this.navigationResponse.navigation.isFinalSign = true;
                            this.navigationResponse.navigation.currentStep = 2;
                            break;
                        default:
                            break;
                    }
                }
            }
            this.saveNavigationWizard(divId);
        }
    }

    private async loadNavigationWizard() {
        await this._navigationService.getNavigationWizardAsync(this.encryptedUser, this.inventionId, this.contractSessionId)
            .then(res => {
                if (res) {
                    if (res.statusCode == 0) {
                        this.navigationResponse = UtilityService.clone(res);
                        if (this.navigationResponse) {
                            this.navigation = this.navigationResponse.navigation;
                        }
                    } else {
                        console.log("Navigation Wizard result status code: " + res.statusCode);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async saveNavigationWizard(divId?: string) {
        if (!isNullOrUndefined(this.navigationResponse) && (this.navigationResponse.navigation.inventionId > 0)) {
            this._navigationService.createNavigationWizardAsync(this.encryptedUser, this.navigationResponse)
                .then(res => {
                    if (res) {
                        this.navigationResponse = UtilityService.clone(res);
                        if (this.isFinalSign)
                            this.updateContractLogObjectModel("", true);
                        else {
                            if ((divId.startsWith('tdIsAddm') || divId == 'tdIsPatentDoc' || divId == 'tdIsIntroMarkDoc'))
                                this.updateContractLogObjectModel(divId, false);
                            else
                                this.updateContractLogObjectModel(this.signedDocId, false);
                        }
                    }
                }).catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    validateSubmissionServices(): boolean {
        if ((this.productId == 3) && !isNullOrUndefined(this.contractActionlog)
            && (this.contractActionlog.dtIntroMarkDoc || this.isIntroMarkAccept) && (this.contractActionlog.dtAddendumDoc || this.isSUBAccept) && (this.message.isAddendumB || this.message.isAddendumG || this.message.isAddendumP)) {
            return this.validateAddendums();
        }
        if ((this.productId == 10) && !isNullOrUndefined(this.contractActionlog)
            && (this.contractActionlog.dtAddendumDoc || this.isSUBAccept) && (this.message.isAddendumB || this.message.isAddendumG || this.message.isAddendumP)) {
            return this.validateAddendums();
        }

        if ((this.productId == 7 || this.productId == 8 || this.productId == 12 || this.productId == 13 || this.productId == 14) && !isNullOrUndefined(this.contractActionlog)
            && (this.contractActionlog.dtIntroMarkDoc || this.isIntroMarkAccept) && (this.contractActionlog.dtAddendumDoc || this.isSUBAccept)
            && (this.contractActionlog.dtPatentDoc || this.isPatentAccept) && (this.message.isAddendumB || this.message.isAddendumG || this.message.isAddendumP)) {
            return this.validateAddendums();
        }
        if ((this.productId == 9) && !isNullOrUndefined(this.contractActionlog)
            && (this.contractActionlog.dtAddendumDoc || this.isSUBAccept)
            && (this.contractActionlog.dtPatentDoc || this.isPatentAccept) && (this.message.isAddendumB || this.message.isAddendumG || this.message.isAddendumP)) {
            return this.validateAddendums();
        }
        //IMP
        if (this.productId == 4 || this.productId == 5) {
            if (this.message.isPatentServices) {
                if (!isNullOrUndefined(this.contractActionlog) && (this.contractActionlog.dtPatentDoc) || this.isPatentAccept)
                    return true;
            }
            //No Patent
            else
                return true;
        }
        //Submission Service
        if (this.productId >= 3 && this.productId <= 14 && this.productId != 6 && this.productId != 11) {
            if ((this.productId == 4 || this.productId == 5) && this.message.isPatentServices && !isNullOrUndefined(this.contractActionlog) && (this.contractActionlog.dtPatentDoc || this.isPatentAccept))
                return true;
            if ((this.productId == 3) && !this.message.isAddendumB && !this.message.isAddendumG && !this.message.isAddendumP && !isNullOrUndefined(this.contractActionlog) && (this.contractActionlog.dtAddendumDoc || this.isSUBAccept) && (this.contractActionlog.dtIntroMarkDoc || this.isIntroMarkAccept))
                return true;
            if (this.productId == 10 && !this.message.isAddendumB && !this.message.isAddendumG && !this.message.isAddendumP && !isNullOrUndefined(this.contractActionlog) && (this.contractActionlog.dtAddendumDoc || this.isSUBAccept))
                return true;
            if ((this.productId == 7 || this.productId == 8 || this.productId == 12 || this.productId == 13 || this.productId == 14) && !this.message.isAddendumB && !this.message.isAddendumG && !this.message.isAddendumP && !isNullOrUndefined(this.contractActionlog) && (this.contractActionlog.dtAddendumDoc || this.isSUBAccept) && (this.contractActionlog.dtIntroMarkDoc || this.isIntroMarkAccept) && (this.contractActionlog.dtPatentDoc || this.isPatentAccept))
                return true;
            if (this.productId == 9 && !this.message.isAddendumB && !this.message.isAddendumG && !this.message.isAddendumP && !isNullOrUndefined(this.contractActionlog) && (this.contractActionlog.dtAddendumDoc || this.isSUBAccept) && (this.contractActionlog.dtPatentDoc || this.isPatentAccept))
                return true;
        }
        else
            return false;
    }

    validateAddendums(): boolean {
        //AddendumB
        if ((this.productId < 9 || this.productId == 12 || this.productId == 13 || this.productId == 14) && this.message.isAddendumB && !this.message.isAddendumG && !this.message.isAddendumP) {
            if (this.contractActionlog.dtAddendumBDoc || this.isAddmBAccept)
                return true;
        }
        //AddendumG
        if (this.message.isAddendumG && !this.message.isAddendumB && !this.message.isAddendumP) {
            if (this.contractActionlog.dtAddendumGDoc || this.isAddmGAccept)
                return true;
        }
        //AddendumP
        if (this.productId < 9 || this.productId == 12 || this.productId == 13 || this.productId == 14) {
            if (this.message.isAddendumP && !this.message.isAddendumG && !this.message.isAddendumB) {
                if ((this.contractActionlog.dtAddendumPDoc || this.isAddmPAccept) && (this.contractActionlog.dtAddendumTDoc || this.isAddmTAccept) && (this.contractActionlog.dtAddendumVDoc || this.isAddmVAccept))
                    return true;
            }
        }
        else {
            if (this.message.isAddendumP && !this.message.isAddendumG && !this.message.isAddendumB) {
                if ((this.contractActionlog.dtAddendumPDoc || this.isAddmPAccept) && (this.contractActionlog.dtAddendumTDoc || this.isAddmTAccept))
                    return true;
            }
        }
        //AddendumB & AddendumG
        if (this.message.isAddendumB && this.message.isAddendumG && !this.message.isAddendumP) {
            if ((this.contractActionlog.dtAddendumBDoc || this.isAddmBAccept) && (this.contractActionlog.dtAddendumGDoc || this.isAddmGAccept))
                return true;
        }
        //AddendumG & AddendumP
        if (this.productId < 9 || this.productId == 12 || this.productId == 13 || this.productId == 14) {
            if (!this.message.isAddendumB && this.message.isAddendumG && this.message.isAddendumP) {
                if ((this.contractActionlog.dtAddendumGDoc || this.isAddmGAccept) && (this.contractActionlog.dtAddendumPDoc || this.isAddmPAccept) && (this.contractActionlog.dtAddendumTDoc || this.isAddmTAccept) && (this.contractActionlog.dtAddendumVDoc || this.isAddmVAccept))
                    return true;
            }
        }
        else {
            if (!this.message.isAddendumB && this.message.isAddendumG && this.message.isAddendumP) {
                if ((this.contractActionlog.dtAddendumGDoc || this.isAddmGAccept) && (this.contractActionlog.dtAddendumPDoc || this.isAddmPAccept) && (this.contractActionlog.dtAddendumTDoc || this.isAddmTAccept))
                    return true;
            }
        }
        //AddendumB & AddendumP
        if (this.productId < 9 || this.productId == 12 || this.productId == 13 || this.productId == 14) {
            if (this.message.isAddendumB && !this.message.isAddendumG && this.message.isAddendumP) {
                if ((this.contractActionlog.dtAddendumBDoc || this.isAddmBAccept) && (this.contractActionlog.dtAddendumPDoc || this.isAddmPAccept) && (this.contractActionlog.dtAddendumTDoc || this.isAddmTAccept) && (this.contractActionlog.dtAddendumVDoc || this.isAddmVAccept))
                    return true;
            }
        }
        else {
            if (this.message.isAddendumB && !this.message.isAddendumG && this.message.isAddendumP) {
                if ((this.contractActionlog.dtAddendumBDoc || this.isAddmBAccept) && (this.contractActionlog.dtAddendumPDoc || this.isAddmPAccept) && (this.contractActionlog.dtAddendumTDoc || this.isAddmTAccept))
                    return true;
            }
        }
        //AddendumB, AddendumG & AddendumP
        if (this.productId < 9 || this.productId == 12 || this.productId == 13 || this.productId == 14) {
            if (this.message.isAddendumB && this.message.isAddendumG && this.message.isAddendumP) {
                if ((this.contractActionlog.dtAddendumBDoc || this.isAddmBAccept) && (this.contractActionlog.dtAddendumGDoc || this.isAddmGAccept) && (this.contractActionlog.dtAddendumPDoc || this.isAddmPAccept) && (this.contractActionlog.dtAddendumTDoc || this.isAddmTAccept) && (this.contractActionlog.dtAddendumVDoc || this.isAddmVAccept))
                    return true;
            }
        }
        else {
            if (this.message.isAddendumB && this.message.isAddendumG && this.message.isAddendumP) {
                if ((this.contractActionlog.dtAddendumBDoc || this.isAddmBAccept) && (this.contractActionlog.dtAddendumGDoc || this.isAddmGAccept) && (this.contractActionlog.dtAddendumPDoc || this.isAddmPAccept) && (this.contractActionlog.dtAddendumTDoc || this.isAddmTAccept))
                    return true;
            }
        }
    }

    updateContractLogObjectModel(Action: string, finalAction: boolean) {
        if (this.contractActionlog) {
            if (finalAction) {
                this.contractActionlog.audiFlag = this.contractActionlog.dtContractSign || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                this.contractActionlog.finalActionFlag = "contractSign";
            }
            switch (Action) {
                case "socSubmit":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtSOCForm || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "socSubmit";
                    break;
                case "socDocSign":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtSOCDoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "socDocSign";
                    break;
                case "adsDocSign":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtADSDoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "adsDocSign";
                    break;
                case "stateDocSign":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtStateDoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "stateDocSign";
                    break;
                case "ndaDocSign":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtNDADoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "ndaDocSign";
                    break;
                case "waitStateDocSign":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtWaitDoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "waitStateDocSign";
                    break;
                case "bipFormSubmit":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtBIPForm || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "bipFormSubmit";
                    break;
                case "bipDocSign":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtBIPDoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "bipDocSign";
                    break;
                case "ppsoDocsign":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtPPSODoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "ppsoDocsign";
                    break;
                case "retailInstallmentDocSign":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtRetailDoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "retailInstallmentDocSign";
                    break;
                case "ppaDocSign":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtPPADoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "ppaDocSign";
                    break;
                case "inventFormSubmit":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtInformInventForm || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "inventFormSubmit";
                    break;
                case "inventDocSign":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtInformInventDoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "inventDocSign";
                    break;
                case "uniPayFormSubmit":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtUniPayForm || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "uniPayFormSubmit";
                    break;
                case "uniPayDocSign":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtUniPayDoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "uniPayDocSign";
                    break;

                case "roiFormSubmit":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtROIForm || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "roiFormSubmit";
                    break;
                case "roiDocSign":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtROIDoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "roiDocSign";
                    break;
                case "payCollectionFormSubmit":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtPayCollectForm || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "payCollectionFormSubmit";
                    break;
                case "payReminder":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtPaymentReminder || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "payReminder";
                    break;
                case "sendToCorp":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtSendCrop || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "sendToCorp";
                    break;
                case "cancelled":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtCancel || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "cancelled";
                    break;
                case "addendumSubmit":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtAddendumForm || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "addendumSubmit";
                    break;
                case "subDocSign":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtAddendumDoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "subDocSign";
                    break;
                case "tdIsAddmBDoc":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtAddendumBDoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "addmBDocSign";
                    break;
                case "tdIsAddmGDoc":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtAddendumGDoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "addmGDocSign";
                    break;
                case "tdIsAddmPDoc":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtAddendumPDoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "addmPDocSign";
                    break;
                case "tdIsAddmTDoc":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtAddendumTDoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "addmTDocSign";
                    break;
                case "tdIsAddmVDoc":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtAddendumVDoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "addmVDocSign";
                    break;
                case "tdIsPatentDoc":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtPatentDoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "patentDocSign";
                    break;
                case "tdIsIntroMarkDoc":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtIntroMarkDoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "introMarkDocSign";
                    break;
                case "impSubmit":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtIMPForm || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "impSubmit";
                    break;
                case "impDocSign":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtIMPDoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "impDocSign";
                    break;
                case "additionalDocSign":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtAdditionalDoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "additionalDocSign";
                    break;
                case "checkListFormSubmit":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtCheckListForm || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "checkListFormSubmit";
                    break;
                case "checkListDocSign":
                    this.contractActionlog.audiFlag = this.contractActionlog.dtCheckListDoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                    this.contractActionlog.actionFlag = "checkListDocSign";
                    break;
                default:
                    break;
            }
            this.contractActionlog.modifiedBy = this.clpUserId;
            this.saveContrActionAcitonLog(Action);
        }
    }

    async saveContrActionAcitonLog(doc?: string) {
        this.contractActionlog.contractSessionId = this.contractSessionId;
        if ((this.inventionId <= 0) || (isNullOrUndefined(this.inventionId))) {
            this._route.paramMap.subscribe(async params => {
                if (params.has('invention')) {
                    this.inventionId = +params.get('invention');
                }
            });
        }
        this.contractActionlog.inventionId = this.inventionId;
        await this._contractActionLogService.updateContractActionLog(this.encryptedUser, this.contractActionlog)
            .then(res => {
                if (res) {
                    if (doc == 'subDocSign')
                        this.loadDocument_DocTypeId(-1);
                    if (!isNullOrUndefined(doc) && (doc.startsWith('tdIsAddm') || doc == 'tdIsPatentDoc' || doc == 'tdIsIntroMarkDoc')) {
                        var docId;
                        switch (doc) {
                            case 'tdIsAddmBDoc': docId = this.message.isWestern && this.countryID < 2 ? 89 : 88; break;
                            
                            case 'tdIsAddmGDoc': docId = this.productId == 14 ? this.message.isWestern && this.countryID < 2 ? 146 : 143 : this.message.isWestern && this.countryID < 2 ? 87 : 86; break;
                            case 'tdIsAddmPDoc': docId = this.message.isWestern && this.countryID < 2 ? 85 : 84; break;
                            case 'tdIsAddmTDoc': docId = this.productId == 14 ? this.message.isWestern && this.countryID < 2 ? 147 : 144 : this.message.isWestern && this.countryID < 2 ? 138 : 137; break;
                            case 'tdIsAddmVDoc': docId = this.message.isWestern && this.countryID < 2 ? 140 : 139; break;
                            case 'tdIsPatentDoc': if (this.message.productId == 4) docId = this.message.isWestern && this.countryID < 2 ? 125 : 124;
                                if (this.message.productId == 5) docId = this.message.isWestern && this.countryID < 2 ? 136 : 134;
                                else docId = this.productId == 14 ? this.message.isWestern && this.countryID < 2 ? 148 : 145 : this.message.isWestern && this.countryID < 2 ? 83 : 82;
                                break;
                            case 'tdIsIntroMarkDoc': docId = this.message.isWestern && this.countryID < 2 ? 93 : 94; break;
                            default: break;
                        }
                        this.loadDocument_DocTypeId(docId);
                    }
                    if (doc == 'tdIsAddmPDoc')
                        this.loadOptionalServiceDocument(this.productId == 14 ? this.message.isWestern && this.countryID < 2 ? "85,147,140" : "84,144,139" : this.message.isWestern && this.countryID < 2 ? "85,138,140" : "84,137,139");
                    this.contractActionlog = UtilityService.clone(res);
                    this.isCustAction = true;
                    this.sendMessage();
                    this.loadContractActionlog(this.contractSessionId);
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    async loadContractActionlog(contractSessionId: number) {
        await this._contractActionLogService.getContractActionLog(this.encryptedUser, this.contractSessionId)
            .then(res => {
                if (res) {
                    this.contractActionlog = UtilityService.clone(res);
                    if (!isNullOrUndefined(this.contractActionlog))
                        this.isFinalSignWait = this.contractActionlog.isFinalSign;
                    this.loadAddendumServices();
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async loadAddendumServices() {
        await this._addendumService.AddendumServices_GetAsync(this.encryptedUser, this.inventionId, this.contractSessionId)
            .then(res => {
                if (res) {
                    if (res.statusCode == 0) {
                        this.addendumServicesResponse = UtilityService.clone(res);
                        this.addendum = this.addendumServicesResponse.addendum;
                        if (this.productId < 9 || this.productId == 12 || this.productId == 13 || this.productId == 14)
                            this.isAddmBAccept = this.addendumServicesResponse.addendum.isAddendumB && this.contractActionlog.dtAddendumBDoc ? true : false;
                        else
                            this.isAddmBAccept = this.contractActionlog.dtAddendumBDoc ? true : false;
                        this.isAddmGAccept = this.addendumServicesResponse.addendum.isAddendumG && this.contractActionlog.dtAddendumGDoc ? true : false;
                        this.isAddmPAccept = this.addendumServicesResponse.addendum.isAddendumP && this.contractActionlog.dtAddendumPDoc ? true : false;
                        this.isAddmTAccept = this.addendumServicesResponse.addendum.isAddendumP && this.contractActionlog.dtAddendumTDoc ? true : false;
                        if (this.productId < 9 || this.productId == 12 || this.productId == 13 || this.productId == 14) {
                            this.isAddmVAccept = this.addendumServicesResponse.addendum.isAddendumP && this.contractActionlog.dtAddendumVDoc ? true : false;
                            this.isIntroMarkAccept = this.contractActionlog.dtIntroMarkDoc ? true : false;
                        }
                        this.isShowPatent = this.addendumServicesResponse.addendum.isPatentServices;
                        this.isPatentAccept = this.isShowPatent && this.contractActionlog.dtPatentDoc ? true : false;
                        this.isSUBAccept = this.contractActionlog.dtAddendumDoc ? true : false;
                    } else {
                        console.log("Addendum services result status code: " + res.statusCode);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    public signataurePadOptions = {
        'minWidth': 1,
        'maxWidth': 2,
        penColor: 'black',
        backgroundColor: '#fff',
    };

    public signataurePadOptionsFinal = {
        'minWidth': 1,
        'maxWidth': 2,
        penColor: 'black',
        backgroundColor: '#fff',
    };

    drawClear(): boolean {
        this.signaturePad.clear();
        this.base64Str = "";
        this.base64StrADS = "";
        if (!isNullOrUndefined(this.documentContainer)) {
            this.documentContainer.signature = "";
            this.documentContainer.i1SignatureADS = "";

        }

        this.documentSignature.signature1 = "";
        this.documentSignature.i1SignatureADS = "";
        this.titleMsg = '';
        this.isExistSoc = false;
        this.isExistADS = false;
        this.signaturePad.on();
        this.initialDisabled = false;
        this.signDocsGroup.patchValue({
            initialSignature: ''
        });
        return false;
    }

    drawClearCoInv(): boolean {
        this.signaturePadCoInv.clear();
        this.base64Str = "";
        this.base64StrADS = "";
        if (!isNullOrUndefined(this.documentContainer)) {
            this.documentContainer.i2signature = "";
            this.documentContainer.i2SignatureADS = "";

        }
        this.documentSignature.signature2 = "";
        this.documentSignature.i2SignatureADS = "";
        this.titleMsgInv = '';
        this.isExistSocinv = false;
        this.isExistADSinv = false;
        this.signaturePadCoInv.on();
        this.initialCoInvDisabled = false;
        this.signDocsGroup.patchValue({
            initialCoInvSignature: ''
        });
        return false;
    }

    drawClearFinal(): boolean {
        this.signaturePadFinal.clear();
        if (!isNullOrUndefined(this.documentContainer))
            this.documentContainer.i1SignatureFinal = "";
        this.documentSignature.i1SignatureFinal = "";
        this.base64Str = "";
        this.base64StrADS = "";
        this.titleMsg = '';
        this.isExistFinal = false;
        this.signaturePadFinal.on();
        this.initialFinalDisabled = false;
        this.signDocsGroup.patchValue({
            initialFinalSignature: ''
        });
        return false;
    }

    drawClearFinalCoInv(): boolean {
        this.signaturePadFinalCoInv.clear();
        this.base64Str = "";
        this.base64StrADS = "";
        if (!isNullOrUndefined(this.documentContainer))
            this.documentContainer.i2SignatureFinal = "";
        this.documentSignature.i2SignatureFinal = "";
        this.isExistFinalinv = false;
        this.titleMsgInv = '';
        this.signaturePadFinalCoInv.on();
        this.initialFinalCoInvDisabled = false;
        this.signDocsGroup.patchValue({
            initialFinalCoInvSignature: ''
        });
        return false;
    }

    mandateDocSign(source?) {
        if ((this.documentID == 1) || (this.documentID == 3) || (this.documentID == 38) || (this.isFinalSign))
            this.saveSignature();
        else
            this.updateUserStepsAfterAcceptOrSign(source);
    }

    maskI1SSN(e) {
        let actualVal: string = "";
        let stars: string = "";
        let res: string = "";

        if (e.key == "Backspace" || e.key == "Delete") {
            if (!this.showSSnDiv)
                this._i1SSN = "";
            else
                this._i1SSN = $('#i1SSN').val();

            this.i1SSNMaskPatch(this._i1SSN, this._i1SSN);
            this.isFormAction = true;
        }
        if ((e.key >= 0 && e.key <= 9) && (this._i1SSN != null && this._i1SSN.length < 9) /*|| ((e.key == "Backspace") || (e.key == "Delete"))*/) {
            this._i1SSN += e.key;
            var len = this._i1SSN.length;
            var max = 9;
            if (len == 1)
                stars = 'X';
            else if (len == 2)
                stars = 'XX';
            else if (len == 3)
                stars = 'XXX';
            else if (len == 4)
                stars = 'XXX-X';
            else if (len == 5)
                stars = 'XXX-XX';
            else if (len >= 6)
                stars = 'XXX-XX-' + this._i1SSN.substring(5);
            this.i1SSNMaskPatch(stars, this._i1SSN);
        }
    }

    i1SSNMaskPatch(ssnMask, ssnNoMask) {
        this.signDocsGroup.patchValue({
            i1SSNMask: this.getSSNMaskString(ssnMask),
            i1SSN: ssnNoMask
        });
        this.sendMessage();
    }

    getSSNMaskString(val) {
        let stars: string = "";
        let _val: string = "";
        if (val != null) {
            let res: string = "";
            _val = val.replace(/[-]/g, "");
            var len = _val.length;
            var max = 9;
            if (len == 1)
                stars = 'X';
            else if (len == 2)
                stars = 'XX';
            else if (len == 3)
                stars = 'XXX';
            else if (len == 4)
                stars = 'XXX-X';
            else if (len == 5)
                stars = 'XXX-XX';
            else if (len >= 6)
                stars = 'XXX-XX-' + _val.substring(5);
        }
        return stars;
    }

    replaceSSN(val) {
        if (val) {
            let unmaskVal = val.substr(5);
            return 'XXX-XX-' + unmaskVal;
        }
        else
            return '';
    }

    i1SSNPatch(ssnVal) {
        this.signDocsGroup.patchValue({

            i1SSNMask: this.getSSNMaskString(this._i1SSN),
            i1SSN: this._i1SSN

        });
    }

    SSNeyeopen() {

        let i1SSN: string = $("#i1SSN").val();
        var chars = i1SSN.split('-');
        var str = "";
        for (var i = 0; i < chars.length; i++) {
            str = str + chars[i].toString();
        }

        let maskedString: string = this.getSSNMaskString(str);
        if (this.showSSnDiv) {
            this.signDocsGroup.patchValue({
                i1SSNMask: maskedString
            });
        }
        this.showSSnDiv = !this.showSSnDiv;
        this._i1SSN = "";
        this.isSSNMask = !this.isSSNMask;
    }

    private async loadInventorInformation() {
        await this._infoCollectService.InventorInvention_GetAsync(this.encryptedUser, this.inventionId, this.contractSessionId)
            .then(res => {
                if (res) {
                    if (res.statusCode == 0) {
                        this.inventorInformationResponse = UtilityService.clone(res);
                        this.inventorInformation = this.inventorInformationResponse.inventorInformation;
                        if (this.inventorInformation.id > 0)
                            this.copyDataObjectToInfoCollectValues();
                    } else {
                        console.log("InventorInvention result status code: " + res.statusCode);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async loadUniversalPayment() {
        await this._infoCollectService.UniversalPayment_GetAsync(this.encryptedUser, this.inventionId, this.contractSessionId)
            .then(res => {
                if (res) {
                    if (res.statusCode == 0) {
                        this.universalPaymentResponse = UtilityService.clone(res);
                        this.universalPayment = this.universalPaymentResponse.universalPayment;

                        if (this.universalPayment.id == 0)
                            this.universalPayment.chkSaveAc = true;

                        this.copyDataObjectToInfoCollectValues();
                    } else {
                        console.log("Universal Payment result status code: " + res.statusCode);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async loadContractMultiPayment() {
        await this._billingService.getContractMultiPaymentAsync(this.encryptedUser, this.contractSessionId)
            .then(res => {
                if (res) {
                    if (res.statusCode == 0) {
                        this.contractMultiPaymentResponse = UtilityService.clone(res);
                        this.contractMultiPayments = this.contractMultiPaymentResponse.contractMultiPayment;
                        this.copyDataObjectToPayFormValues();
                    } else {
                        console.log("Contract MultiPayment result status code: " + res.statusCode);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private copyDataObjectToPayFormValues() {
        this.collectPaymentGroup.patchValue({
            paymentType: false,
            fileNo: false,
        });
        if (this.contractMultiPayments.length > 0) {
            this.collectPaymentGroup.patchValue({
                chkBankName: this.contractMultiPayments[0].chkBankName || '',
                chkCity: this.contractMultiPayments[0].chkCity || '',
                chkState: this.contractMultiPayments[0].chkState || '',
                chkRoutingNo: this.contractMultiPayments[0].chkRoutingNo || '',
                chkAccNo: this.contractMultiPayments[0].chkAccNo || '',
                chkNumber: this.contractMultiPayments[0].chkNumber || '',
                bankAccountName: this.contractMultiPayments[0].bankAccountName || '',
            });
            $("#chkDate").val(this.contractMultiPayments[0].chkDate);
        }
    }

    private copyDataObjectToInfoCollectValues() {
        if (this.inventorInformation) {
            /*Information For InventHelp - Buyer*/
            $("#i1DOB").val(this.inventorInformation.i1DOB);

            if (this.inventorInformation.i1SSN)
                this._i1SSN = this.inventorInformation.i1SSN;

            this.signDocsGroup.patchValue({
                i1SSN: this.inventorInformation.i1SSN != "" ? this.inventorInformation.i1SSN : '',
                i1SSNMask: this.inventorInformation.i1SSN != "" ? this.getSSNMaskString(this.inventorInformation.i1SSN) : '',

            })
        }
        if (this.universalPayment) {
            var altAmount = this.universalPayment.altAmount ? this.universalPayment.altAmount : 0;
            this.convertNumberToCurrency(altAmount, 'altAmount');

            this.signDocsGroup.patchValue({
                chkSaveAc: this.universalPayment.chkSaveAc || '',
                bankName: this.universalPayment.bankName || '',
                ABANo: this.universalPayment.ABANo || '',
                chkAcNo: this.universalPayment.chkAcNo || '',
                accountType: this.universalPayment.accountType || '-1',
                chkCCard: this.universalPayment.chkCCard || '',
                cCardNo: this.universalPayment.cCardNo || '',
                cCardExpDT: this.universalPayment.cCardExpDT || '',
                cCardCVV: this.universalPayment.cCardCVV || '',
                altDayMonth: this.universalPayment.altDayMonth || '',
                chkNoAutoPay: this.universalPayment.chkNoAutoPay || '',
            });

            if (this.universalPayment.chkSaveAc == true) {
                this.divPaySaveAc = true;
                this.divPayCard = this.countryID < 3 ? false : true;
                this.divNoAutoPay = false;
            }
            else if (this.universalPayment.chkCCard == true) {
                this.divPaySaveAc = false;
                this.divPayCard = this.countryID < 3 ? true : false;
                this.divNoAutoPay = false;
            }
            else if (this.universalPayment.chkNoAutoPay == true) {
                this.divPaySaveAc = false;
                this.divPayCard = false;
                this.divNoAutoPay = true;
                this.hideOptionalDoc = true;
            }
        }

        if (this.inventionCheckListResponse) {

            this.signDocsGroup.patchValue({
                isSubmitYes: this.inventionCheckListResponse.inventionCheckList.isSubmit == true ? true : false,
                isSubmitNo: this.inventionCheckListResponse.inventionCheckList.isSubmit == true ? false : this.inventionCheckListResponse.inventionCheckList.isSubmit == false ? true : false,

                isAcceptYes: this.inventionCheckListResponse.inventionCheckList.isAccept == true ? true : false,
                isAcceptNo: this.inventionCheckListResponse.inventionCheckList.isAccept == true ? false : this.inventionCheckListResponse.inventionCheckList.isAccept == false ? true : false,

                isDataBankYes: this.inventionCheckListResponse.inventionCheckList.isDataBank == true ? true : false,
                isDataBankNo: this.inventionCheckListResponse.inventionCheckList.isDataBank == true ? false : this.inventionCheckListResponse.inventionCheckList.isDataBank == false ? true : false,

                isSolicitsYes: this.inventionCheckListResponse.inventionCheckList.isSolicits == true ? true : false,
                isSolicitsNo: this.inventionCheckListResponse.inventionCheckList.isSolicits == true ? false : this.inventionCheckListResponse.inventionCheckList.isSolicits == false ? true : false,

                isPrepareYes: this.inventionCheckListResponse.inventionCheckList.isPrepare == true ? true : false,
                isPrepareNo: this.inventionCheckListResponse.inventionCheckList.isPrepare == true ? false : this.inventionCheckListResponse.inventionCheckList.isPrepare == false ? true : false,

                isStaffYes: this.inventionCheckListResponse.inventionCheckList.isStaff == true ? true : false,
                isStaffNo: this.inventionCheckListResponse.inventionCheckList.isStaff == true ? false : this.inventionCheckListResponse.inventionCheckList.isStaff == false ? true : false,

                isBIPSYes: this.inventionCheckListResponse.inventionCheckList.isBIPS == true ? true : false,
                isBIPSNo: this.inventionCheckListResponse.inventionCheckList.isBIPS == true ? false : this.inventionCheckListResponse.inventionCheckList.isBIPS == false ? true : false,

                isPRSYes: this.inventionCheckListResponse.inventionCheckList.isPRS == true ? true : false,
                isPRSNo: this.inventionCheckListResponse.inventionCheckList.isPRS == true ? false : this.inventionCheckListResponse.inventionCheckList.isPRS == false ? true : false,

                isSoldYes: this.inventionCheckListResponse.inventionCheckList.isSold == true ? true : false,
                isSoldNo: this.inventionCheckListResponse.inventionCheckList.isSold == true ? false : this.inventionCheckListResponse.inventionCheckList.isSold == false ? true : false,

                isSendYes: this.inventionCheckListResponse.inventionCheckList.isSend == true ? true : false,
                isSendNo: this.inventionCheckListResponse.inventionCheckList.isSend == true ? false : this.inventionCheckListResponse.inventionCheckList.isSend == false ? true : false,

                isIdeasYes: this.inventionCheckListResponse.inventionCheckList.isIdeas == true ? true : false,
                isIdeasNo: this.inventionCheckListResponse.inventionCheckList.isIdeas == true ? false : this.inventionCheckListResponse.inventionCheckList.isIdeas == false ? true : false,

                isShowsYes: this.inventionCheckListResponse.inventionCheckList.isShows == true ? true : false,
                isShowsNo: this.inventionCheckListResponse.inventionCheckList.isShows == true ? false : this.inventionCheckListResponse.inventionCheckList.isShows == false ? true : false,

                isWorkBrochureYes: this.inventionCheckListResponse.inventionCheckList.isWorkBrochure == true ? true : false,
                isWorkBrochureNo: this.inventionCheckListResponse.inventionCheckList.isWorkBrochure == true ? false : this.inventionCheckListResponse.inventionCheckList.isWorkBrochure == false ? true : false,

                isBIPYes: this.inventionCheckListResponse.inventionCheckList.isBIP == true ? true : false,
                isBIPNo: this.inventionCheckListResponse.inventionCheckList.isBIP == true ? false : this.inventionCheckListResponse.inventionCheckList.isBIP == false ? true : false,

                isBIPReportYes: this.inventionCheckListResponse.inventionCheckList.isBIPReport == true ? true : false,
                isBIPReportNo: this.inventionCheckListResponse.inventionCheckList.isBIPReport == true ? false : (this.inventionCheckListResponse.inventionCheckList.isBIPReport == false && this.inventionCheckListResponse.inventionCheckList.isNABIPReport == false) ? true : false,

                isNABIPReport: this.inventionCheckListResponse.inventionCheckList.isNABIPReport || '',

                isServiceFeesYes: this.inventionCheckListResponse.inventionCheckList.isServiceFees == true ? true : false,
                isServiceFeesNo: this.inventionCheckListResponse.inventionCheckList.isServiceFees == true ? false : this.inventionCheckListResponse.inventionCheckList.isServiceFees == false ? true : false,

                isADSYes: this.inventionCheckListResponse.inventionCheckList.isADS == true ? true : false,
                isADSNo: this.inventionCheckListResponse.inventionCheckList.isADS == true ? false : this.inventionCheckListResponse.inventionCheckList.isADS == false ? true : false,

                isNDAYes: this.inventionCheckListResponse.inventionCheckList.isNDA == true ? true : false,
                isNDANo: this.inventionCheckListResponse.inventionCheckList.isNDA == true ? false : this.inventionCheckListResponse.inventionCheckList.isNDA == false ? true : false,

                isPRSBrochureYes: this.inventionCheckListResponse.inventionCheckList.isPRSBrochure == true ? true : false,
                isPRSBrochureNo: this.inventionCheckListResponse.inventionCheckList.isPRSBrochure == true ? false : this.inventionCheckListResponse.inventionCheckList.isPRSBrochure == false ? true : false,

                isPPSOYes: this.inventionCheckListResponse.inventionCheckList.isPPSO == true ? true : false,
                isPPSONo: this.inventionCheckListResponse.inventionCheckList.isPPSO == true ? false : (this.inventionCheckListResponse.inventionCheckList.isPPSO == false && this.inventionCheckListResponse.inventionCheckList.isNAPPSO == false) ? true : false,

                isNAPPSO: this.inventionCheckListResponse.inventionCheckList.isNAPPSO || '',
                comments: this.inventionCheckListResponse.inventionCheckList.comments || '',
                bestTimeToReach: this.inventionCheckListResponse.inventionCheckList.bestTimeToReach || '',


                isSolicitYes: this.inventionCheckListResponse.inventionCheckList.isSolicitYes == true ? true : false,
                isSolicitNo: this.inventionCheckListResponse.inventionCheckList.isSolicitYes == true ? false : this.inventionCheckListResponse.inventionCheckList.isSolicitYes == false ? true : false,

                isRefineYes: this.inventionCheckListResponse.inventionCheckList.isRefineYes == true ? true : false,
                isRefineNo: this.inventionCheckListResponse.inventionCheckList.isRefineYes == true ? false : this.inventionCheckListResponse.inventionCheckList.isRefineYes == false ? true : false,

                isIndependentYes: this.inventionCheckListResponse.inventionCheckList.isIndependentYes == true ? true : false,
                isIndependentNo: this.inventionCheckListResponse.inventionCheckList.isIndependentYes == true ? false : this.inventionCheckListResponse.inventionCheckList.isIndependentYes == false ? true : false,

                isAttorneyYes: this.inventionCheckListResponse.inventionCheckList.isAttorneyYes == true ? true : false,
                isAttorneyNo: this.inventionCheckListResponse.inventionCheckList.isAttorneyYes == true ? false : this.inventionCheckListResponse.inventionCheckList.isAttorneyYes == false ? true : false,

                isPurchasedYes: this.inventionCheckListResponse.inventionCheckList.isPurchasedYes == true ? true : false,
                isPurchasedNo: this.inventionCheckListResponse.inventionCheckList.isPurchasedYes == true ? false : this.inventionCheckListResponse.inventionCheckList.isPurchasedYes == false ? true : false,
            })
        }
    }

    showInputContract() {
        this.isCustAction = true;
        this.sendMessage();
    }

    showCardInput(e, dvId) {
        this.isCustAction = true;
        this.sendMessage();
    }

    infoInventorSubmit(): void {
        var repAltAmount = this.signDocsGroup.controls.altAmount.value;
        repAltAmount = repAltAmount ? repAltAmount.toString().replace(this.currencySterling, "").replace(",", "") : 0;
        this.signDocsGroup.patchValue({
            altAmount: repAltAmount,
        });
        this.validateAllFormFields(this.signDocsGroup);
        if (this.signDocsGroup.valid) {
            this.signDocsGroup.markAsPristine();
            this.copyInfoCollectValuesToDataObject("InfoInvent");
        }
    }

    validateAllFormFields(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            if (control && field == "cCardNo" && control.value.length >= 14) {
                control.clearValidators();
            }
            if (control && field == "creditCard" && control.value.length >= 14) {
                control.clearValidators();
            }
            if (formGroup.status == "INVALID") {
                if (formGroup.controls.creditCard) {
                    if ((formGroup.controls.creditCard.status == "INVALID") && (formGroup.controls.creditCard.value.length < 14)) {
                        this.openSnackBar("Card number must be 14-20 digits long", "");
                    }
                }
                else
                    this.openSnackBar("Form has Invalid Data. Please check your inputs and save again !", "");
            }
            if (control instanceof FormControl) {
                control.markAsTouched();
                control.updateValueAndValidity();
            } else if (control instanceof FormGroup) {
                this.validateAllFormFields(control);
            }
        });
    }

    private CreateUpdate_ContractSession() {
        this.contractSession.CLPUserId = this.clpUserId;
        this._contractSessionService.createContactSessionAsync(this.encryptedUser, this.contractSession)
            .then(res => {
                if (res) {
                    this.contractSession = UtilityService.clone(res);
                    this.contractSessionId = this.contractSession.ContractSessionId;
                    this.loadContractSession();
                }
            }).catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private copyInfoCollectValuesToDataObject(frmName) {
        this.contractSession.sendToCorp = false;
        this.contractSession.productId = this.productId;
        this.CreateUpdate_ContractSession();
        if (this.inventorInformation && frmName == "InfoInvent") {
            if (this.inventionId > 0)
                this.inventorInformation.inventionId = this.inventionId;

            if (this.contractSessionId > 0)
                this.inventorInformation.contractSessionId = this.contractSessionId;

            this.inventorInformation.i1CLPContactId = this.contactDetails.contactid;
            this.inventorInformation.i2CLPContactId = this.contactDetails.contactid1;

            /*Information For InventHelp - Buyer*/
            this.inventorInformation.i1DOB = $("#i1DOB").val() || '';
            this.inventorInformation.i1SSN = this.signDocsGroup.controls.i1SSN.value || '';

            this.inventorInformation.i1AddressYear = 0;
            this.inventorInformation.i1AddressMonth = 0;

            this.inventorInformation.i1HomeType = 1;

            this.inventorInformation.i1PreviousHomeAdd = '';
            this.inventorInformation.i1PreviousHomeCity = '';
            this.inventorInformation.i1PreviousHomeState = '';
            this.inventorInformation.i1PreviousHomeZip = '';
            this.inventorInformation.i1PreviousAddYear = 0;
            this.inventorInformation.i1PreviousAddMonth = 0;

            this.inventorInformation.i1PresentPosition = '';
            this.inventorInformation.i1PresentEmp = '';
            this.inventorInformation.i1PresentEmpYear = 0;
            this.inventorInformation.i1PresentEmpMonth = 0;
            this.inventorInformation.i1PresentMonthlyInc = 0;

            this.inventorInformation.i1BusinessAdd = '';
            this.inventorInformation.i1BusinessHomeCity = '';
            this.inventorInformation.i1BusinessHomeState = '';
            this.inventorInformation.i1BusinessHomeZip = '';

            this.inventorInformation.i1BusinessPhone = '';

            this.inventorInformation.i1PreviousEmpName = '';
            this.inventorInformation.i1PreviousEmpPos = '';
            this.inventorInformation.i1PreviousEmpAdd = '';
            this.inventorInformation.i1PreviousEmpYear = 0;
            this.inventorInformation.i1PreviousEmpMonth = 0;
            this.inventorInformation.i1PreviousMonthlyInc = 0;

            this.inventorInformation.i1MonthlytOtherInc = 0;
            this.inventorInformation.iI1MonthlyOtherIncSrc = '';

            this.inventorInformation.i1RelativeName = '';
            this.inventorInformation.i1RelativeAdd = '';
            this.inventorInformation.i1RelativeCity = '';
            this.inventorInformation.i1RelativeState = '';
            this.inventorInformation.i1RelativeRelation = '';
            this.inventorInformation.i1RelativePhone = '';

            /*Information For InventHelp - Co-Buyer*/

            this.inventorInformation.i2DOB = '';
            this.inventorInformation.i2SSN = '';
            this.inventorInformation.i2PresentHomeAdd1 = '';
            this.inventorInformation.i2PresentHomeAdd2 = '';
            this.inventorInformation.i2PresentHomeCity = '';
            this.inventorInformation.i2PresentHomeState = '';
            this.inventorInformation.i2PresentHomeZip = '';
            this.inventorInformation.i2PresentPhone = '';
            this.inventorInformation.i2RelationshipI1 = '';

            this.inventorInformation.i2PresentPosition = '';
            this.inventorInformation.i2PresentEmp = '';
            this.inventorInformation.i2PresentEmpYear = 0;
            this.inventorInformation.i2PresentEmpMonth = 0;
            this.inventorInformation.i2PresentMonthlyInc = 0;

            this.inventorInformation.i2BusinessAdd = '';
            this.inventorInformation.i2BusinessHomeCity = '';
            this.inventorInformation.i2BusinessHomeState = '';
            this.inventorInformation.i2BusinessHomeZip = '';
            this.inventorInformation.i2BusinessPhone = '';

            this.inventorInformation.i2PreviousEmpName = '';
            this.inventorInformation.i2PreviousEmpPos = '';
            this.inventorInformation.i2PreviousEmpAdd = '';
            this.inventorInformation.i2PreviousEmpYear = 0;
            this.inventorInformation.i2PreviousEmpMonth = 0;
            this.inventorInformation.i2PreviousMonthlyInc = 0;

            this.inventorInformation.i2MonthlytOtherInc = 0;
            this.inventorInformation.i2MonthlyOtherIncSrc = '';

            this.saveInventorInvention();
        }

        if (this.universalPayment && frmName == "UniPay") {

            this.universalPayment.inventionId = this.inventionId;
            this.universalPayment.contractSessionId = this.contractSessionId;
            this.universalPayment.chkSaveAc = this.countryID > 2 ? false : this.signDocsGroup.controls.chkSaveAc.value || false;
            this.universalPayment.bankName = this.signDocsGroup.controls.bankName.value || '';
            this.universalPayment.ABANo = this.signDocsGroup.controls.ABANo.value || '';
            this.universalPayment.chkAcNo = this.signDocsGroup.controls.chkAcNo.value || '';
            this.universalPayment.accountType = this.signDocsGroup.controls.accountType.value || -1;
            this.universalPayment.chkCCard = this.countryID > 2 ? true : this.signDocsGroup.controls.chkCCard.value || false;
            this.universalPayment.cCardNo = this.signDocsGroup.controls.cCardNo.value || '';
            this.universalPayment.cCardExpDT = this.signDocsGroup.controls.cCardExpDT.value || '';
            this.universalPayment.cCardCVV = this.signDocsGroup.controls.cCardCVV.value || '';
            this.universalPayment.altDayMonth = this.signDocsGroup.controls.altDayMonth.value || '';
            this.universalPayment.altAmount = this.signDocsGroup.controls.altAmount.value ? this.signDocsGroup.controls.altAmount.value.toString().replace(this.currencySterling, "").replace(",", "") : 0;
            this.universalPayment.cardType = '';
            this.universalPayment.chkNoAutoPay = this.contractSession.CountryID == 2 ? this.signDocsGroup.controls.chkNoAutoPay.value != '' ? true : false : false;

            if (this.universalPayment.chkCCard) {
                this.universalPayment.cardType = this.cc_brand_type(this.universalPayment.cCardNo);
            }

            this.saveUtilityPayment();
        }

        /*Invention CheckList Form*/
        if (this.inventionCheckListResponse.inventionCheckList && frmName == "CheckList") {
            if (this.inventionId > 0)
                this.inventionCheckListResponse.inventionCheckList.inventionId = this.inventionId;
            this.inventionCheckListResponse.inventionCheckList.productId = this.productId;
            this.inventionCheckListResponse.inventionCheckList.contractSessionId = this.contractSessionId;
            this.inventionCheckListResponse.inventionCheckList.clpUserId = this.clpUserId;

            this.signDocsGroup.controls.isSubmitYes.value ? this.inventionCheckListResponse.inventionCheckList.isSubmit = true : this.inventionCheckListResponse.inventionCheckList.isSubmit = false;
            if (this.signDocsGroup.controls.isSubmitNo.value) this.inventionCheckListResponse.inventionCheckList.isSubmit = false;
            this.signDocsGroup.controls.isAcceptYes.value ? this.inventionCheckListResponse.inventionCheckList.isAccept = true : this.inventionCheckListResponse.inventionCheckList.isAccept = false;
            if (this.signDocsGroup.controls.isAcceptNo.value) this.inventionCheckListResponse.inventionCheckList.isAccept = false;
            this.signDocsGroup.controls.isDataBankYes.value ? this.inventionCheckListResponse.inventionCheckList.isDataBank = true : this.inventionCheckListResponse.inventionCheckList.isDataBank = false;
            if (this.signDocsGroup.controls.isDataBankNo.value) this.inventionCheckListResponse.inventionCheckList.isDataBank = false;
            this.signDocsGroup.controls.isSolicitsYes.value ? this.inventionCheckListResponse.inventionCheckList.isSolicits = true : this.inventionCheckListResponse.inventionCheckList.isSolicits = false;
            if (this.signDocsGroup.controls.isSolicitsNo.value) this.inventionCheckListResponse.inventionCheckList.isSolicits = false;
            this.signDocsGroup.controls.isPrepareYes.value ? this.inventionCheckListResponse.inventionCheckList.isPrepare = true : this.inventionCheckListResponse.inventionCheckList.isPrepare = false;
            if (this.signDocsGroup.controls.isPrepareNo.value) this.inventionCheckListResponse.inventionCheckList.isPrepare = false;
            this.signDocsGroup.controls.isStaffYes.value ? this.inventionCheckListResponse.inventionCheckList.isStaff = true : this.inventionCheckListResponse.inventionCheckList.isStaff = false;
            if (this.signDocsGroup.controls.isStaffNo.value) this.inventionCheckListResponse.inventionCheckList.isStaff = false;
            this.signDocsGroup.controls.isBIPSYes.value ? this.inventionCheckListResponse.inventionCheckList.isBIPS = true : this.inventionCheckListResponse.inventionCheckList.isBIPS = false;
            if (this.signDocsGroup.controls.isBIPSNo.value) this.inventionCheckListResponse.inventionCheckList.isBIPS = false;
            this.signDocsGroup.controls.isPRSYes.value ? this.inventionCheckListResponse.inventionCheckList.isPRS = true : this.inventionCheckListResponse.inventionCheckList.isPRS = false;
            if (this.signDocsGroup.controls.isPRSNo.value) this.inventionCheckListResponse.inventionCheckList.isPRS = false;
            this.signDocsGroup.controls.isSoldYes.value ? this.inventionCheckListResponse.inventionCheckList.isSold = true : this.inventionCheckListResponse.inventionCheckList.isSold = false;
            if (this.signDocsGroup.controls.isSoldNo.value) this.inventionCheckListResponse.inventionCheckList.isSold = false;
            this.signDocsGroup.controls.isSendYes.value ? this.inventionCheckListResponse.inventionCheckList.isSend = true : this.inventionCheckListResponse.inventionCheckList.isSend = false;
            if (this.signDocsGroup.controls.isSendNo.value) this.inventionCheckListResponse.inventionCheckList.isSend = false;
            this.signDocsGroup.controls.isIdeasYes.value ? this.inventionCheckListResponse.inventionCheckList.isIdeas = true : this.inventionCheckListResponse.inventionCheckList.isIdeas = false;
            if (this.signDocsGroup.controls.isIdeasNo.value) this.inventionCheckListResponse.inventionCheckList.isIdeas = false;
            this.signDocsGroup.controls.isShowsYes.value ? this.inventionCheckListResponse.inventionCheckList.isShows = true : this.inventionCheckListResponse.inventionCheckList.isShows = false;
            if (this.signDocsGroup.controls.isShowsNo.value) this.inventionCheckListResponse.inventionCheckList.isShows = false;
            this.signDocsGroup.controls.isWorkBrochureYes.value ? this.inventionCheckListResponse.inventionCheckList.isWorkBrochure = true : this.inventionCheckListResponse.inventionCheckList.isWorkBrochure = false;
            if (this.signDocsGroup.controls.isWorkBrochureNo.value) this.inventionCheckListResponse.inventionCheckList.isWorkBrochure = false;
            this.signDocsGroup.controls.isBIPYes.value ? this.inventionCheckListResponse.inventionCheckList.isBIP = true : this.inventionCheckListResponse.inventionCheckList.isBIP = false;
            if (this.signDocsGroup.controls.isBIPNo.value) this.inventionCheckListResponse.inventionCheckList.isBIP = false;
            this.signDocsGroup.controls.isBIPReportYes.value ? this.inventionCheckListResponse.inventionCheckList.isBIPReport = true : this.inventionCheckListResponse.inventionCheckList.isBIPReport = false;
            if (this.signDocsGroup.controls.isBIPReportNo.value) this.inventionCheckListResponse.inventionCheckList.isBIPReport = false;
            if (this.signDocsGroup.controls.isNABIPReport.value) this.inventionCheckListResponse.inventionCheckList.isNABIPReport = true;
            this.signDocsGroup.controls.isServiceFeesYes.value ? this.inventionCheckListResponse.inventionCheckList.isServiceFees = true : this.inventionCheckListResponse.inventionCheckList.isServiceFees = false;
            if (this.signDocsGroup.controls.isServiceFeesNo.value) this.inventionCheckListResponse.inventionCheckList.isServiceFees = false;
            this.signDocsGroup.controls.isADSYes.value ? this.inventionCheckListResponse.inventionCheckList.isADS = true : this.inventionCheckListResponse.inventionCheckList.isADS = false;
            if (this.signDocsGroup.controls.isADSNo.value) this.inventionCheckListResponse.inventionCheckList.isADS = false;
            this.signDocsGroup.controls.isNDAYes.value ? this.inventionCheckListResponse.inventionCheckList.isNDA = true : this.inventionCheckListResponse.inventionCheckList.isNDA = false;
            if (this.signDocsGroup.controls.isNDANo.value) this.inventionCheckListResponse.inventionCheckList.isNDA = false;
            this.signDocsGroup.controls.isPRSBrochureYes.value ? this.inventionCheckListResponse.inventionCheckList.isPRSBrochure = true : this.inventionCheckListResponse.inventionCheckList.isPRSBrochure = false;
            if (this.signDocsGroup.controls.isPRSBrochureNo.value) this.inventionCheckListResponse.inventionCheckList.isPRSBrochure = false;
            this.signDocsGroup.controls.isPPSOYes.value ? this.inventionCheckListResponse.inventionCheckList.isPPSO = true : this.inventionCheckListResponse.inventionCheckList.isPPSO = false;
            if (this.signDocsGroup.controls.isPPSONo.value) this.inventionCheckListResponse.inventionCheckList.isPPSO = false;
            if (this.signDocsGroup.controls.isNAPPSO.value) this.inventionCheckListResponse.inventionCheckList.isNAPPSO = true;
            this.signDocsGroup.controls.comments.value == '' ? this.inventionCheckListResponse.inventionCheckList.comments = '' : this.inventionCheckListResponse.inventionCheckList.comments = this.signDocsGroup.controls.comments.value;
            this.signDocsGroup.controls.bestTimeToReach.value == '' ? this.inventionCheckListResponse.inventionCheckList.bestTimeToReach = '' : this.inventionCheckListResponse.inventionCheckList.bestTimeToReach = this.signDocsGroup.controls.bestTimeToReach.value;

            this.signDocsGroup.controls.isSolicitYes.value ? this.inventionCheckListResponse.inventionCheckList.isSolicitYes = true : this.inventionCheckListResponse.inventionCheckList.isSolicitYes = false;
            this.signDocsGroup.controls.isSolicitNo.value ? this.inventionCheckListResponse.inventionCheckList.isSolicitYes = false : this.inventionCheckListResponse.inventionCheckList.isSolicitYes = true;
            this.signDocsGroup.controls.isRefineYes.value ? this.inventionCheckListResponse.inventionCheckList.isRefineYes = true : this.inventionCheckListResponse.inventionCheckList.isRefineYes = false;
            this.signDocsGroup.controls.isRefineNo.value ? this.inventionCheckListResponse.inventionCheckList.isRefineYes = false : this.inventionCheckListResponse.inventionCheckList.isRefineYes = true;
            this.signDocsGroup.controls.isIndependentYes.value ? this.inventionCheckListResponse.inventionCheckList.isIndependentYes = true : this.inventionCheckListResponse.inventionCheckList.isIndependentYes = false;
            this.signDocsGroup.controls.isIndependentNo.value ? this.inventionCheckListResponse.inventionCheckList.isIndependentYes = false : this.inventionCheckListResponse.inventionCheckList.isIndependentYes = true;
            this.signDocsGroup.controls.isAttorneyYes.value ? this.inventionCheckListResponse.inventionCheckList.isAttorneyYes = true : this.inventionCheckListResponse.inventionCheckList.isAttorneyYes = false;
            this.signDocsGroup.controls.isAttorneyNo.value ? this.inventionCheckListResponse.inventionCheckList.isAttorneyYes = false : this.inventionCheckListResponse.inventionCheckList.isAttorneyYes = true;
            this.signDocsGroup.controls.isPurchasedYes.value ? this.inventionCheckListResponse.inventionCheckList.isPurchasedYes = true : this.inventionCheckListResponse.inventionCheckList.isPurchasedYes = false;
            this.signDocsGroup.controls.isPurchasedNo.value ? this.inventionCheckListResponse.inventionCheckList.isPurchasedYes = false : this.inventionCheckListResponse.inventionCheckList.isPurchasedYes = true;

            this.saveInventionCheckList();
        }

    }

    private async saveInventionCheckList() {
        if (this.inventionCheckListResponse) {
            this.CreateUpdate_InventionCheckList();
        }
    }

    private async saveInventorInvention() {
        this._infoCollectService.InventorInvention_CreateAsync(this.encryptedUser, this.inventorInformationResponse)
            .then(res => {
                if (res) {
                    this.inventorInformationResponse = UtilityService.clone(res);
                    if (this.inventorInformationResponse) {
                        this.inventorInformation = this.inventorInformationResponse.inventorInformation;
                        this.message.divId = 'infoSubmit';
                        this.isCustAction = true;
                        this.formDivActive = 0;
                        this.receiveRespone(24, this.message.finalDocTypeIds);
                        var signedDocId = this.signedDocId;
                        this.updateUserSteps("tdIsInformInventForm");
                        this.updateContractLogObjectModel(signedDocId, false);
                        this.saveContrActionAcitonLog();
                    }
                    else {
                        this.actionDesc = "The Inventor's information wasn't saved. Please try again."
                        this.isCustAction = false;
                    }
                }
            }).catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async CreateUpdate_InventionCheckList() {
        this._inventionCheckListService.InventionCheckList_CreateAsync(this.encryptedUser, this.inventionCheckListResponse)
            .then(res => {
                if (res) {
                    this.inventionCheckListResponse = UtilityService.clone(res);
                    this.actionDesc = "The Invention Checklist was saved.";
                    this.message.divId = 'checkListSubmit';
                    this.isCustAction = true;
                    this.formDivActive = 0;
                    this.loadInventionCheckList();
                    this.updateUserSteps("tdIsCheckListForm");
                    if (this.productId == 9 || this.productId == 10)
                        this.receiveRespone(141, this.message.finalDocTypeIds);
                    else
                        this.receiveRespone(-3, this.message.finalDocTypeIds);
                    this.updateContractLogObjectModel(this.signedDocId, false);
                    this.saveContrActionAcitonLog();
                }
            }).catch((err: HttpErrorResponse) => {
                this.actionDesc = "The Invention Checklist wasn't saved. Please try again."
                this._utilityService.handleErrorResponse(err);
            });
    }

    //For UPC
    checkDecimal(e) {
        let downPayment: string = this.signDocsGroup.controls.downPayment.value;
        if (e.ctrlKey || e.altKey) {
            e.preventDefault();
        }
        else {
            var key = e.keyCode;
            if (key == 46 && downPayment.toString().indexOf('.') > 0) {
                e.preventDefault();
            }
            if (key != 8 && key != 0 && (key != 46 && key > 31) && (key < 48 || key > 57)) {
                e.preventDefault();
            }
        }
    }

    chkSaveAcChange(e) {
        this.hideOptionalDoc = false;
        this.expiry = false;
        if (!e.target.checked) {
            this.divPayCard = true;
            this.divPaySaveAc = false;
            this.divNoAutoPay = false;
            this.signDocsGroup.patchValue({
                chkSaveAc: false,
                chkCCard: true,
                chkNoAutoPay: false,
                cCardNo: "",
                cCardExpDT: "",
                cCardCVV: "",
                bankName: "",
                ABANo: "",
                chkAcNo: "",
                accountType: "-1",
            });
        }
        else {
            this.divPaySaveAc = e.target.checked;
            this.divPayCard = !e.target.checked;
            this.divNoAutoPay = !e.target.checked;
            this.signDocsGroup.patchValue({
                chkSaveAc: e.target.checked,
                chkCCard: !e.target.checked,
                chkNoAutoPay: !e.target.checked,
                cCardNo: "",
                cCardExpDT: "",
                cCardCVV: "",
                bankName: "",
                ABANo: "",
                chkAcNo: "",
                accountType: "-1",
            });
        }
    }

    chkCCardChange(e) {
        this.hideOptionalDoc = false;
        this.expiry = false;
        if (!e.target.checked) {
            this.divPayCard = false;
            this.divPaySaveAc = true;
            this.divNoAutoPay = false;
            this.signDocsGroup.patchValue({
                chkSaveAc: true,
                chkCCard: false,
                chkNoAutoPay: false,
                cCardNo: "",
                cCardExpDT: "",
                cCardCVV: "",
                bankName: "",
                ABANo: "",
                chkAcNo: "",
                accountType: "-1",
            });
        }
        else {
            this.divPaySaveAc = !e.target.checked;
            this.divPayCard = e.target.checked;
            this.divNoAutoPay = !e.target.checked;
            this.signDocsGroup.patchValue({
                chkSaveAc: !e.target.checked,
                chkCCard: e.target.checked,
                chkNoAutoPay: !e.target.checked,
                cCardNo: "",
                cCardExpDT: "",
                cCardCVV: "",
                bankName: "",
                ABANo: "",
                chkAcNo: "",
                accountType: "-1",
            });
        }
    }

    chkNoAutoPayChange(e) {
        this.expiry = false;
        if (!e.target.checked) {
            this.divPayCard = false;
            this.divPaySaveAc = true;
            this.divNoAutoPay = false;
            this.hideOptionalDoc = false;
            this.signDocsGroup.patchValue({
                chkSaveAc: true,
                chkCCard: false,
                chkNoAutoPay: false,
                cCardNo: "",
                cCardExpDT: "",
                cCardCVV: "",
                bankName: "",
                ABANo: "",
                chkAcNo: "",
                accountType: "-1",
            });
        }
        else {
            this.divPaySaveAc = !e.target.checked;
            this.divNoAutoPay = e.target.checked;
            this.divPayCard = !e.target.checked;
            this.hideOptionalDoc = true;
            this.signDocsGroup.patchValue({
                chkSaveAc: !e.target.checked,
                chkCCard: !e.target.checked,
                chkNoAutoPay: e.target.checked,
                cCardNo: "",
                cCardExpDT: "",
                cCardCVV: "",
                bankName: "",
                ABANo: "",
                chkAcNo: "",
                accountType: "-1",
            });
        }
    }

    allowNumeric(e) {
        if (e.ctrlKey || e.altKey) {
            e.preventDefault();
        } else {
            var key = e.keyCode;
            if (key != 8 && key != 0 && (key < 48 || key > 57)) {
                e.preventDefault();
            }
        }
    }

    checkExpiry(divid) {
        var datePipe = new DatePipe("en-US");
        this.expDate = datePipe.transform(new Date(), 'MMyyyy');
        if (divid == 'divUPC') {
            if (this.prodForm.cCardExpDT.value)
                this.cCardExpDTfield = this.prodForm.cCardExpDT.value.substring(0, 2) + this.expDate.substring(2, 4) + this.prodForm.cCardExpDT.value.substring(2, 4);
        }
        else if (divid == 'divCPG') {
            if (this.collectPaymentForm.expirationDate.value)
                this.cCardExpDTfield = this.collectPaymentForm.expirationDate.value.substring(0, 2) + this.expDate.substring(2, 4) + this.collectPaymentForm.expirationDate.value.substring(2, 4);
        }

        if (parseInt(this.cCardExpDTfield.substring(2, 6)) < parseInt(this.expDate.substring(2, 6))) {
            this.openSnackBar("Please check the card's expiration date.", "");
            return this.expiry = true;
        }

        else if (parseInt(this.cCardExpDTfield.substring(2, 6)) == parseInt(this.expDate.substring(2, 6)) && parseInt(this.cCardExpDTfield.substring(0, 2)) < parseInt(this.expDate.substring(0, 2))) {
            this.openSnackBar("Please check the card's expiration date.", "");
            return this.expiry = true;
        }

        else if (parseInt(this.cCardExpDTfield.substring(2, 6)) >= parseInt(this.expDate.substring(2, 6))) {
            return this.expiry = false;
        }

        else if (parseInt(this.cCardExpDTfield.substring(2, 6)) == parseInt(this.expDate.substring(2, 6)) && parseInt(this.cCardExpDTfield.substring(0, 2)) == parseInt(this.expDate.substring(0, 2))) {
            return this.expiry = false;
        }

        else if (parseInt(this.cCardExpDTfield.substring(2, 6)) == parseInt(this.expDate.substring(2, 6)) && parseInt(this.cCardExpDTfield.substring(0, 2)) < parseInt(this.expDate.substring(0, 2))) {
            this.openSnackBar("Please check the card's expiration date.", "");
            return this.expiry = true;
        }
        else
            return this.expiry = false;
    }

    calculatePayment() {
        var altAmount = this.signDocsGroup.controls.altAmount.value;
        altAmount = altAmount ? altAmount.toString().replace(this.currencySterling, "").replace(",", "") : 0;
        this.convertNumberToCurrency(altAmount, 'altAmount');
    }

    convertNumberToCurrency(cashPrice, valueFor) {
        if (cashPrice == 0) {
            return;
        }
        if (cashPrice > 99999) {
            if (valueFor == "altAmount")
                this.openSnackBar("The alternate amount cannot be greater than $99,999.00.", "");
            return;
        }
        cashPrice = Number(cashPrice).toFixed(2);
        cashPrice += '';
        var x = cashPrice.split('.');
        var x1 = x[0];
        var x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }
        var regxCashPrice = x1 + x2;

        if (valueFor == 'altAmount') {
            this.signDocsGroup.patchValue({
                altAmount: '$' + regxCashPrice
            });
        }
    }

    cc_brand_type(cur_val) {
        let jcb_regex = new RegExp('^(?:2131|1800|35)[0-9]{0,}$');
        let amex_regex = new RegExp('^3[47][0-9]{0,}$');
        let diners_regex = new RegExp('^3(?:0[0-59]{1}|[689])[0-9]{0,}$');
        let visa_regex = new RegExp('^4[0-9]{0,}$');
        let mastercard_regex = new RegExp('^(5[1-5]|222[1-9]|22[3-9]|2[3-6]|27[01]|2720)[0-9]{0,}$');
        let maestro_regex = new RegExp('^(5[06789]|6)[0-9]{0,}$');
        let discover_regex = new RegExp('^(6011|65|64[4-9]|62212[6-9]|6221[3-9]|622[2-8]|6229[01]|62292[0-5])[0-9]{0,}$');

        cur_val = cur_val.replace(/\D/g, '');

        var sel_brand = "unknown";
        if (cur_val.match(jcb_regex)) {
            sel_brand = "JCB";
        } else if (cur_val.match(amex_regex)) {
            sel_brand = "AMEX";
        } else if (cur_val.match(diners_regex)) {
            sel_brand = "DINERS_CLUB";
        } else if (cur_val.match(visa_regex)) {
            sel_brand = "VISA";
        } else if (cur_val.match(mastercard_regex)) {
            sel_brand = "MASTERCARD";
        } else if (cur_val.match(discover_regex)) {
            sel_brand = "DISCOVER";
        } else if (cur_val.match(maestro_regex)) {
            if (cur_val[0] == '5') {
                sel_brand = "MASTERCARD";
            } else {
                sel_brand = "MAESTRO";
            }
        }
        return sel_brand;
    }

    infoUniversalPaymentSubmit(stepper): void {
        if (this.signDocsGroup.controls.chkCCard.value && this.prodForm.cCardExpDT.value != "" && !isNullOrUndefined(this.prodForm.cCardExpDT.value))
            this.upcExpiryStatus = this.checkExpiry("divUPC");
        else
            this.upcExpiryStatus = false;
        if (!this.upcExpiryStatus) {
            var repAltAmount = this.signDocsGroup.controls.altAmount.value;
            repAltAmount = repAltAmount ? repAltAmount.toString().replace(this.currencySterling, "").replace(',', "") : 0;
            this.signDocsGroup.patchValue({
                altAmount: repAltAmount,
            });
            this.validateAllFormFields(this.signDocsGroup);
            if (this.signDocsGroup.valid) {
                this.signDocsGroup.markAsPristine();
                this.copyInfoCollectValuesToDataObject("UniPay");
                this.convertNumberToCurrency(this.signDocsGroup.controls.altAmount.value, 'altAmount');
                this.signDocsGroup.controls.cCardNo.setValidators([Validators.minLength(14)]);
            }
        }
    }

    private async saveUtilityPayment() {
        this._infoCollectService.UniversalPayment_CreateAsync(this.encryptedUser, this.universalPaymentResponse)
            .then(res => {
                if (res) {

                    this.universalPaymentResponse = UtilityService.clone(res);
                    if (this.universalPaymentResponse) {
                        this.isCustAction = true;
                        this.formDivActive = 0;
                        this.message.divId = 'upcSubmit';
                        this.receiveRespone(26, this.message.finalDocTypeIds);
                        this.updateUserSteps("tdIsUniPayForm");
                        this.universalPayment = this.universalPaymentResponse.universalPayment;
                        var signedDocId = this.signedDocId;
                        this.updateContractLogObjectModel(signedDocId, false);
                        this.saveContrActionAcitonLog();
                    }
                }
            }).catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
                this.actionDesc = "The Universal Payment Corporation information wasn't saved. Please try again.";
            });
    }

    saveCardPayment() {
        this.isCardPaymentStarted = true;
        this.cardErrorMsg = "";
        if (this.message.cashPrice <= 0) {
            this.cardErrorMsg = "Please inform Sales person to enter Total price of Services in Service section.";
            this.isCardPaymentStarted = false;
        }
        else if (this.message.partialFee <= 0) {
            this.cardErrorMsg = "Please inform Sales person to enter amount and click on Pending button in Payment Collection.";
            this.isCardPaymentStarted = false;
        }
        else {
            this.cardErrorMsg = "";
            this.validateAllFormFields(this.collectPaymentGroup);
            if (this.collectPaymentGroup.valid) {
                this.collectPaymentGroup.markAsPristine();
                this.isSubmitCharge = true;
                this.isPaymentProcessing = true;
                this.sendMessage();
                this.collectPaymentGroup.controls.creditCard.setValidators([Validators.minLength(14)]);
                this.copyPayFormValuesToDataObject();
                this.billingDetails.chkAmount = false;
                this.billingDetails.chkFileNumber = false;
                this.billingDetails.fileNumber = this.message.billingDetails.fileNumber
                this._billingService.payCardPaymentAsync(this.encryptedUser, this.billingDetails)
                    .then(res => {
                        if (res) {
                            this.billingResponse = UtilityService.clone(res);
                            if (this.billingResponse.statusCode == 411) {
                                this.openSnackBar("Card number format is not valid.", "");
                                this.isPaymentDone = false;
                                this.isPaymentProcessing = false;
                                this.isSubmitCharge = false;
                                this.isCardPaymentStarted = false;
                                return;
                            }
                            else {
                                if (this.billingResponse) {
                                    if (this.billingResponse.billingDetails.cardTxnStatus == 1) {
                                        this.cardTxnReference = this.billingResponse.billingDetails.cardTxnReference;
                                        this.cardTxnNotes = this.billingResponse.billingDetails.cardTxnNotes;
                                        this.isPaymentError = false;
                                        this.isPaymentDone = true;
                                        this.isPaymentProcessing = false;
                                        this.isCustAction = true;
                                    }
                                    else {
                                        this.cardTxnReference = this.billingResponse.billingDetails.cardTxnReference;
                                        this.cardTxnNotes = this.billingResponse.billingDetails.cardTxnNotes;
                                        this.isPaymentError = true;
                                        this.isSubmitCharge = false;
                                        this.isPaymentDone = false;
                                        this.isPaymentProcessing = false;
                                    }
                                    this.isCardPaymentStarted = false;
                                    this.sendMessage();
                                }
                            }
                        }
                    }).catch((err: HttpErrorResponse) => {
                        this.isPaymentDone = false;
                        this.isPaymentProcessing = false;
                        this.isSubmitCharge = false;
                        this.isCardPaymentStarted = false;
                        this._utilityService.handleErrorResponse(err);
                    });
                this.collectPaymentGroup.controls.creditCard.setValidators([Validators.required, Validators.minLength(14)]);
            } else {
                this.isPaymentProcessing = false;
                this.isSubmitCharge = false;
                this.isCardPaymentStarted = false;
            }
            this.saveContrActionAcitonLog();
        }
    }

    changeUpperCase(e) {
    }

    allowAlphabets(e) {
        if (e.ctrlKey || e.altKey) {
            e.preventDefault();
        } else {
            var key = e.keyCode;
            if (!((key == 8) || (key == 9) || (key == 32) || (key == 46) || (key >= 35 && key <= 40) || (key >= 65 && key <= 90))) {
                e.preventDefault();
            }
        }
    }

    cc_brand_id(e, divid) {
        var jcb_regex = new RegExp('^(?:2131|1800|35)[0-9]{0,}$');
        var amex_regex = new RegExp('^3[47][0-9]{0,}$'); //34, 37
        var diners_regex = new RegExp('^3(?:0[0-59]{1}|[689])[0-9]{0,}$');
        var visa_regex = new RegExp('^4[0-9]{0,}$'); //4
        var mastercard_regex = new RegExp('^(5[1-5]|222[1-9]|22[3-9]|2[3-6]|27[01]|2720)[0-9]{0,}$');
        var maestro_regex = new RegExp('^(5[06789]|6)[0-9]{0,}$');
        var discover_regex = new RegExp('^(6011|65|64[4-9]|62212[6-9]|6221[3-9]|622[2-8]|6229[01]|62292[0-5])[0-9]{0,}$');

        var cur_val = divid == 'divCPG' ? this.collectPaymentGroup.controls.creditCard.value : divid == 'divUPC' ? this.signDocsGroup.controls.cCardNo.value : '';
        cur_val = cur_val.replace(/\D/g, '');

        var sel_brand = "unknown";
        if (cur_val.match(jcb_regex)) {
            sel_brand = "jcb";
        } else if (cur_val.match(amex_regex)) {
            sel_brand = "amex";
        } else if (cur_val.match(diners_regex)) {
            sel_brand = "diners-club";
        } else if (cur_val.match(visa_regex)) {
            sel_brand = "visa";
        } else if (cur_val.match(mastercard_regex)) {
            sel_brand = "mastercard";
        } else if (cur_val.match(discover_regex)) {
            sel_brand = "discover";
        } else if (cur_val.match(maestro_regex)) {
            if (cur_val[0] == '5') {
                sel_brand = "mastercard";
            } else {
                sel_brand = "stripe";
            }
        }
        if (divid == 'divCPG')
            this.sel_brand = sel_brand;
        else if (divid == 'divUPC')
            this.sel_brandUPC = sel_brand;
    }

    //Check List
    checklistItems(controlName, e) {
        switch (controlName) {
            case "isSubmitYes": this.signDocsGroup.patchValue({ isSubmitYes: !e.target.checked }); this.signDocsGroup.controls.isSubmitYes.value ? this.inventionCheckList.isSubmit = true : this.inventionCheckList.isSubmit = false; break;
            case "isSubmitNo": this.signDocsGroup.patchValue({ isSubmitNo: !e.target.checked }); this.signDocsGroup.controls.isSubmitNo.value ? this.inventionCheckList.isSubmit = false : this.inventionCheckList.isSubmit = true; break;

            case 'isAcceptYes': this.signDocsGroup.patchValue({ isAcceptYes: !e.target.checked }); this.signDocsGroup.controls.isAcceptYes.value ? this.inventionCheckList.isAccept = true : this.inventionCheckList.isAccept = false; break;
            case 'isAcceptNo': this.signDocsGroup.patchValue({ isAcceptNo: !e.target.checked }); this.signDocsGroup.controls.isAcceptNo.value ? this.inventionCheckList.isAccept = false : this.inventionCheckList.isAccept = true; break;

            case 'isDataBankYes': this.signDocsGroup.patchValue({ isDataBankYes: !e.target.checked }); this.signDocsGroup.controls.isDataBankYes.value ? this.inventionCheckList.isDataBank = true : this.inventionCheckList.isDataBank = false; break;
            case 'isDataBankNo': this.signDocsGroup.patchValue({ isDataBankNo: !e.target.checked }); this.signDocsGroup.controls.isDataBankNo.value ? this.inventionCheckList.isDataBank = false : this.inventionCheckList.isDataBank = true; break;

            case 'isSolicitsYes': this.signDocsGroup.patchValue({ isSolicitsYes: !e.target.checked }); this.signDocsGroup.controls.isSolicitsYes.value ? this.inventionCheckList.isSolicits = true : this.inventionCheckList.isSolicits = false; break;
            case 'isSolicitsNo': this.signDocsGroup.patchValue({ isSolicitsNo: !e.target.checked }); this.signDocsGroup.controls.isSolicitsNo.value ? this.inventionCheckList.isSolicits = false : this.inventionCheckList.isSolicits = true; break;

            case 'isPrepareYes': this.signDocsGroup.patchValue({ isPrepareYes: !e.target.checked }); this.signDocsGroup.controls.isPrepareYes.value ? this.inventionCheckList.isPrepare = true : this.inventionCheckList.isPrepare = false; break;
            case 'isPrepareNo': this.signDocsGroup.patchValue({ isPrepareNo: !e.target.checked }); this.signDocsGroup.controls.isPrepareNo.value ? this.inventionCheckList.isPrepare = false : this.inventionCheckList.isPrepare = true; break;

            case 'isStaffYes': this.signDocsGroup.patchValue({ isStaffYes: !e.target.checked }); this.signDocsGroup.controls.isStaffYes.value ? this.inventionCheckList.isStaff = true : this.inventionCheckList.isStaff = false; break;
            case 'isStaffNo': this.signDocsGroup.patchValue({ isStaffNo: !e.target.checked }); this.signDocsGroup.controls.isStaffNo.value ? this.inventionCheckList.isStaff = false : this.inventionCheckList.isStaff = true; break;

            case 'isBIPSYes': this.signDocsGroup.patchValue({ isBIPSYes: !e.target.checked }); this.signDocsGroup.controls.isBIPSYes.value ? this.inventionCheckList.isBIPS = true : this.inventionCheckList.isBIPS = false; break;
            case 'isBIPSNo': this.signDocsGroup.patchValue({ isBIPSNo: !e.target.checked }); this.signDocsGroup.controls.isBIPSNo.value ? this.inventionCheckList.isBIPS = false : this.inventionCheckList.isBIPS = true; break;

            case 'isPRSYes': this.signDocsGroup.patchValue({ isPRSYes: !e.target.checked }); this.signDocsGroup.controls.isPRSYes.value ? this.inventionCheckList.isPRS = true : this.inventionCheckList.isPRS = false; break;
            case 'isPRSNo': this.signDocsGroup.patchValue({ isPRSNo: !e.target.checked }); this.signDocsGroup.controls.isPRSNo.value ? this.inventionCheckList.isPRS = false : this.inventionCheckList.isPRS = true; break;

            case 'isSoldYes': this.signDocsGroup.patchValue({ isSoldYes: !e.target.checked }); this.signDocsGroup.controls.isSoldYes.value ? this.inventionCheckList.isSold = true : this.inventionCheckList.isSold = false; break;
            case 'isSoldNo': this.signDocsGroup.patchValue({ isSoldNo: !e.target.checked }); this.signDocsGroup.controls.isSoldNo.value ? this.inventionCheckList.isSold = false : this.inventionCheckList.isSold = true; break;

            case 'isSendYes': this.signDocsGroup.patchValue({ isSendYes: !e.target.checked }); this.signDocsGroup.controls.isSendYes.value ? this.inventionCheckList.isSend = true : this.inventionCheckList.isSend = false; break;
            case 'isSendNo': this.signDocsGroup.patchValue({ isSendNo: !e.target.checked }); this.signDocsGroup.controls.isSendNo.value ? this.inventionCheckList.isSend = false : this.inventionCheckList.isSend = true; break;

            case 'isIdeasYes': this.signDocsGroup.patchValue({ isIdeasYes: !e.target.checked }); this.signDocsGroup.controls.isIdeasYes.value ? this.inventionCheckList.isIdeas = true : this.inventionCheckList.isIdeas = false; break;
            case 'isIdeasNo': this.signDocsGroup.patchValue({ isIdeasNo: !e.target.checked }); this.signDocsGroup.controls.isIdeasNo.value ? this.inventionCheckList.isIdeas = false : this.inventionCheckList.isIdeas = true; break;

            case 'isShowsYes': this.signDocsGroup.patchValue({ isShowsYes: !e.target.checked }); this.signDocsGroup.controls.isShowsYes.value ? this.inventionCheckList.isShows = true : this.inventionCheckList.isShows = false; break;
            case 'isShowsNo': this.signDocsGroup.patchValue({ isShowsNo: !e.target.checked }); this.signDocsGroup.controls.isShowsNo.value ? this.inventionCheckList.isShows = false : this.inventionCheckList.isShows = true; break;

            case 'isWorkBrochureYes': this.signDocsGroup.patchValue({ isWorkBrochureYes: !e.target.checked }); this.signDocsGroup.controls.isWorkBrochureYes.value ? this.inventionCheckList.isWorkBrochure = true : this.inventionCheckList.isWorkBrochure = false; break;
            case 'isWorkBrochureNo': this.signDocsGroup.patchValue({ isWorkBrochureNo: !e.target.checked }); this.signDocsGroup.controls.isWorkBrochureNo.value ? this.inventionCheckList.isWorkBrochure = false : this.inventionCheckList.isWorkBrochure = true; break;

            case 'isBIPYes': this.signDocsGroup.patchValue({ isBIPYes: !e.target.checked }); this.signDocsGroup.controls.isBIPYes.value ? this.inventionCheckList.isBIP = true : this.inventionCheckList.isBIP = false; break;
            case 'isBIPNo': this.signDocsGroup.patchValue({ isBIPNo: !e.target.checked }); this.signDocsGroup.controls.isBIPNo.value ? this.inventionCheckList.isBIP = false : this.inventionCheckList.isBIP = true; break;

            case 'isBIPReportYes': this.signDocsGroup.patchValue({ isBIPReportYes: true, isBIPReportNo: false, isNABIPReport: false }); if (this.signDocsGroup.controls.isBIPReportYes.value) { this.inventionCheckList.isBIPReport = true; this.inventionCheckList.isNABIPReport = false; } break;
            case 'isBIPReportNo': this.signDocsGroup.patchValue({ isBIPReportNo: true, isBIPReportYes: false, isNABIPReport: false }); if (this.signDocsGroup.controls.isBIPReportNo.value) { this.inventionCheckList.isBIPReport = false; this.inventionCheckList.isNABIPReport = false; } break;
            case 'isNABIPReport': this.signDocsGroup.patchValue({ isNABIPReport: true, isBIPReportYes: false, isBIPReportNo: false }); if (this.signDocsGroup.controls.isNABIPReport.value) { this.inventionCheckList.isNABIPReport = true; } break;

            case 'isServiceFeesYes': this.signDocsGroup.patchValue({ isServiceFeesYes: !e.target.checked }); this.signDocsGroup.controls.isServiceFeesYes.value ? this.inventionCheckList.isServiceFees = true : this.inventionCheckList.isServiceFees = false; break;
            case 'isServiceFeesNo': this.signDocsGroup.patchValue({ isServiceFeesNo: !e.target.checked }); this.signDocsGroup.controls.isServiceFeesNo.value ? this.inventionCheckList.isServiceFees = false : this.inventionCheckList.isServiceFees = true; break;

            case 'isADSYes': this.signDocsGroup.patchValue({ isADSYes: !e.target.checked }); this.signDocsGroup.controls.isADSYes.value ? this.inventionCheckList.isADS = true : this.inventionCheckList.isADS = false; break;
            case 'isADSNo': this.signDocsGroup.patchValue({ isADSNo: !e.target.checked }); this.signDocsGroup.controls.isADSNo.value ? this.inventionCheckList.isADS = false : this.inventionCheckList.isADS = true; break;

            case 'isNDAYes': this.signDocsGroup.patchValue({ isNDAYes: !e.target.checked }); this.signDocsGroup.controls.isNDAYes.value ? this.inventionCheckList.isNDA = true : this.inventionCheckList.isNDA = false; break;
            case 'isNDANo': this.signDocsGroup.patchValue({ isNDANo: !e.target.checked }); this.signDocsGroup.controls.isNDANo.value ? this.inventionCheckList.isNDA = false : this.inventionCheckList.isNDA = true; break;

            case 'isPRSBrochureYes': this.signDocsGroup.patchValue({ isPRSBrochureYes: !e.target.checked }); this.signDocsGroup.controls.isPRSBrochureYes.value ? this.inventionCheckList.isPRSBrochure = true : this.inventionCheckList.isPRSBrochure = false; break;
            case 'isPRSBrochureNo': this.signDocsGroup.patchValue({ isPRSBrochureNo: !e.target.checked }); this.signDocsGroup.controls.isPRSBrochureNo.value ? this.inventionCheckList.isPRSBrochure = false : this.inventionCheckList.isPRSBrochure = true; break;

            case 'isPPSOYes': this.signDocsGroup.patchValue({ isPPSOYes: true, isPPSONo: false, isNAPPSO: false }); if (this.signDocsGroup.controls.isPPSOYes.value) { this.inventionCheckList.isPPSO = true; this.inventionCheckList.isNAPPSO = false; } break;
            case 'isPPSONo': this.signDocsGroup.patchValue({ isPPSONo: true, isPPSOYes: false, isNAPPSO: false }); if (this.signDocsGroup.controls.isPPSONo.value) { this.inventionCheckList.isPPSO = false; this.inventionCheckList.isNAPPSO = false; } break;
            case 'isNAPPSO': this.signDocsGroup.patchValue({ isNAPPSO: true, isPPSOYes: false, isPPSONo: false }); if (this.signDocsGroup.controls.isNAPPSO.value) { this.inventionCheckList.isNAPPSO = true; } break;

            case 'isSolicitYes': this.signDocsGroup.patchValue({ isSolicitYes: !e.target.checked }); break;
            case 'isSolicitNo': this.signDocsGroup.patchValue({ isSolicitNo: !e.target.checked }); break;
            case 'isRefineNo': this.signDocsGroup.patchValue({ isRefineNo: !e.target.checked }); break;
            case 'isRefineYes': this.signDocsGroup.patchValue({ isRefineYes: !e.target.checked }); break;
            case 'isIndependentNo': this.signDocsGroup.patchValue({ isIndependentNo: !e.target.checked }); break;
            case 'isIndependentYes': this.signDocsGroup.patchValue({ isIndependentYes: !e.target.checked }); break;
            case 'isAttorneyNo': this.signDocsGroup.patchValue({ isAttorneyNo: !e.target.checked }); break;
            case 'isAttorneyYes': this.signDocsGroup.patchValue({ isAttorneyYes: !e.target.checked }); break;
            case 'isPurchasedNo': this.signDocsGroup.patchValue({ isPurchasedNo: !e.target.checked }); break;
            case 'isPurchasedYes': this.signDocsGroup.patchValue({ isPurchasedYes: !e.target.checked }); break;

            default:
                break;
        }
        this.isCustAction = false;
        this.sendMessage();
    }

    checkListInput(e) {
        this.inventionCheckList.comments = this.signDocsGroup.controls.comments.value;
        this.inventionCheckList.bestTimeToReach = this.signDocsGroup.controls.bestTimeToReach.value;
        this.sendMessage();
    }

    inventionCheckListSubmit(): void {
        this.checkListStatus = this.checkListValid();
        if (!this.checkListStatus)
            this.openSnackBar("Please select your appropriate choice before submit.", "");
        else
            this.copyInfoCollectValuesToDataObject("CheckList");
    }

    checkListValid(): boolean {
        if (this.productId == 9 || this.productId == 10) {
            if ((this.signDocsGroup.controls.isSolicitYes.value == true || this.signDocsGroup.controls.isSolicitNo.value == true) &&
                (this.signDocsGroup.controls.isRefineYes.value == true || this.signDocsGroup.controls.isRefineNo.value == true) &&
                (this.signDocsGroup.controls.isIndependentYes.value == true || this.signDocsGroup.controls.isIndependentNo.value == true) &&
                (this.signDocsGroup.controls.isAttorneyYes.value == true || this.signDocsGroup.controls.isAttorneyNo.value == true) &&
                (this.signDocsGroup.controls.isPurchasedYes.value == true || this.signDocsGroup.controls.isPurchasedNo.value == true) &&
                (this.signDocsGroup.controls.isWorkBrochureYes.value == true || this.signDocsGroup.controls.isWorkBrochureNo.value == true) &&
                //(this.prodConfigGroup.controls.isBIPYes.value == true || this.prodConfigGroup.controls.isBIPNo.value == true) &&
                //(this.prodConfigGroup.controls.isBIPReportYes.value == true || this.prodConfigGroup.controls.isBIPReportNo.value == true || this.prodConfigGroup.controls.isNABIPReport.value == true) &&
                //(this.prodConfigGroup.controls.isServiceFeesYes.value == true || this.prodConfigGroup.controls.isServiceFeesNo.value == true) &&
                (this.signDocsGroup.controls.isPRSBrochureYes.value == true || this.signDocsGroup.controls.isPRSBrochureNo.value == true) &&
                (this.signDocsGroup.controls.isPPSOYes.value == true || this.signDocsGroup.controls.isPPSONo.value == true)) {
                if (this.contractSession.CountryID > 2)
                    return true;
                else if (this.isNewCanadianContract) {
                    if (this.signDocsGroup.controls.isADSYes.value == true || this.signDocsGroup.controls.isADSNo.value == true)
                        return true;
                    else
                        return false;
                }
                else {
                    if ((this.signDocsGroup.controls.isADSYes.value == true || this.signDocsGroup.controls.isADSNo.value == true) &&
                        (this.signDocsGroup.controls.isNDAYes.value == true || this.signDocsGroup.controls.isNDANo.value == true))
                        return true;
                    else
                        return false;
                }
            }
            else
                return false;
        }
        else {

            if ((this.signDocsGroup.controls.isSubmitYes.value == true || this.signDocsGroup.controls.isSubmitNo.value == true) &&
                (this.signDocsGroup.controls.isAcceptYes.value == true || this.signDocsGroup.controls.isAcceptNo.value == true) &&
                (this.signDocsGroup.controls.isDataBankYes.value == true || this.signDocsGroup.controls.isDataBankNo.value == true) &&
                (this.signDocsGroup.controls.isSolicitsYes.value == true || this.signDocsGroup.controls.isSolicitsNo.value == true) &&
                (this.signDocsGroup.controls.isPrepareYes.value == true || this.signDocsGroup.controls.isPrepareNo.value == true) &&
                (this.signDocsGroup.controls.isStaffYes.value == true || this.signDocsGroup.controls.isStaffNo.value == true) &&
                (this.signDocsGroup.controls.isBIPSYes.value == true || this.signDocsGroup.controls.isBIPSNo.value == true) &&
                (this.signDocsGroup.controls.isPRSYes.value == true || this.signDocsGroup.controls.isPRSNo.value == true) &&
                (this.signDocsGroup.controls.isSoldYes.value == true || this.signDocsGroup.controls.isSoldNo.value == true) &&
                (this.signDocsGroup.controls.isSendYes.value == true || this.signDocsGroup.controls.isSendNo.value == true) &&
                (this.signDocsGroup.controls.isIdeasYes.value == true || this.signDocsGroup.controls.isIdeasNo.value == true) &&
                (this.signDocsGroup.controls.isShowsYes.value == true || this.signDocsGroup.controls.isShowsNo.value == true) &&
                (this.signDocsGroup.controls.isWorkBrochureYes.value == true || this.signDocsGroup.controls.isWorkBrochureNo.value == true) &&
                (this.signDocsGroup.controls.isBIPYes.value == true || this.signDocsGroup.controls.isBIPNo.value == true) &&
                (this.signDocsGroup.controls.isBIPReportYes.value == true || this.signDocsGroup.controls.isBIPReportNo.value == true || this.signDocsGroup.controls.isNABIPReport.value == true) &&
                (this.signDocsGroup.controls.isServiceFeesYes.value == true || this.signDocsGroup.controls.isServiceFeesNo.value == true) &&
                (this.signDocsGroup.controls.isPRSBrochureYes.value == true || this.signDocsGroup.controls.isPRSBrochureNo.value == true) &&
                (this.signDocsGroup.controls.isPPSOYes.value == true || this.signDocsGroup.controls.isPPSONo.value == true || this.signDocsGroup.controls.isNAPPSO.value == true)) {
                if (this.countryID > 2)
                    return true;
                else if (this.isNewCanadianContract) {
                    if (this.signDocsGroup.controls.isADSYes.value == true || this.signDocsGroup.controls.isADSNo.value == true)
                        return true;
                    else
                        return false;
                }
                else {
                    if ((this.signDocsGroup.controls.isADSYes.value == true || this.signDocsGroup.controls.isADSNo.value == true) &&
                        (this.signDocsGroup.controls.isNDAYes.value == true || this.signDocsGroup.controls.isNDANo.value == true))
                        return true;
                    else
                        return false;
                }
            }
            else
                return false;
        }
    }

    initialOnPress(e) {
        if (e.key == "Backspace" || e.key == "Delete") {
            if (this.signDocsGroup.controls.initialSignature.value.length == 0)
                this.signaturePad.on();
            return;
        }
        this.signaturePad.off();
    }

    signatureOnEnd() {
        if (this.signaturePad.isEmpty() == false) {
            this.initialDisabled = true;
        }
    }

    initialOnPressCoInv(e) {
        if (e.key == "Backspace" || e.key == "Delete") {
            if (this.signDocsGroup.controls.initialCoInvSignature.value.length == 0)
                this.signaturePadCoInv.on();
            return;
        }
        this.signaturePadCoInv.off();
    }

    signatureOnEndCoInv() {
        if (this.signaturePadCoInv.isEmpty() == false) {
            this.initialCoInvDisabled = true;
        }
    }

    initialFinalOnPress(e) {
        if (e.key == "Backspace" || e.key == "Delete") {
            if (this.signDocsGroup.controls.initialFinalSignature.value.length == 0)
                this.signaturePadFinal.on();
            return;
        }
        this.signaturePadFinal.off();
    }

    signatureFinalOnEnd() {
        if (this.signaturePadFinal.isEmpty() == false) {
            this.initialFinalDisabled = true;
        }
    }

    initialFinalCoInvOnPress(e) {
        if (e.key == "Backspace" || e.key == "Delete") {
            if (this.signDocsGroup.controls.initialFinalCoInvSignature.value.length == 0)
                this.signaturePadFinalCoInv.on();
            return;
        }
        this.signaturePadFinalCoInv.off();
    }

    signatureFinalCoInvOnEnd() {
        if (this.signaturePadFinalCoInv.isEmpty() == false) {
            this.initialFinalCoInvDisabled = true;
        }
    }

    get hideCardDiv(): boolean {
        if (this.message) {
            if (this.message.connectionStatus == 3)
                this.message.connectionStatus = 1
            if (this.formDivActive != 3 || this.message.connectionStatus != 1)
                return true;
            else
                return false;
        }
        else
            return false;
    }

    changeRoutingNo() {
        this.isRoutingNumberBlank = this.collectPaymentGroup.controls.chkRoutingNo.value.length > 0 ? false : true;
        this.sendMessage();
    }

    changeAccountNo() {
        this.isAccountNumberBlank = this.collectPaymentGroup.controls.chkAccNo.value.length > 0 ? false : true;
        this.sendMessage();
    }

    changeAccountName() {
        this.isBankAccountNameBlank = this.collectPaymentGroup.controls.bankAccountName.value.length > 0 ? false : true;
        this.sendMessage();
    }

    async printReceipt() {
        if (isNullOrUndefined(this.message.billingDetails) || this.message.billingDetails.fileNumber === '' || this.message.billingDetails.fileNumber === '0')
            this.openSnackBar("Please inform Sales person to save the correct File Number.", "");
        else if (this.message.cashPrice <= 0)
            this.openSnackBar("Please inform Sales person to enter Total price of Services in Service section.", "");
        else if (this.message.partialFee <= 0)
            this.openSnackBar("Amount should be greater than Zero.", "");
        else if (this.message.paidMode === 'payCheck' && (this.collectPaymentGroup.controls.chkAccNo.value.trim() == "" ||
            this.collectPaymentGroup.controls.chkRoutingNo.value.trim() == "" || this.collectPaymentGroup.controls.bankAccountName.value.trim() == "")) {
            if (this.collectPaymentGroup.controls.chkAccNo.value.trim() == "")
                this.isAccountNumberBlank = true;
            if (this.collectPaymentGroup.controls.chkRoutingNo.value.trim() == "")
                this.isRoutingNumberBlank = true;
            if (this.collectPaymentGroup.controls.bankAccountName.value.trim() == "")
                this.isBankAccountNameBlank = true;
        }
        else {
            this.isAccountNumberBlank = false;
            this.isRoutingNumberBlank = false;
            this.isBankAccountNameBlank = false;
            this.copyPayFormValuesToDataObject();
            this.billingDetails.fileNumber = this.message.billingDetails.fileNumber
            await this._billingService.payAmountAsync(this.encryptedUser, this.billingDetails)
                .then(res => {
                    if (res) {
                        this.billingResponse = UtilityService.clone(res);
                        if (this.billingResponse) {
                            this.openSnackBar("Payment details have been saved successfully!", "");
                        }
                    }
                }).catch((err: HttpErrorResponse) => {
                    this.isPaymentDone = false;
                    this.isPaymentProcessing = false;
                    this._utilityService.handleErrorResponse(err);
                });
            let contractMultiPayment: ContractMultiPayment = {
                id: this.currentMultiPayId,
                contractSessionId: this.contractSessionId,
                payOption: this.message.paidMode == 'payCheck' ? 3 : this.message.paidMode == 'payOther' ? 5 : 2,
                downPaymentPart: "-1",
                dtCreated: new Date(),
                isChkAmount: this.collectPaymentForm.paymentType.value && this.message.paidMode == 'payCheck' ? this.collectPaymentForm.paymentType.value : false,
                chkBankName: this.collectPaymentForm.chkBankName.value && this.message.paidMode == 'payCheck' ? this.collectPaymentForm.chkBankName.value : '',
                chkCity: this.collectPaymentForm.chkCity.value && this.message.paidMode == 'payCheck' ? this.collectPaymentForm.chkCity.value : '',
                chkState: this.collectPaymentForm.chkState.value && this.message.paidMode == 'payCheck' ? this.collectPaymentForm.chkState.value : '',
                chkRoutingNo: this.collectPaymentForm.chkRoutingNo.value && this.message.paidMode == 'payCheck' ? this.collectPaymentForm.chkRoutingNo.value : '',
                chkAccNo: this.collectPaymentForm.chkAccNo.value && this.message.paidMode == 'payCheck' ? this.collectPaymentForm.chkAccNo.value : '',
                action: '',
                paymentStatus: false,
                isPaid: true,
                isShowSelect: false,
                chkNumber: this.collectPaymentForm.chkNumber.value && this.message.paidMode == 'payCheck' ? this.collectPaymentForm.chkNumber.value : '',
                bankAccountName: '',
                chkDate: '',
                CCNumber: ''
            }
            this.contractMultiPayment = contractMultiPayment;
            await this._billingService.updateContractMultiPaymentAsync(this.encryptedUser, this.contractMultiPayment)
                .then(res => {
                    if (res) {
                        this.contractMultiPayment = UtilityService.clone(res);
                    }
                }).catch((err: HttpErrorResponse) => {
                    this.isPaymentDone = false;
                    this.isPaymentProcessing = false;
                    this._utilityService.handleErrorResponse(err);
                });
            this.isCustAction = true;
            this.sendMessage();
            this.saveContrActionAcitonLog();
        }
    }

    checkPaymentType(event) {
        this.disabledAgreement = !event.target.checked;
        this.sendMessage();
    }

    PaymentshowUpload() {
        this.paymentDocshowUploadFlg = !this.paymentDocshowUploadFlg;
    }

    applyZipValidators(countryId: number) {
        if (countryId == 3)
            this.collectPaymentGroup.controls.zip.clearValidators();
        else
            this.collectPaymentGroup.controls.zip.setValidators([Validators.required, Validators.minLength(5), Validators.pattern(/^[a-zA-Z0-9\s]{5,10}$/)]);
    }
}
var canvasheight = 0;
var canvaswidgth = 0;
function resizeCanvas() {
    var canvas = document.getElementsByTagName("canvas")[0];
    var canvas2 = document.getElementsByTagName("canvas")[1];
    var canvas3 = document.getElementsByTagName("canvas")[2];
    var canvas4 = document.getElementsByTagName("canvas")[3];

    if (canvas) {
        var card = document.getElementsByClassName("signature-pad-card");
        var outer = document.getElementsByClassName("outerSign");
        var outerCoInv = document.getElementsByClassName("outerSignCoInv");
        var outerFinal = document.getElementsByClassName("outerSignFinal");
        var outerFinalCoInv = document.getElementsByClassName("outerSignFinalCoInv");

        canvas.width = outer[0].clientWidth - 50;
        canvas.height = outer[0].clientHeight - 50;
        canvasheight = canvas.height;
        canvaswidgth = canvas.width;
        if (canvas2) {
            canvas2.width = outerCoInv[0].clientWidth - 50;
            canvas2.height = outerCoInv[0].clientHeight - 50;
            canvasheight = canvas2.height;
            canvaswidgth = canvas2.width;

        }

        if (canvas3) {
            canvas3.width = outerFinal[0].clientWidth - 50;
            canvas3.height = outerFinal[0].clientHeight - 50;
            canvasheight = canvas3.height;
            canvaswidgth = canvas3.width;
        }

        if (canvas4) {
            canvas4.width = outerFinalCoInv[0].clientWidth - 50;
            canvas4.height = outerFinalCoInv[0].clientHeight - 50;
            canvasheight = canvas4.height;
            canvaswidgth = canvas4.width;
        }
    }
}

